/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps, eqeqeq, jsx-a11y/alt-text, array-callback-return */
import React, { useState, useEffect, useRef, createRef } from "react";
import styles from "./style.module.scss";
import {
  notification,
  Button,
  Spin,
  Input,
  Menu,
  Dropdown,
  Tooltip,
  Table,
} from "antd";
import {
  CloseOutlined,
  DownOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import DashboardHeader from "components/Dashboard/Header";
import DashboardPageChrome from "components/Dashboard/DashboardPageChrome";
import { UNLOGGED } from "util/constants";
import { apiRequest, uploadFileToS3 } from "util/services";
import { fetchAiInsightsQuota } from "util/aiInsightsQuota";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/Dashboard/actions.js";
import BoardCard, { AppRatingCard } from "components/Dashboard/BoardCard";
import LineChartWrapper from "components/Dashboard/LineChartWrapper";
import GaugeChart from "react-gauge-chart";
import ReviewsList from "components/Dashboard/ReviewsList";
import CreateTaskTrelloModal from "components/Dashboard/TaskModalTrello";
import CreateTaskClickupModal from "components/Dashboard/TaskModalClickup";
import CreateTaskJiraModal from "components/Dashboard/TaskModelJira";
import CustomInput from "components/General/CustomInput";
import HotTerms from "components/Dashboard/HotTerms";
import { Modal, Modal as Modal1 } from "components/General/ModalFormComponents";
import NestedTabs from "components/NestedTabs";
import { useTranslation, Trans } from "react-i18next";
import {
  resolveApiErrorMessage,
  resolveBoardFailureMsg,
} from "util/apiErrorMessage";
import { isAbortedResult } from "util/apiAvailability";
import { searchFiltersSignature } from "util/searchFiltersSignature";
import {
  closeReviewRangeNotice,
  isReviewRangeTooLarge,
  notifyReviewRangeTooLarge,
  notifyWidgetError,
} from "util/reviewRangeLimit";
import { getIntlLocale } from "util/locale";
import TopTopics from "components/Dashboard/TopTopics";
import FileTypePopup from "helperComponents/FileTypePopup";
import {
  trackDashboardOpenedOnce,
  trackReviewExported,
} from "util/productAnalytics";
import { useEngagementQueryFilterTracking } from "util/useEngagementQueryFilterTracking";
import BarChartWrapper from "components/Dashboard/BarChartWrapper";
import DataSelectionPopup from "components/General/DataSelectionPopup";
import PivotTwoPaneFilter from "helperComponents/PivotTwoPaneFilter";
import { InfoCircleOutlined } from "@ant-design/icons";
import SingleSelect from "helperComponents/SingleSelect";
import DashboardAIInsightsModal from "components/Dashboard/DashboardAIInsightsModal";
import CustomChart from "components/Charts";
import zoomPlugin from "chartjs-plugin-zoom";
import { Chart } from "chart.js";
import DateFilterTwoPickers from "components/Dashboard/DateFilterTwoPickers";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { DASHBOARD_INTENT_COLORS } from "../../constants/dashboardIntentColors";
Chart.register(zoomPlugin);

const DashboardData = ({ match, shared, authenticated, user }) => {
  let timerating = true;
  const DashboardReducer = useSelector((state) => state.DashboardReducer);
  const [allData, setAllData] = useState({});
  const [reviewsLoaded, setReviewsLoaded] = useState(false);
  const [highlights, setHighlights] = useState(null);
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  if (!match.params.id && !DashboardReducer.dashboard) {
    history.push("/home");
    //history.push("/console/myDashboards");
  }

  let initialState = {
    currentDashboard: match.params.id || DashboardReducer.dashboard?.ID,
    restaurant: "All",
  };
  const [localState, setState] = useState(initialState);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [numReviews, setNumReviews] = useState();
  const [timeInterval, setTimeInterval] = useState(null);
  const [searchWord, setSearchWord] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const [createTaskModal, setCreateTaskModal] = useState(false);
  const [showAIInsightsModal, setShowAIInsightsModal] = useState(false);
  const [aiInsightsQuota, setAiInsightsQuota] = useState(null);
  const [aiInsightsQuotaLoading, setAiInsightsQuotaLoading] = useState(false);
  const [aiInsightsQuotaError, setAiInsightsQuotaError] = useState(false);
  const [insightTxt, setInsightTxt] = useState("");
  const [insightTitleTxt, setinsightTitleTxt] = useState("");
  const [startIndex, setStartIndex] = useState(0);
  const [Time_Daily_Rating, setTime_Daily_Rating] = useState(null);
  const [switchPeriod, setSwitchPeriod] = useState(false);
  const [usefulData, setUsefulData] = useState(0);
  const [rawData, setrawData] = useState(0);
  const [overalUsefulData, setOveralUsefulData] = useState(0);
  const [overalRawData, setOveralRawData] = useState(0);
  const [avgRating, setAvgRating] = useState(0);
  const [overalAvgRating, setOveralAvgRating] = useState(0);
  const [overalNps, setOveralNps] = useState(0);
  const [npScore, setnpScore] = useState(0);

  const [changeDateRange, setChangeDateRange] = useState(false);

  const [disableDateRange, setDisableDateRange] = useState([true, true]);

  const [participationPeriod, setParticipationPeriod] = useState(null);
  const [sentimentPeriod, setSentimentPeriod] = useState(null);
  const [ratingsPeriod, setratingsPeriod] = useState(null);
  const [participationPeriodLoading, setParticipationPeriodLoading] = useState(
    true
  );
  const [ratingPeriodLoading, setratingPeriodLoading] = useState(true);
  const [sentimentPeriodLoading, setSentimentPeriodLoading] = useState(true);
  const [volumeDaily, setVolumeDaily] = useState([]);
  const [sentimentDaily, setSentimentDaily] = useState([]);

  const [restaurantDoughnutData, setRestaurantDoughnutData] = useState([]);
  const [
    isRestaurantDoughnutDataLoading,
    setIsRestaurantDoughnutDataLoading,
  ] = useState(true);
  const [intentDoughnutData, setIntentDoughnutData] = useState([]);
  const [
    isIntentDoughnutDataLoading,
    setIsIntentDoughnutDataLoading,
  ] = useState(true);
  const [ratingDoughnutData, setRatingDoughnutData] = useState([]);
  const [
    isRatingDoughnutDataLoading,
    setIsRatingDoughnutDataLoading,
  ] = useState(true);
  const [sentimentDoughnutData, setSentimentDoughnutData] = useState([]);
  const [
    isSentimentDoughnutDataLoading,
    setIsSentimentDoughnutDataLoading,
  ] = useState(true);
  const [avgSentiment, setAvgSentiment] = useState(0);
  const [
    isAvgSentimentGaugeDataLoading,
    setIsAvgSentimentGaugeDataLoading,
  ] = useState(true);
  // const [facebookReplies, setFacebookReplies] = useState([]);
  const searchControllerRef = useRef();
  // Widget requests (search, top topics, hot terms, ratings, KDA, decisions)
  // for the current filters. Each new search aborts the previous set so slow
  // requests don't pile up while the user keeps changing filters.
  const widgetsControllerRef = useRef();
  const userReducer = useSelector((state) => state.userReducer);

  const [platformData, setPlatformData] = useState({});
  const [
    isPlatformDoughnutDataLoading,
    setIsPlatformDoughnutDataLoading,
  ] = useState(true);
  // const [subscriptionStatus, setSubscriptionStatus] = useState();
  const [numOfDocs, setNumOfDocs] = useState(10);
  const [pivotOptions, setPivotOptions] = useState(null);
  const [multiLevelOptions, setMultiLevelOptions] = useState(null);
  const [selectedPivots, setSelectedPivots] = useState({});
  const [filters, setFilters] = useState([]);
  const [topTopics, setTopTopics] = useState([]);
  const [hottermsData, setHottermsData] = useState({});
  const [hottermsLoading, setHottermsLoading] = useState(false);
  const [selectedTopTopics, setSelectedTopTopics] = useState([]);
  const [topTopicsLoading, setTopTopicsLoading] = useState(true);
  const [npsInfo, setNpsInfo] = useState(null);
  const [showFileTypePopup, setShowFileTypePopup] = useState(false);
  const [fileType, setFileType] = useState("csv");
  const [onlySequences, setOnlySequences] = useState(false);
  const [downloadDataLoading, setDownloadDataLoading] = useState(false);
  const [overLimitForHotterms, setOverLimitForHotterms] = useState(false);
  const downloadBtnRef = useRef();
  const { t, i18n } = useTranslation();
  const [topicRatingData, setTopicRatingData] = useState(null);
  const [topicSentimentData, setTopicSentimentData] = useState(null);
  const [topicRatingsLoading, setTopicRatingsLoading] = useState(true);
  const skipFirstLoadAPICall = useRef(true);
  const [checkedTopicIds, setCheckedTopicIds] = useState([]);
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const [createInsightLoading, setCreateInsightLoading] = useState(false);
  const [queryFilters, setQueryFilters] = useState({});
  // Tracks the last serialized queryFilters to skip spurious setQueryFilters
  // calls caused by cursor-only URL changes (cursor params are excluded from
  // queryObj, so the serialized content is unchanged; skipping prevents the
  // queryFilters effect from re-running getSearchResults and blanking the page).
  const prevQueryFiltersStr = useRef(null);
  useEngagementQueryFilterTracking(
    queryFilters,
    localState?.currentDashboard || DashboardReducer.dashboard?.ID,
    "dashboard_data",
  );
  const { search } = useLocation();
  const params = new URLSearchParams(window.location.search);
  // On a share page the route holds the share hash; the numeric id is known once
  // share/deserialize answers. Callbacks created before that (the first data load
  // among them) read it here, or that load stopped at a NaN id and spun forever.
  const sharedDashboardIdRef = useRef(null);
  const resolveDashboardId = () => {
    const reducerId = DashboardReducer.dashboard?.ID;
    if (reducerId != null && reducerId !== "") {
      const parsed = parseInt(reducerId, 10);
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }
    if (sharedDashboardIdRef.current != null) {
      return sharedDashboardIdRef.current;
    }
    const routeId = localState.currentDashboard ?? match.params.id;
    if (routeId != null && routeId !== "") {
      const parsed = parseInt(routeId, 10);
      if (Number.isFinite(parsed)) {
        return parsed;
      }
    }
    return null;
  };
  const [showPopupSequence, setShowPopupSequence] = useState(false);
  const [selectedOutcomeMetric, setSelectedOutcomeMetric] = useState(1);
  const [selectedCustomTopics, setSelectedCustomTopics] = useState([]);
  const [selectedPivotColumns, setSelectedPivotColumns] = useState([]);
  const [showDriverPopup, setShowDriverPopup] = useState(null);
  const [emptyDriverAnalysis, setEmptyDriverAnalysis] = useState(true);
  const [outcomeMetrics, setOutcomeMetrics] = useState([]);
  const [potentialDrivers, setPotentialDrivers] = useState([]);
  const [driverAnalysisData, setDriverAnalysisData] = useState([]);
  const [driverAnalysisLoading, setDriverAnalysisLoading] = useState(true);
  const [tableDataLoading, setTableDataLoading] = useState(false);
  const [noDataForSelectedConfig, setNoDataForSelectedConfig] = useState(false);
  const [levelWisePivotSelections, setLevelWisePivotSelections] = useState({});
  const [zoomPlugin, setZoomPlugin] = useState({});
  const bubbleChart = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(0);
  const [kdaScaleValues, setKDAScaleValues] = useState({});
  const [KDABubbleData, setKDABubbleData] = useState(null);
  const [selectedTopicFromBars, setSelectedTopicFromBars] = useState({});
  const [actualDistributionData, setActualDistributionData] = useState({});
  const [selectedPivotsOperator, setSelectedPivotsOperator] = useState("AND");
  const [showAdditionalSearchPopup, setShowAdditionalSearchPopup] = useState(
    false
  );
  const [npsScale, setNpsScale] = useState([1, 10]);
  const [showSavedSearchPopup, setShowSavedSearchPopup] = useState(false);
  const [savedSearchTitle, setSavedSearchTitle] = useState("");
  const [savedSearchSentiment, setSavedSearchSentiment] = useState(null);
  const [savedSearchIntent, setSavedSearchIntent] = useState(null);
  const [
    savedSearchSelectedTopicIds,
    setSavedSearchSelectedTopicIds,
  ] = useState([]);
  const [savedSearchCheckedTopicIds, setSavedSearchCheckedTopicIds] = useState(
    []
  );
  const [
    savedSearchLevelWisePivotSelections,
    setSavedSearchLevelWisePivotSelections,
  ] = useState({});
  const [savedSearchSelectedPivots, setSavedSearchSelectedPivots] = useState(
    {}
  );
  const [savedSearchPivotsOperator, setSavedSearchPivotsOperator] = useState(
    "AND"
  );
  const [savedSearchShowDateFilter, setSavedSearchShowDateFilter] = useState(
    false
  );
  const [savedSearchDateRange, setSavedSearchDateRange] = useState([]);
  const [savedSearchDaysRange, setSavedSearchDaysRange] = useState("allTime");
  const [showRangePicker, setShowRangePicker] = useState(true);
  const [createSavedSearchLoading, setCreateSavedSearchLoading] = useState(
    false
  );
  const [savedSearchRating, setSavedSearchRating] = useState(null);
  const [savedSearchPlatform, setSavedSearchPlatform] = useState(null);
  const [savedSearchPublish, setSavedSearchPublish] = useState(null);
  const [savedSearchOpenCase, setSavedSearchOpenCase] = useState(null);
  const [savedSearchAction, setSavedSearchAction] = useState(null);
  const [savedSearchTopicsOperator, setSavedSearchTopicsOperator] = useState(
    "AND"
  );
  const [
    savedSearchPivotFiltersApplied,
    setSavedSearchPivotFiltersApplied,
  ] = useState(false);
  const [savedSearchShowTopTopics, setSavedSearchShowTopTopics] = useState(
    false
  );
  const [savedSearchTags, setSavedSearchTags] = useState([]);
  const [savedSearchTextWord, setSavedSearchTextWord] = useState("");
  const [savedSearchTopTopicsFilter, setSavedSearchTopTopicsFilter] = useState(
    []
  );
  const [savedSearchChildOthers, setSavedSearchChildOthers] = useState([]);
  const [savedSearchParentOthers, setSavedSearchParentOthers] = useState([]);
  const [savedSearchPivotsApplied, setSavedSearchPivotsApplied] = useState(
    false
  );
  const [chartDataDownloadProgress, setChartDataDownloadProgress] = useState(0);
  const [
    downloadSentimentChartsDataLoading,
    setDownloadSentimentChartsDataLoading,
  ] = useState(false);
  const [
    downloadRatingChartsDataLoading,
    setDownloadRatingChartsDataLoading,
  ] = useState(false);
  const [dateBasedChartsPeriod, setDateBasedChartsPeriod] = useState("daily");
  const runOnlyOneRef = useRef(true);
  // Filters the latest full search started with (see searchFiltersSignature),
  // and whether the queryFilters effect skipped a change because a search was
  // still loading. Bumping filterReplayTick makes that effect run again.
  const lastSearchFiltersRef = useRef();
  const skippedFilterChangeRef = useRef(false);
  const [filterReplayTick, setFilterReplayTick] = useState(0);
  const restaurantRef = useRef({});
  useEffect(
    () => () => {
      if (widgetsControllerRef.current) widgetsControllerRef.current.abort();
      closeReviewRangeNotice();
    },
    []
  );
  const [showNormalizedData, setShowNormalizedData] = useState(true);
  const [ratingBreakdown, setRatingBreakdown] = useState({});
  useEffect(() => {
    const handleResize = () => {
      setNpsScale((prev) => {
        return [prev[0], prev[1]];
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
  const [decisionData, setDecisionData] = useState([]);
  const [decisionDataLoading, setDecisionDataLoading] = useState(false);
  const [selectedDecisions, setSelectedDecisions] = useState({});
  const [cursors, setCursors] = useState({});
  const [cursorNext, setCursorNext] = useState("");
  const [backWardCursors, setBackwardCursors] = useState({ "-1": null });
  const handleClearAllTopTopics = () => {
    let items = document.getElementsByClassName("check-box-topic-for-filter");
    if (items?.length > 0) {
      for (let i = 0; i < items?.length; i++) {
        items[i].checked = false;
        items[i].indeterminate = false;
      }
    }
    setSelectedTopicIds([]);
    setCheckedTopicIds([]);
    setSavedSearchCheckedTopicIds([]);
    setSavedSearchSelectedTopicIds([]);
  };
  const [savedSearch, setSavedSearch] = useState(params.has("savedSearchID"));
  const [hideEmptyReviews, setHideEmptyReviews] = useState(true);
  const isInitialRender = useRef(true);
  const [resetReviewsPage, setResetReviewsPage] = useState(false);
  const [selectedReviewIDs, setSelectedReviewIds] = useState([]);
  const [tweetsCheckList, setTweetsCheckList] = useState({});
  const [usersCheckList, setUsersCheckList] = useState({});
  const [isStatic, setIsStatic] = useState(false);

  useEffect(() => {
    if (params.has("isStatic")) {
      if (params.get("isStatic") == "false") {
        setIsStatic(false);
      } else {
        setIsStatic(true);
      }
    }
  }, [history, window.location]);
  useEffect(() => {
    if (params.has("savedSearchID")) {
      setSavedSearch(params.has("savedSearchID"));
    }
  }, [history, window.location]);
  useEffect(() => {
    if (params) {
      const values = Array.from(params);
      const queryObj = values.reduce((acc, [key, val]) => {
        // Exclude pagination cursor params: cursor URL changes (from getOnlyReviews
        // updating cursor_next after each page fetch) must NOT trigger a full search
        // re-run via the queryFilters effect — that would create an infinite loop.
        if (
          key === "cursor_next" ||
          key === "cursor_curr" ||
          key === "cursor_before"
        ) {
          return acc;
        }
        if (
          key === "keyword" ||
          key === "pivotFilter" ||
          key === "top_topics" ||
          key === "level1Selection" ||
          key === "level2Selection" ||
          key === "decisionFilter" ||
          key === "child_others" ||
          key === "parent_others" ||
          key === "hotterm"
        ) {
          acc[key] = JSON.parse(val);
        } else {
          acc[key] = val;
        }
        return acc;
      }, {});
      // Only update queryFilters when non-cursor content actually changed.
      // Cursor writes (cursor_next, cursor_before) are excluded from queryObj
      // above, so without this guard a cursor write would produce a new object
      // reference with identical content, trigger the queryFilters effect, and
      // call getSearchResults(reset=true) — blanking the page mid-load.
      const serialized = JSON.stringify(
        Object.keys(queryObj).sort().reduce((r, k) => { r[k] = queryObj[k]; return r; }, {})
      );
      if (serialized !== prevQueryFiltersStr.current) {
        prevQueryFiltersStr.current = serialized;
        setQueryFilters(queryObj);
      }
    }
  }, [history, search]);

  const updateQParams = (attr, val) => {
    if (val === null || val === undefined || val === "null" || val === "undefined") {
      if (!params.has(attr)) {
        return;
      }
      params.delete(attr);
      history.push({ search: params.toString() });
      return;
    }
    const nextVal = String(val);
    if (params.get(attr) === nextVal) {
      return;
    }
    params.delete(attr);
    params.append(attr, nextVal);
    history.push({ search: params.toString() });
  };

  useEffect(() => {
    // getSubscribtionStatus();
    if (authenticated === UNLOGGED && !shared) {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (reviewsLoading === false) {
      //enable date filtering
      setDisableDateRange([false, false]);
    } else {
      setDisableDateRange([true, true]);
    }
  }, [reviewsLoading]);
  useEffect(() => {
    setAllData({
      VolumeDaily: volumeDaily,
      SentimentDaily: sentimentDaily,
      RatingsDaily: Time_Daily_Rating,
    });
  }, [volumeDaily, sentimentDaily, Time_Daily_Rating]);
  useEffect(() => {
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: true,
      },
    });
    if (authenticated === UNLOGGED && !shared) {
      document.location.href = document.location.origin;
      return;
    }
    if (!localState.currentDashboard) {
      notification.error({
        message: t("notifications.42"),
      });
      history.push("/home");
      //history.push("/console/myDashboards");
      return;
    }
    const getDashboardID = async () => {
      const payload = {
        hashed: localState.currentDashboard,
      };
      const result = await apiRequest(
        "dashboards/share/deserialize",
        "POST",
        payload
      );
      if (result) {
        const sharedId = parseInt(result.dashboard_id, 10);
        sharedDashboardIdRef.current = Number.isFinite(sharedId) ? sharedId : null;
        setState({ ...localState, currentDashboard: result.dashboard_id });
        checkDashboardStatus(result.dashboard_id);
      } else {
        notification.error({
          message: t("notifications.43"),
        });
        document.location.href = document.location.origin;
        return;
      }
    };
    if (shared) getDashboardID();
    else checkDashboardStatus(localState.currentDashboard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Not an `a || b || ...` chain: rules-of-hooks reads that as a branch and
  // flags every hook below it as conditional.
  const searchLoading = [
    topTopicsLoading,
    topicRatingsLoading,
    isRestaurantDoughnutDataLoading,
    hottermsLoading,
    reviewsLoading,
  ].some(Boolean);
  useEffect(() => {
    if (searchLoading) {
      skippedFilterChangeRef.current = true;
      return;
    }
    if (DashboardReducer.dashboard && !reviewsLoading) {
      if (runOnlyOneRef.current) {
        setSelectedReviewIds([]);
        setTweetsCheckList({});
        setUsersCheckList({});
        updateQParams("cursor_curr", null);
        updateQParams("start_index", 0);
        getSearchResults(false, 0, true);
        runOnlyOneRef.current = false;
        setTopTopicsLoading(true);
        setParticipationPeriodLoading(true);
        setSentimentPeriodLoading(true);
        setratingPeriodLoading(true);
        setIsAvgSentimentGaugeDataLoading(true);
        setIsPlatformDoughnutDataLoading(true);
        setIsIntentDoughnutDataLoading(true);
        setIsRatingDoughnutDataLoading(true);
        setIsSentimentDoughnutDataLoading(true);
        setDriverAnalysisLoading(true);
        if ([33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId)) {
          setDecisionDataLoading(true);
        }
        return;
      }
      //Reseting the after filters are change
      setSelectedReviewIds([]);
      setTweetsCheckList({});
      setUsersCheckList({});
      updateQParams("cursor_curr", null);
      updateQParams("start_index", 0);
      setTopTopicsLoading(true);
      getSearchResults(false, 0, true);
      setParticipationPeriodLoading(true);
      setSentimentPeriodLoading(true);
      setratingPeriodLoading(true);
      setIsAvgSentimentGaugeDataLoading(true);
      setIsPlatformDoughnutDataLoading(true);
      setIsIntentDoughnutDataLoading(true);
      setIsRatingDoughnutDataLoading(true);
      setIsSentimentDoughnutDataLoading(true);
      setDriverAnalysisLoading(true);
      if ([33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId)) {
        setDecisionDataLoading(true);
      }
    }
  }, [queryFilters, resetReviewsPage, filterReplayTick]); // Here if the reviews are deleted everthing refreshes
  // The effect above skips filter changes made while a search is loading so
  // requests don't pile up. Once that search settles, run once more if the
  // URL's filters have moved on since it started; otherwise the page would
  // keep showing results for the old filters.
  useEffect(() => {
    if (searchLoading || !skippedFilterChangeRef.current) return;
    skippedFilterChangeRef.current = false;
    if (lastSearchFiltersRef.current === undefined) return;
    if (
      searchFiltersSignature(window.location.search) ===
      lastSearchFiltersRef.current
    ) {
      return;
    }
    setFilterReplayTick((tick) => tick + 1);
  }, [searchLoading]);
  useEffect(() => {
    if (skipFirstLoadAPICall.current) {
      skipFirstLoadAPICall.current = false;
      return;
    } else {
      updateQParams("start_index", 0);
      updateQParams("cursor_curr", null);
      getOnlyReviews(false, 0, true);
    }
  }, [numOfDocs]);
  useEffect(() => {
    if (DashboardReducer?.dashboard?.ID && volumeDaily.length > 0) {
      console.log(`get search results on switch period change`);
      getSearchResults(false, 1);
    }
  }, [switchPeriod]);
  useEffect(() => {
    if (!switchPeriod) {
      if (params.get("since") && params.get("until")) {
        const since = params.get("since");
        const until = params.get("until");
        const sinceDate = dayjs(since);
        const untilDate = dayjs(until);
        const noOfDays =
          since === until ||
          (untilDate.diff(sinceDate, "day") === 1 && since !== until)
            ? untilDate.diff(sinceDate, "day")
            : untilDate.diff(sinceDate, "day") + 1;
        const period =
          noOfDays < 30 ? "daily" : noOfDays < 366 ? "monthly" : "yearly";
        // Force monthly if span >= 90 days (3 months)
        const finalPeriod = noOfDays >= 90 ? "monthly" : period;
        setDateBasedChartsPeriod(finalPeriod);
      } else {
        setDateBasedChartsPeriod("monthly");
      }
    }
  }, [history, search]);
  useEffect(() => {
    if (!params.has("start_index")) {
      updateQParams("start_index", 0);
    }
    if (!params.has("page_offset")) {
      updateQParams("page_offset", 10);
    } else {
      const pageOffset = parseInt(params.get("page_offset"), 10);
      if (Number.isFinite(pageOffset) && pageOffset > 0) {
        setNumOfDocs(pageOffset);
      }
    }
    // Strip any stale cursor params that may be present in a bookmarked URL.
    // getOnlyReviews handles this too (reset=true path), but doing it here
    // on mount avoids the extra history.push inside getOnlyReviews which would
    // otherwise re-trigger the [history, search] effect and create unnecessary
    // queryFilters churn before the first data load.
    const cursorKeys = ["cursor_next", "cursor_curr", "cursor_before"];
    const hasStaleCursors = cursorKeys.some((k) => params.has(k));
    if (hasStaleCursors) {
      cursorKeys.forEach((k) => params.delete(k));
      history.replace({ search: params.toString() });
    }
  }, []);

  const checkDashboardStatus = async (DashboardId) => {
    const result = await apiRequest(
      "dashboards/v2/get",
      "POST",
      {
        dashboard_id: parseInt(DashboardId, 10),
      },
      true
    );

    if (result.cancel || result.error) {
      setTopTopicsLoading(false);
      setParticipationPeriodLoading(false);
      setSentimentPeriodLoading(false);
      setratingPeriodLoading(false);
      setIsAvgSentimentGaugeDataLoading(false);
      setIsPlatformDoughnutDataLoading(false);
      setIsIntentDoughnutDataLoading(false);
      setIsRatingDoughnutDataLoading(false);
      setIsSentimentDoughnutDataLoading(false);
      setReviewsLoading(false);
      setIsRestaurantDoughnutDataLoading(false);
      setTopicRatingsLoading(false);
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.dashboard_status"),
      });
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          loading: false,
        },
      });
      dispatch({
        type: actions.SET_Dashboard,
        payload: {
          failureMsg: resolveBoardFailureMsg(result, t),
        },
      });
    } else if (result.status.ID === -1 || result.status.ID === 5) {
      notification.info({
        message: t("notifications.44"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
      history.push(`/home`);
      // history.push("/console/myDashboards");
    } else if (
      result.status.ID !== 4 &&
      result.status.ID !== 6 &&
      result.status.ID !== 7 &&
      !result?.dashboard?.IsDynamic
    ) {
      notification.info({
        message: t("notifications.45"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
      history.push(`/console/journey/${initialState.currentDashboard}`);
    } else {
      if (
        DashboardReducer.insightBasedSearch &&
        location?.state?.searchInsight
      ) {
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            ...DashboardReducer.insightBasedSearch,
            selectedDaysRange: DashboardReducer?.insightBasedSearch
              ?.selectedDaysRange
              ? DashboardReducer.insightBasedSearch.selectedDaysRange
              : "custom",
          },
        });
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            showNewReviewsLabel: true,
          },
        });
      }
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          ...result,
          loading: true,
        },
      });
      if (
        !params.has("since") &&
        !params.has("until") &&
        params.get("daysRange") !== "allTime"
      ) {
        if (!result.dashboard_start_date && !result.dashboard_end_date) {
          updateQParams("daysRange", "allTime");
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              ...result,
              selectedDaysRange: "allTime",
              dateRange: [],
            },
          });
        } else {
          // Create a dateRange array for default_period with the end_date
          let cd = new Date(
            DashboardReducer.dashboard?.RefreshRate
              ? new Date()
              : result.dashboard_end_date
          );
          let pd = new Date(
            DashboardReducer.dashboard?.RefreshRate
              ? new Date()
              : result.dashboard_end_date
          );
          let noOfDaysToLoadByDefault = result.isLight ? 90 : 1;
          cd.setDate(cd.getDate());
          pd.setDate(pd.getDate());
          pd.setDate(pd.getDate() - noOfDaysToLoadByDefault);
          const formattedCurrentDate = cd.toISOString().split("T")[0];
          const formattedPastDate = pd.toISOString().split("T")[0];
          const sinceAlreadyExists = params.get("since") === formattedPastDate;
          const untilAlreadyExists =
            params.get("until") === formattedCurrentDate;
          if (sinceAlreadyExists && formattedPastDate) {
            updateQParams("since", formattedPastDate);
          } else if (!sinceAlreadyExists && formattedPastDate) {
            updateQParams("since", formattedPastDate);
          }
          if (untilAlreadyExists && formattedCurrentDate) {
            updateQParams("until", formattedCurrentDate);
          } else if (!untilAlreadyExists && formattedCurrentDate) {
            updateQParams("until", formattedCurrentDate);
          }
          updateQParams("daysRange", result.isLight ? "last90d" : "last24");
          history.push({ search: params.toString() });
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              ...result,
              dateRange: [formattedPastDate, formattedCurrentDate],
            },
          });
        }
      }
      trackDashboardOpenedOnce(result.dashboard?.ID, {
        name: result.dashboard?.Name,
        view: "data",
      });
      getBoardData(DashboardId);
    }
  };

  const getBoardData = async (dashboard_id) => {
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    // Kick off the first data load immediately; the hidden #load-reviews button
    // is not mounted yet when checkDashboardStatus resolves (pre-paint).
    getSearchResults(false, 0, true);
  };
  // const getFacebookReplies = async (resReviews = []) => {
  //   setReviewsLoading(true);
  //   const url = "dashboards/get_facebook_replies";
  //   const payload = {
  //     comment_ids: (resReviews.length > 0 ? resReviews : allReviews).map(
  //       ({ DocId }) => {
  //         return DocId;
  //       }
  //     ),
  //     firebase_id: DashboardReducer.dashboard.UserId,
  //   };
  //   const result = await apiRequest(url, "POST", payload, true);
  //   if (result.success) {
  //     setFacebookReplies(result.success);
  //   } else {
  //     notification.error({
  //       message: result.error,
  //     });
  //   }
  //   setReviewsLoading(false);
  // };
  const getTopTopics = async (updateIndex, flag = 0, reset) => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      return;
    }
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since: sinceFromFilterTT,
      until: untilFromFilterTT,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const since = sinceFromFilterTT || params.get("since") || "";
    const until = untilFromFilterTT || params.get("until") || "";

    let url = "dashboards/v2/search/top_topics";
    const payload = {
      start_index: reset
        ? 0
        : updateIndex
        ? updateIndex > 1
          ? updateIndex
          : startIndex + updateIndex
        : 0,
      num_docs: numOfDocs,
      dashboard_id: resolveDashboardId(),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) {
      payload.fraud = fraud;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;

    if (result.cancel || result?.error || result.validation_error) {
      notifyWidgetError(result, t, "api_errors.top_topics");
      // setTopTopicsLoading(false);
      // setParticipationPeriodLoading(false);
      // setSentimentPeriodLoading(false);
      // setratingPeriodLoading(false);
      // setIsAvgSentimentGaugeDataLoading(false);
      // setIsPlatformDoughnutDataLoading(false);
      // setIsIntentDoughnutDataLoading(false);
      // setIsRatingDoughnutDataLoading(false);
      // setIsSentimentDoughnutDataLoading(false);
      // setReviewsLoading(false);
      // setIsRestaurantDoughnutDataLoading(false);
      // setTopicRatingsLoading(false);
    }

    if (result && !result.error && !result.cancel) {
      setTopTopics(result);
    }
    setTopTopicsLoading(false);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };
  const generatePivotAnalysis = (data) => {
    if (data && Object.keys(data)?.length > 0) {
      const initData = data.initial;
      const pivotOpt = Object.keys(initData).reduce((acc, curr) => {
        acc[curr] = Object.keys(initData[curr]);
        return acc;
      }, {});
      setPivotOptions(pivotOpt);

      if (showNormalizedData) {
        const normalizedFilteredData = getNormalizedData(data.filtered);
        const normalizedInitialData = getNormalizedData(data.initial);
        setActualDistributionData(normalizedInitialData);
        initRestaurantDoughnutData(
          normalizedFilteredData,
          normalizedInitialData
        );
      } else {
        // Use raw data without normalization
        const rawFilteredData = data.filtered;
        const rawInitialData = data.initial;
        setActualDistributionData(rawInitialData);
        initRestaurantDoughnutData(rawFilteredData, rawInitialData);
      }
    }
  };
  const getNormalizedData = (data) => {
    if (data && Object.keys(data)?.length > 0) {
      const keys = Object.keys(data);
      const totalCounts = {};
      const normalizedData = {};

      keys.forEach((key) => {
        totalCounts[key] = Object.values(data[key]).reduce((a, b) => a + b, 0);
      });

      // Normalize the data
      keys.forEach((key) => {
        normalizedData[key] = {};
        for (const subKey in data[key]) {
          normalizedData[key][subKey] = {
            count: data[key][subKey],
            percentage: Math.round(
              (data[key][subKey] / totalCounts[key]) * 100
            ),
          };
        }
      });
      return normalizedData;
    }
  };
  const getHotterms = async () => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      setHottermsLoading(false);
      return;
    }
    setHottermsLoading(true);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const ngramsArr = [1, 2, 3, 4];
    const dataObj = {};
    let aborted = false;
    const promises = ngramsArr.map(async (n_words) => {
      const {
        sentiment,
        intent,
        since: sinceFromFilterHT,
        until: untilFromFilterHT,
        rating,
        top_topics,
        topics_operator,
        platform_id,
        match_date,
        hotterm,
        nps,
        keyword,
        pivotFilter,
        pivots_operator,
        decisionFilter,
        child_others,
        parent_others,
        sortByDate,
        fraud,
      } = queryFilters;
      const since = sinceFromFilterHT || params.get("since") || "";
      const until = untilFromFilterHT || params.get("until") || "";

      let url = "dashboards/v2/get/hotterm";
      const payload = {
        dashboard_id: resolveDashboardId(),
        n_words: n_words,
        user_id: user?.uid,
      };
      if (since && until) {
        payload.since = since;
        payload.until = until;
      }
      if (sentiment) {
        payload.sentiment = sentiment;
      }
      if (intent) {
        payload.intent = intent;
      }
      if (rating) {
        payload.rating = rating;
      }
      if (hotterm?.term) {
        payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
      }
      if (keyword && keyword.length > 0) {
        payload.keyword = keyword;
      }
      if (match_date) {
        payload.match_date = match_date;
      }
      if (platform_id) {
        payload.platform_id = platform_id;
      }
      if (nps) {
        payload.nps = nps;
      }
      if (
        pivotFilter &&
        Object.keys(pivotFilter).length > 0 &&
        Object.values(pivotFilter)?.flat().length > 0
      ) {
        payload.pivotFilter = pivotFilter;
        payload.pivots_operator = pivots_operator;
      }
      if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
        payload.decisionFilter = decisionFilter;
      }
      if (fraud) {
        payload.fraud = fraud;
      }
      const selectedTpcs = {};
      for (let level = 1; level >= 1; level++) {
        if (params.has(`level${level}Selection`)) {
          const levelSelection = JSON.parse(
            params.get(`level${level}Selection`)
          );
          selectedTpcs[level] = levelSelection;
        } else {
          break;
        }
      }

      const maxLevel = Math.max(...Object.keys(selectedTpcs));
      if (maxLevel > 0) {
        payload.topic_id = selectedTpcs[maxLevel]?.id;
      }
      if (top_topics && top_topics.length > 0) {
        payload.top_topics = top_topics;
        payload.topics_operator = topics_operator ? topics_operator : "AND";
        if (child_others?.length > 0) {
          payload.top_topics_others = true;
          payload.child_others = child_others;
        } else if (parent_others?.length > 0) {
          payload.top_topics_others = true;
          payload.parent_others = parent_others;
        } else {
          payload.top_topics_others = false;
        }
      }
      if (switchPeriod) {
        payload.volume_period = switchPeriod.toLowerCase();
        payload.sentiment_period = switchPeriod.toLowerCase();
        payload.ratings_period = switchPeriod.toLowerCase();
      } else {
        payload.volume_period = dateBasedChartsPeriod.toLowerCase();
        payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
        payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
      }
      // if (sortByDate) payload.sortByDate = true;

      const result = await apiRequest(
        url,
        "POST",
        payload,
        true,
        widgetsControllerRef.current?.signal
      );
      if (isAbortedResult(result)) {
        aborted = true;
        return;
      }

      if (result && !result.error && !result.cancel) {
        if (result?.data && result.data === -1) {
          setOverLimitForHotterms(true);
          return;
        } else {
          dataObj[n_words] = result;
          setOverLimitForHotterms(false);
          return;
        }
      } else {
        if (isReviewRangeTooLarge(result)) notifyReviewRangeTooLarge(result, t);
        setHottermsLoading(false);
        dataObj[n_words] = [];
        return;
      }
    });
    await Promise.all(promises);
    if (aborted) return;
    setHottermsData(dataObj);
    setHottermsLoading(false);
  };

  const getSearchResults = async (updateIndex, flag = 0, reset) => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      return;
    }
    setReviewsLoaded(false);
    setBackwardCursors({ "-1": null });
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since: sinceFromFilter,
      until: untilFromFilter,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    // Fall back to URL params when queryFilters hasn't been populated yet (stale
    // closure on first-render call from checkDashboardStatus before setQueryFilters
    // has processed).  getOnlyReviews already reads directly from params, so this
    // makes the v2/search call consistent with the v2/get/reviews call.
    const since = sinceFromFilter || params.get("since") || "";
    const until = untilFromFilter || params.get("until") || "";

    const platformId = DashboardReducer?.dashboard?.PlatformId;
    // const isFacebookPlatform =
    //   flag === 0 && (platformId === 9 || platformId === 10);
    setTopTopicsLoading(true);
    if (flag === 0) {
      setReviewsLoading(true);
      !updateIndex && setIsRestaurantDoughnutDataLoading(true);
      if (widgetsControllerRef.current) widgetsControllerRef.current.abort();
      widgetsControllerRef.current = new AbortController();
      lastSearchFiltersRef.current = searchFiltersSignature(
        window.location.search
      );
      closeReviewRangeNotice();
    }
    const widgetsSignal = widgetsControllerRef.current?.signal;
    if (flag === 1) {
      setParticipationPeriodLoading(true);
      setSentimentPeriodLoading(true);
    }
    let url = "dashboards/v2/search";
    const payload = {
      start_index: reset
        ? 0
        : updateIndex
        ? updateIndex > 1
          ? updateIndex
          : startIndex + updateIndex
        : 0,
      num_docs: numOfDocs,
      dashboard_id: resolveDashboardId(),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;

    // Get Top Topics and Search results simultaneously
    getOnlyReviews(updateIndex, 0, reset);
    let result = null;
    if (!savedSearch) {
      getTopTopics();
      getHotterms();
      getTopicRating();
      getKeyDriverAnalysis();
      if ([33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId)) {
        getDecisionData();
      }
      result = await apiRequest(url, "POST", payload, true, widgetsSignal);
    } else {
      const values = Array.from(params);
      const queryObj = values.reduce((acc, [key, val]) => {
        if (
          key === "keyword" ||
          key === "pivotFilter" ||
          key === "top_topics" ||
          key === "level1Selection" ||
          key === "level2Selection" ||
          key === "decisionFilter" ||
          key === "child_others" ||
          key === "parent_others" ||
          key === "hotterm"
        ) {
          acc[key] = JSON.parse(val);
        } else {
          acc[key] = val;
        }
        return acc;
      }, {});

      const {
        sentiment,
        intent,
        since,
        until,
        rating,
        top_topics,
        topics_operator,
        platform_id,
        match_date,
        hotterm,
        nps,
        keyword,
        pivotFilter,
        pivots_operator,
        decisionFilter,
        child_others,
        parent_others,
        sortByDate,
        page_offset,
        start_index,
        cursor_curr,
        include_empty_reviews,
        fraud,
      } = queryObj;

      const payload = {
        dashboard_id: resolveDashboardId(),
        start_index: reset ? 0 : parseInt(start_index, 10),
        user_id: user?.uid,
      };
      if (cursor_curr && cursor_curr !== "null") {
        payload.cursor_next = cursor_curr;
      }
      if (since && until) {
        payload.since = since;
        payload.until = until;
      }
      if (sentiment) {
        payload.sentiment = sentiment;
      }
      if (intent) {
        payload.intent = intent;
      }
      if (rating) {
        payload.rating = rating;
      }
      if (hotterm?.term) {
        payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
      }
      if (keyword && keyword.length > 0) {
        payload.keyword = keyword;
      }
      if (match_date) {
        payload.match_date = match_date;
      }
      if (platform_id) {
        payload.platform_id = platform_id;
      }
      if (nps) {
        payload.nps = nps;
      }
      if (
        pivotFilter &&
        Object.keys(pivotFilter).length > 0 &&
        Object.values(pivotFilter)?.flat().length > 0
      ) {
        payload.pivotFilter = pivotFilter;
        payload.pivots_operator = pivots_operator;
      }
      if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
        payload.decisionFilter = decisionFilter;
      }
      if (fraud !== undefined && fraud !== null && fraud !== "") {
        let fraudValue;
        if (
          fraud === "true" ||
          fraud === "1" ||
          fraud === 1 ||
          fraud === true
        ) {
          fraudValue = true;
        } else if (
          fraud === "false" ||
          fraud === "0" ||
          fraud === 0 ||
          fraud === false
        ) {
          fraudValue = false;
        } else {
          fraudValue = fraud;
        }
        payload.fraud = fraudValue;
      }
      const selectedTpcs = {};
      for (let level = 1; level >= 1; level++) {
        if (params.has(`level${level}Selection`)) {
          const levelSelection = JSON.parse(
            params.get(`level${level}Selection`)
          );
          selectedTpcs[level] = levelSelection;
        } else {
          break;
        }
      }

      const maxLevel = Math.max(...Object.keys(selectedTpcs));
      if (maxLevel > 0) {
        payload.topic_id = selectedTpcs[maxLevel]?.id;
      }
      if (top_topics && top_topics.length > 0) {
        payload.top_topics = top_topics;
        payload.topics_operator = topics_operator ? topics_operator : "AND";
        if (child_others?.length > 0) {
          payload.top_topics_others = true;
          payload.child_others = child_others;
        } else if (parent_others?.length > 0) {
          payload.top_topics_others = true;
          payload.parent_others = parent_others;
        } else {
          payload.top_topics_others = false;
        }
      }
      if (switchPeriod) {
        payload.volume_period = switchPeriod.toLowerCase();
        payload.sentiment_period = switchPeriod.toLowerCase();
        payload.ratings_period = switchPeriod.toLowerCase();
      } else {
        payload.volume_period = dateBasedChartsPeriod.toLowerCase();
        payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
        payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
      }

      payload.id = parseInt(params.get("savedSearchID"), 10);
      result = await apiRequest(
        "dashboards/saved-searches/load",
        "POST",
        payload,
        // { id: parseInt(params.get("savedSearchID"), 10) },
        true,
        widgetsSignal
      );
      // Superseded by a newer search, which owns the loading flags now.
      if (isAbortedResult(result)) return;

      if (!result || result.error || result.validation_error) {
        notification.error({
          message: resolveApiErrorMessage(result, t, "api_errors.saved_view"),
        });
        setTopTopicsLoading(false);
        setParticipationPeriodLoading(false);
        setSentimentPeriodLoading(false);
        setratingPeriodLoading(false);
        setIsAvgSentimentGaugeDataLoading(false);
        setIsPlatformDoughnutDataLoading(false);
        setIsIntentDoughnutDataLoading(false);
        setIsRatingDoughnutDataLoading(false);
        setIsSentimentDoughnutDataLoading(false);
        setReviewsLoading(false);
        setIsRestaurantDoughnutDataLoading(false);
        setTopicRatingsLoading(false);
        return;
      }
      result = result.success;
      setTopTopics(result.top_topics);
      if (result?.hasOwnProperty("sent-rating")) {
        const convertedValuesIntoPercentages = convertSentimentToPercentage(
          result["sent-rating"]
        );
        const convertedRatings = convertIntoRatingData(result["sent-rating"]);
        const sortedRat = [...convertedRatings].sort((a, b) => {
          return b.rating?.value - a.rating?.value;
        });
        const sortedSent = [...convertedValuesIntoPercentages].sort((a, b) => {
          const totalA =
            a.sentiment["0.0"]?.value +
            a.sentiment["0.5"]?.value +
            a.sentiment["1.0"]?.value +
            a.sentiment["-1"]?.value;
          const totalB =
            b.sentiment["0.0"]?.value +
            b.sentiment["0.5"]?.value +
            b.sentiment["1.0"]?.value +
            b.sentiment["-1"]?.value;
          return totalB - totalA;
        });
        setTopicRatingData(sortedRat);
        setTopicSentimentData(adjustSentiments(sortedSent));
      }
      if (result?.hasOwnProperty("ngrams")) {
        const dataObj = {
          1: result.ngrams["unigram"] || [],
          2: result.ngrams["bigram"] || [],
          3: result.ngrams["trigram"] || [],
          4: result.ngrams["quadrigram"] || [],
        };
        setHottermsData(dataObj);
      }
      if (result?.hasOwnProperty("kda")) {
        if (
          result.kda === -1 ||
          result.kda.length === 0 ||
          result.kda === "No config found"
        ) {
          setNoDataForSelectedConfig(false);
          setEmptyDriverAnalysis(true);
          setDriverAnalysisLoading(false);
        } else {
          setDriverAnalysisData(result.kda);
          setNoDataForSelectedConfig(false);
          setEmptyDriverAnalysis(false);
          setDriverAnalysisLoading(false);
        }
      }
      if ([33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId)) {
        initDecisionChartsData(result.decision);
        setDecisionDataLoading(false);
      }
      setHottermsLoading(false);
      setTopicRatingsLoading(false);
      setTopTopicsLoading(false);
      setDriverAnalysisLoading(false);
    }
    // Superseded by a newer search, which owns the loading flags now.
    if (isAbortedResult(result)) return;
    // let triggerFacebookReplies = false;
    if (!result || result.cancel || result?.error || result.validation_error) {
      notifyWidgetError(result, t, "api_errors.search_results");
      setTopTopicsLoading(false);
      setParticipationPeriodLoading(false);
      setSentimentPeriodLoading(false);
      setratingPeriodLoading(false);
      setIsAvgSentimentGaugeDataLoading(false);
      setIsPlatformDoughnutDataLoading(false);
      setIsIntentDoughnutDataLoading(false);
      setIsRatingDoughnutDataLoading(false);
      setIsSentimentDoughnutDataLoading(false);
      setReviewsLoading(false);
      setIsRestaurantDoughnutDataLoading(false);
      setTopicRatingsLoading(false);
    }

    if (result && !result.error && !result.cancel) {
      // setPivotOptions(result.pivot_options ? result.pivot_options : {});
      setVolumeDaily(result.VolumeDaily || []);
      setSentimentDaily(result.SentimentDaily || []);
      setRatingBreakdown(result?.rating_breakdown);
      setAvgSentiment(result?.avgSentiment || 0);
      if (result.pivotData?.initial) {
        generatePivotAnalysis(result.pivotData);
      }
      initIntentDoughnutData((result || {}).intentPercents || []);
      initRatingDoughnutData((result || {}).ratingPercents || []);
      initSentimentDoughnutData((result || {}).sentimentPercents || []);
      initFraudDoughnutData((result || {}).fraud_dist || {});
      if (result?.VolumeDaily?.length > 0) {
        let period = determinePeriod(result?.VolumeDaily[0]?.day);
        // If data spans 3+ months (90 days), force Monthly regardless of API format
        const days = result.VolumeDaily.length;
        if (period === "Daily" && days >= 90) {
          period = "Monthly";
        }
        setratingsPeriod(period);
        setSentimentPeriod(period);
        setParticipationPeriod(period);
      }
      // triggerFacebookReplies =
      //   isFacebookPlatform && ((result || {}).docs || []).length > 0;
      // if (triggerFacebookReplies) {
      //   getFacebookReplies(result.docs);
      // }
      initPlatformDoughnutData((result || {}).PlatformCount || []);
      setTime_Daily_Rating(result?.RatingsDaily);
      setratingPeriodLoading(false);
      setNpsInfo(result?.nps_dist);
      const scale = result?.npsScale;
      if (scale) {
        setNpsScale([
          parseInt(scale.split(" to ")[0], 10),
          parseInt(scale.split(" to ")[1], 10),
        ]);
      }
      setNumReviews(result.total_num_docs);
      setrawData(result.total_num_docs || 0);
      if (result?.nps) {
        setnpScore(result?.nps || 0);
      }
      if (result?.avgRating) {
        setAvgRating(result?.avgRating || 0);
      }
    }
    // else {
    //   notification.error({
    //     message: result.error,
    //   });
    // }
    setParticipationPeriodLoading(false);
    setSentimentPeriodLoading(false);
    setratingPeriodLoading(false);
    setIsRestaurantDoughnutDataLoading(false);
    setIsIntentDoughnutDataLoading(false);
    setIsRatingDoughnutDataLoading(false);
    setIsSentimentDoughnutDataLoading(false);
    setIsAvgSentimentGaugeDataLoading(false);
    setIsPlatformDoughnutDataLoading(false);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };

  // if you are on page 2 and you click the hide reviews option then it bring you back to page 1
  useEffect(() => {
    if (isInitialRender.current) {
      //Skipping the intial render
      isInitialRender.current = false;
      return;
    }
    updateQParams("start_index", 0);
    updateQParams("cursor_curr", null);

    setSelectedReviewIds([]);
    setTweetsCheckList({});
    setUsersCheckList({});

    getOnlyReviews(false, 0, true);
  }, [hideEmptyReviews]);

  const getOnlyReviews = async (updateIndex, flag = 0, reset) => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      return;
    }
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const values = Array.from(params);
    const queryObj = values.reduce((acc, [key, val]) => {
      if (
        key === "keyword" ||
        key === "pivotFilter" ||
        key === "top_topics" ||
        key === "level1Selection" ||
        key === "level2Selection" ||
        key === "decisionFilter" ||
        key === "child_others" ||
        key === "parent_others" ||
        key === "hotterm"
      ) {
        acc[key] = JSON.parse(val);
      } else {
        acc[key] = val;
      }
      return acc;
    }, {});
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      page_offset,
      start_index,
      cursor_curr,
      include_empty_reviews,
      fraud,
    } = queryObj;

    const platformId = DashboardReducer?.dashboard?.PlatformId;
    // const isFacebookPlatform =
    //   flag === 0 && (platformId === 9 || platformId === 10);
    if (flag === 0) {
      setReviewsLoading(true);
      if (searchControllerRef.current) {
        searchControllerRef.current.abort();
      }
      const controller = new AbortController();
      searchControllerRef.current = controller;
    }
    let url = "dashboards/v2/get/reviews";
    const payload = {
      start_index: reset ? 0 : parseInt(start_index, 10),
      num_docs: parseInt(page_offset, 10),
      dashboard_id: resolveDashboardId(),
      user_id: user?.uid,
      hide_empty: hideEmptyReviews,
    };
    const savedSearchId = parseInt(params.get("savedSearchID"), 10);
    if (Number.isFinite(savedSearchId)) {
      payload.saved_view_id = savedSearchId;
    }
    if (reset) {
      const cursorKeys = ["cursor_next", "cursor_before", "cursor_curr"];
      const hadCursors = cursorKeys.some((key) => params.has(key));
      cursorKeys.forEach((key) => params.delete(key));
      // Only push if cursor params were actually present; avoid spurious history
      // entries that would change `search` and re-trigger the queryFilters effect.
      if (hadCursors) {
        history.push({ search: params.toString() });
      }
    } else if (cursor_curr && cursor_curr !== "null") {
      payload.cursor_next = cursor_curr;
    }
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    if (include_empty_reviews === "true") {
      payload.include_empty_reviews = true;
    }
    // if (sortByDate) payload.sortByDate = true;

    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      searchControllerRef.current?.signal
    );
    // let triggerFacebookReplies = false;
    if (result.cancel) {
      // Request was aborted by a newer search; the replacement request handles
      // its own loading state — do NOT clear reviewsLoading here.
      return;
    }
    if (
      result?.error ||
      Object.keys(result)?.length === 0 ||
      result.validation_error
    ) {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.loading_reviews"),
      });
      setReviewsLoading(false);
      return;
    }

    if (!result.error && !result.cancel) {
      if (flag === 0) {
        // Guard against a null/undefined docs field so allReviews is always an
        // array; a null value would silently block getHighlights and leave
        // reviewsLoading stuck at true (blank page / infinite spinner).
        setAllReviews(result.docs ?? []);
        setTimeInterval(result.timeInterval);
        setStartIndex(reset ? 0 : start_index);
      }
      setCursors({
        prev: result.cursor_before,
        next: result.cursor_next,
      });
      setBackwardCursors((prev) => {
        return {
          ...prev,
          [start_index]: result.cursor_next,
        };
      });
      const backWard_ids = {
        ...backWardCursors,
        [start_index]: result.cursor_next,
      };
      if (result.cursor_next != null && result.cursor_next !== "") {
        updateQParams("cursor_next", result.cursor_next);
      } else {
        updateQParams("cursor_next", null);
      }
      if (start_index === "0") {
        updateQParams("cursor_before", null);
      } else {
        const b_cursor =
          backWard_ids[(parseInt(start_index, 10) - 2).toString()];
        setBackwardCursors((prev) => {
          return {
            ...prev,
            [(parseInt(start_index, 10) - 2).toString()]:
              b_cursor !== undefined ? b_cursor : params.get("cursor_before"),
          };
        });
        updateQParams(
          "cursor_before",
          b_cursor !== undefined ? b_cursor : params.get("cursor_before")
        );
      }
    }
    setReviewsLoaded(true);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };

  function convertSentimentToPercentage(data) {
    const convertItem = (item) => {
      const { negative, neutral, positive, unspecified } = item.sentiment;
      const total =
        (negative || 0) + (neutral || 0) + (positive || 0) + (unspecified || 0);
      if (total > 0) {
        const sentiment = {
          "0.0": {
            percentage: parseFloat(
              (((negative || 0) / total) * 100).toFixed(2),
              10
            ),
            value: negative || 0,
          },
          "0.5": {
            percentage: parseFloat(
              (((neutral || 0) / total) * 100).toFixed(2),
              10
            ),
            value: neutral || 0,
          },
          "1.0": {
            percentage: parseFloat(
              (((positive || 0) / total) * 100).toFixed(2),
              10
            ),
            value: positive || 0,
          },
          "-1": {
            percentage: parseFloat(
              (((unspecified || 0) / total) * 100).toFixed(2),
              10
            ),
            value: unspecified || 0,
          },
        };

        if (item.child) {
          item.child = item.child.map(convertItem);
        }

        return {
          ...item,
          sentiment,
        };
      } else {
        return {
          ...item,
          sentiment: {
            "0.0": {
              percentage: 0,
              value: 0,
            },
            "0.5": {
              percentage: 0,
              value: 0,
            },
            "1.0": {
              percentage: 0,
              value: 0,
            },
            "-1": {
              percentage: 0,
              value: 0,
            },
          },
        };
      }
    };

    return data.map(convertItem);
  }
  const convertIntoRatingData = (data) => {
    const convertItem = (item) => {
      const ratings = item.rating;
      // Calculate the total count of ratings and the weighted sum
      const totalRatings = Object.values(ratings).reduce(
        (sum, count) => sum + count,
        0
      );
      let averageRating = 0;
      if (totalRatings > 0) {
        const weightedSum = Object.entries(ratings).reduce(
          (sum, [rating, count]) => sum + rating * count,
          0
        );
        averageRating = (weightedSum / totalRatings).toFixed(2);
      }
      const reviewsCount = Object.values(item.rating)
        .map((x) => parseInt(x, 10))
        .reduce((acc, curr) => acc + curr, 0);
      if (item.child) {
        item.child = item.child.map(convertItem);
      }
      return {
        ...item,
        rating: {
          value: averageRating,
          reviewsCount: reviewsCount,
        },
      };
    };
    return data.map(convertItem);
  };
  const getTopicRating = async (topicId = null) => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      setTopicRatingsLoading(false);
      return;
    }
    setTopicRatingsLoading(true);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since: sinceFromFilterTR,
      until: untilFromFilterTR,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const since = sinceFromFilterTR || params.get("since") || "";
    const until = untilFromFilterTR || params.get("until") || "";

    let url = "dashboards/v2/get/sent-rating";
    const payload = {
      dashboard_id: resolveDashboardId(),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;

    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;

    if (result.cancel || result.error || result.validation_error) {
      notifyWidgetError(result, t, "api_errors.topics_rating");
      setTopicRatingsLoading(false);
    }

    if (!result.error && !result.cancel) {
      const convertedValuesIntoPercentages = convertSentimentToPercentage(
        result
      );
      const convertedRatings = convertIntoRatingData(result);
      const sortedRat = [...convertedRatings].sort((a, b) => {
        return b.rating?.value - a.rating?.value;
      });
      const sortedSent = [...convertedValuesIntoPercentages].sort((a, b) => {
        const totalA =
          a.sentiment["0.0"]?.value +
          a.sentiment["0.5"]?.value +
          a.sentiment["1.0"]?.value +
          a.sentiment["-1"]?.value;
        const totalB =
          b.sentiment["0.0"]?.value +
          b.sentiment["0.5"]?.value +
          b.sentiment["1.0"]?.value +
          b.sentiment["-1"]?.value;
        return totalB - totalA;
      });
      setTopicRatingData(sortedRat);
      setTopicSentimentData(adjustSentiments(sortedSent));
      setTopicRatingsLoading(false);
    }
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };

  const getHighlights = async (allReviews) => {
    const url = "dashboards/highlights";
    const payload = {
      review_ids: allReviews?.map((review) => review.date_gpid),
      dashboard_id: resolveDashboardId(),
    };
    const result = await apiRequest(url, "POST", payload, true);
    if (result?.success) {
      setHighlights(result?.success);
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.reviews_highlights"),
      });
    }
    setReviewsLoading(false);
  };
  useEffect(() => {
    if (reviewsLoaded) {
      // Pass an empty array when allReviews is null/undefined so getHighlights
      // always runs and always calls setReviewsLoading(false).
      getHighlights(allReviews ?? []);
    }
  }, [reviewsLoaded, allReviews]);
  const platformIdsANdNamesMap = {
    "1": t("feedback_dropdown_values.14"),
    "2": t("feedback_dropdown_values.15"),
    "4": t("feedback_dropdown_values.17"),
    "5": t("feedback_dropdown_values.18"),
    "6": "Instagram Hashtags",
    "9": t("feedback_dropdown_values.21"),
    "10": t("feedback_dropdown_values.22"),
    "14": t("feedback_dropdown_values.26"),
    "15": t("feedback_dropdown_values.27"),
    "17": t("feedback_dropdown_values.29"),
    "18": t("feedback_dropdown_values.30"),
    "19": t("feedback_dropdown_values.31"),
    "27": t("feedback_dropdown_values.36"),
    "29": t("feedback_dropdown_values.38"),
    "31": t("feedback_dropdown_values.40"),
    "32": t("feedback_dropdown_values.41"),
    "33": t("feedback_dropdown_values.42"),
    "34": t("feedback_dropdown_values.43"),
    "35": t("feedback_dropdown_values.44"),
    "36": "doktortakvimi",
    "30": "Others",
    "40": "Trustpilot",
  };

  const handleDoughnutClick = (item, type) => {
    if (savedSearch && isStatic) {
      return;
    }
    if (item) {
      // const datasetIndex = item._datasetIndex;
      const index = item.index;
      if (type === "intent") {
        updateQParams("intent", intentDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenIntent: intentDoughnutData.ids[index],
          },
        });
      } else if (type === "sentiment") {
        updateQParams("sentiment", sentimentDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenSentiment: sentimentDoughnutData.ids[index],
          },
        });
      } else if (type === "rating") {
        updateQParams("rating", ratingDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenDocRating: ratingDoughnutData.ids[index],
          },
        });
      } else if (type === "platform") {
        updateQParams("platform_id", platformData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenPlatformName: platformData.ids[index],
          },
        });
      } else if (type === "fraud") {
        updateQParams("fraud", fraudDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: { chosenFraud: fraudDoughnutData.ids[index] },
        });
      }
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: true,
        },
      });
    }
  };

  const handleSearchWord = (tag, checked, isFromReviewsSection) => {
    if (
      reviewsLoading ||
      topTopicsLoading ||
      participationPeriodLoading ||
      topicRatingsLoading ||
      hottermsLoading ||
      decisionDataLoading ||
      driverAnalysisLoading ||
      isIntentDoughnutDataLoading ||
      isRatingDoughnutDataLoading ||
      isSentimentDoughnutDataLoading ||
      isAvgSentimentGaugeDataLoading ||
      isPlatformDoughnutDataLoading ||
      isRestaurantDoughnutDataLoading
    ) {
      return;
    }
    searchControllerRef.current = new AbortController();
    const selectedTags = params.has("keyword")
      ? JSON.parse(params.get("keyword"))
      : [];
    if (tag && checked && selectedTags.length >= 1) {
      setShowAdditionalSearchPopup(true);
      return;
    }
    const nextSelectedTags = checked
      ? tag
        ? [...selectedTags, { label: tag, type: "search" }]
        : selectedTags
      : selectedTags.filter((t) => t.label !== tag);
    params.delete("keyword");
    params.append("keyword", JSON.stringify(nextSelectedTags));
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenKeywords: nextSelectedTags,
      },
    });
    setSearchWord("");
    if (!isFromReviewsSection) {
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: true,
        },
      });
    }
  };

  const getSearchState = () => {
    const {
      chosenKeywords,
      chosenSentiment,
      chosenDate,
      chosenIntent,
      chosenHotTerm,
      chosenDocRating,
      chosenFraud,
    } = DashboardReducer.searchState;
    const payload = {};
    if (chosenKeywords.length !== 0) {
      payload.chosenKeywords = chosenKeywords;
    }
    if (chosenDate) {
      payload.chosenDate = chosenDate;
    }
    if (chosenSentiment) {
      payload.chosenSentiment = chosenSentiment;
    }
    if (chosenIntent) {
      payload.chosenIntent = chosenIntent;
    }
    if (chosenHotTerm) {
      payload.chosenHotTerm = chosenHotTerm;
    }
    if (chosenDocRating) {
      payload.chosenDocRating = chosenDocRating;
    }
    if (chosenFraud) {
      payload.chosenFraud = chosenFraud;
    }
    return payload;
  };

  const getAIInsightsDateRange = () => {
    return {
      since: queryFilters?.since || DashboardReducer?.dashboard_start_date,
      until: queryFilters?.until || DashboardReducer?.dashboard_end_date,
    };
  };

  const getAIInsightsSelectedTopic = () => {
    let selectedTopic = null;
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        selectedTopic = JSON.parse(params.get(`level${level}Selection`));
      } else {
        break;
      }
    }
    return selectedTopic;
  };

  const buildAIInsightsSearchFilters = () => {
    const { since, until } = getAIInsightsDateRange();
    const selectedTopic = getAIInsightsSelectedTopic();
    const searchFilters = {};
    [
      "sentiment",
      "intent",
      "rating",
      "top_topics",
      "topics_operator",
      "platform_id",
      "match_date",
      "hotterm",
      "nps",
      "keyword",
      "pivotFilter",
      "pivots_operator",
      "decisionFilter",
      "child_others",
      "parent_others",
      "fraud",
    ].forEach((key) => {
      const value = queryFilters?.[key];
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        (!Array.isArray(value) || value.length > 0) &&
        (typeof value !== "object" || Array.isArray(value) || Object.keys(value).length > 0)
      ) {
        searchFilters[key] = value;
      }
    });
    if (queryFilters?.hotterm?.term) {
      searchFilters.hotterm = [
        queryFilters.hotterm.term,
        ...(queryFilters.hotterm.similarTerms || []),
      ];
    }
    if (
      queryFilters?.fraud !== undefined &&
      queryFilters?.fraud !== null &&
      queryFilters?.fraud !== ""
    ) {
      if (queryFilters.fraud === "true" || queryFilters.fraud === "1") {
        searchFilters.fraud = true;
      } else if (
        queryFilters.fraud === "false" ||
        queryFilters.fraud === "0"
      ) {
        searchFilters.fraud = false;
      }
    }
    if (since && until) {
      searchFilters.since = since;
      searchFilters.until = until;
    }
    if (selectedTopic?.id) {
      searchFilters.topic_id = selectedTopic.id;
    }
    return searchFilters;
  };

  const buildAIInsightsPayload = () => {
    const searchFilters = buildAIInsightsSearchFilters();
    return {
      dashboard_id: parseInt(match.params.id, 10),
      since: searchFilters.since,
      until: searchFilters.until,
      searchFilters,
    };
  };

  const buildAIInsightsFilterLabels = () => {
    const labels = [];
    const { since, until } = getAIInsightsDateRange();
    const selectedTopic = getAIInsightsSelectedTopic();

    if (since && until) {
      labels.push(`${since} - ${until}`);
    }
    if (queryFilters?.pivotFilter && Object.keys(queryFilters.pivotFilter).length > 0) {
      Object.entries(queryFilters.pivotFilter).forEach(([key, values]) => {
        const column = key.includes("$$") ? key.split("$$")[1] : key;
        const list = Array.isArray(values) ? values : [values];
        labels.push(`${column}: ${list.join(", ")}`);
      });
    }
    if (queryFilters?.top_topics?.length > 0) {
      labels.push(
        `Topics: ${queryFilters.top_topics
          .map((topic) => topic?.label)
          .filter(Boolean)
          .join(` ${queryFilters?.topics_operator || "AND"} `)}`
      );
    }
    if (selectedTopic?.label) {
      labels.push(`Selected topic: ${selectedTopic.label}`);
    }
    if (queryFilters?.sentiment) {
      labels.push(`Sentiment: ${queryFilters.sentiment}`);
    }
    if (queryFilters?.intent) {
      labels.push(`Intent: ${queryFilters.intent}`);
    }
    if (queryFilters?.rating) {
      labels.push(`Rating: ${queryFilters.rating}`);
    }
    if (queryFilters?.platform_id) {
      labels.push(`Platform: ${platformIdsANdNamesMap[queryFilters.platform_id] || queryFilters.platform_id}`);
    }
    if (queryFilters?.nps) {
      labels.push(`NPS: ${queryFilters.nps}`);
    }
    if (queryFilters?.keyword?.length > 0) {
      labels.push(`Keywords: ${queryFilters.keyword.join(", ")}`);
    }
    if (queryFilters?.hotterm?.term) {
      labels.push(`Hotterm: ${queryFilters.hotterm.term}`);
    } else if (Array.isArray(queryFilters?.hotterm) && queryFilters.hotterm.length > 0) {
      labels.push(`Hotterm: ${queryFilters.hotterm.join(", ")}`);
    }
    if (queryFilters?.fraud !== undefined && queryFilters?.fraud !== null && queryFilters?.fraud !== "") {
      labels.push(`Fraud: ${queryFilters.fraud}`);
    }

    return labels;
  };

  const { since: aiQuotaSince, until: aiQuotaUntil } = getAIInsightsDateRange();

  useEffect(() => {
    if (!showAIInsightsModal || !match.params.id || !aiQuotaSince || !aiQuotaUntil) {
      return;
    }
    let cancelled = false;
    (async () => {
      setAiInsightsQuotaLoading(true);
      setAiInsightsQuotaError(false);
      setAiInsightsQuota(null);
      try {
        const res = await fetchAiInsightsQuota(apiRequest, {
          dashboardId: match.params.id,
          startDate: aiQuotaSince,
          endDate: aiQuotaUntil,
        });
        if (cancelled) {
          return;
        }
        if (res?.error || res?.validation_error) {
          console.warn(
            "[WARN] DashboardData AI insights quota check returned error",
            res,
          );
          setAiInsightsQuotaError(true);
        } else {
          setAiInsightsQuota(res);
        }
      } catch (e) {
        console.error("[ERROR] DashboardData AI insights quota fetch failed", e);
        if (!cancelled) {
          setAiInsightsQuotaError(true);
        }
      } finally {
        if (!cancelled) {
          setAiInsightsQuotaLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    showAIInsightsModal,
    match.params.id,
    aiQuotaSince,
    aiQuotaUntil,
  ]);

  const handleCreateInsight = async () => {
    if (!insightTxt) {
      notification.error({ message: t("notifications.46") });
      return;
    }
    setCreateInsightLoading(true);
    const searchState = {
      ...DashboardReducer?.searchState,
      chosenDate: params.has("match_date") ? params.get("match_date") : "",
      chosenDocRating: params.has("rating") ? params.get("rating") : "",
      chosenHotTerm: params.has("hotterm")
        ? JSON.parse(params.get("hotterm"))
        : [],
      chosenIntent: params.has("intent") ? params.get("intent") : "",
      chosenKeywords: params.has("keyword")
        ? JSON.parse(params.get("keyword"))
        : [],
      chosenNPS: params.has("nps") ? params.get("nps") : "",
      chosenPlatformName: params.has("platform_id")
        ? platformIdsANdNamesMap[params.get("platform_id")]
        : "",
      chosenSentiment: params.has("sentiment") ? params.get("sentiment") : "",
      chosenTopTopic: params.has("top_topics")
        ? JSON.parse(params.get("top_topics"))
        : [],
      chosenFraud: params.has("fraud") ? params.get("fraud") : "",
      dateRange:
        params.has("since") && params.has("until")
          ? [params.get("since"), params.get("until")]
          : [],
      selectedDaysRange: params.has("daysRange")
        ? params.get("daysRange")
        : DashboardReducer?.searchState?.selectedDaysRange,
      topicsOperator:
        params.has("top_topics") && params.has("topics_operator")
          ? params.get("topics_operator")
          : "OR",
      pivotFilter: params.has("pivotFilter")
        ? JSON.parse(params.get("pivotFilter"))
        : {},
      pivots_operator:
        params.has("pivotFilter") && params.has("pivots_operator")
          ? params.get("pivots_operator")
          : "AND",
      decisionFilter: params.has("decisionFilter")
        ? JSON.parse(params.get("decisionFilter"))
        : {},
    };
    if (params.has("top_topics")) {
      if (params.has("child_others")) {
        searchState.top_topics_others = true;
        searchState.child_others = JSON.parse(params.get("child_others"));
      } else if (params.has("parent_others")) {
        searchState.top_topics_others = true;
        searchState.parent_others = JSON.parse(params.get("parent_others"));
      } else {
        searchState.top_topics_others = false;
      }
    }
    const ratingTpcs = {};
    for (let l = 1; l >= 1; l++) {
      if (params.has(`level${l}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${l}Selection`));
        ratingTpcs[`level${l}Selection`] = levelSelection;
      } else {
        break;
      }
    }
    // if(Object.keys(searchState).length === 0) {
    //   notification.error({
    //     message: "Please apply some filtering"
    //   });
    // }
    const payload = {
      dashboard_id: initialState.currentDashboard,
      insight: insightTxt,
      insight_title: insightTitleTxt,
      searchState: { ...searchState, ...ratingTpcs },
      timeInterval,
      total_num_docs: numReviews,
      reporter: userReducer.IsExpert ? 2 : 1,
    };
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const search_payload = {
      dashboard_id: parseInt(initialState.currentDashboard, 10),
      start_index: 0,
      num_docs: numOfDocs,
      user_id: user?.uid,
    };
    if (since && until) {
      search_payload.since = since;
      search_payload.until = until;
    }
    if (sentiment) {
      search_payload.sentiment = sentiment;
    }
    if (intent) {
      search_payload.intent = intent;
    }
    if (rating) {
      search_payload.rating = rating;
    }
    if (hotterm?.term) {
      search_payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      search_payload.keyword = keyword;
    }
    if (match_date) {
      search_payload.match_date = match_date;
    }
    if (platform_id) {
      search_payload.platform_id = platform_id;
    }
    if (nps) {
      search_payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      search_payload.pivotFilter = pivotFilter;
      search_payload.pivots_operator = pivots_operator || "AND";
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      search_payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      search_payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      search_payload.top_topics = top_topics;
      search_payload.topics_operator = topics_operator
        ? topics_operator
        : "AND";
      if (child_others?.length > 0) {
        search_payload.top_topics_others = true;
        search_payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        search_payload.top_topics_others = true;
        search_payload.parent_others = parent_others;
      } else {
        search_payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      search_payload.volume_period = switchPeriod.toLowerCase();
      search_payload.sentiment_period = switchPeriod.toLowerCase();
      search_payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      search_payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      search_payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      search_payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) search_payload.sortByDate = true;
    if (Object.keys(search_payload)?.length > 0) {
      payload.search_payload = search_payload;
    }
    const result = await apiRequest(
      "dashboards/insights/create",
      "POST",
      payload,
      true
    );
    if (result.cancel || result.error || result.validation_error) {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.post_insight"),
      });
    } else {
      notification.success({
        message: (
          <span>
            Insight created successfully.
            <br />
            Go to{" "}
            <a
              onClick={() => {
                history.push({
                  pathname: `/console/insights/${DashboardReducer.dashboard?.ID}`,
                });
              }}
            >
              insights page
            </a>
          </span>
        ),
      });
    }
    setCreateInsightLoading(false);
    setCreateModal(false);
    // getInsights(DashboardId);
    setInsightTxt("");
  };

  const handleAIInsightGeneration = async () => {
    const payload = buildAIInsightsPayload();
    try {
      const response = await apiRequest(
        "dashboards/gen-insights",
        "POST",
        payload,
        true
      );
      if (response?.error) throw new Error(response.error);
      if (response?.success) {
        setShowAIInsightsModal(false);
        notification.success({
          message: t("common.aiInsightsTitle"),
          description: t("common.aiInsightsGenerationStarted"),
        });
        history.push("/console/my-workspace");
      } else {
        throw new Error("Failed to start generation");
      }
    } catch (error) {
      notification.error({
        message: t("common.aiInsightsGenerationFailed"),
        description: error.message || t("common.aiInsightsGenerationFailedDesc"),
      });
      throw error;
    }
  };

  const downloadData = async () => {
    notification.success({
      message: (
        <span>
          {t("notifications.47")}.
          <br />
          Go to{" "}
          <a
            onClick={() => {
              history.push("/console/report?page=download");
            }}
          >
            Exports page
          </a>
        </span>
      ),
    });
    setShowFileTypePopup(false);
    const payload = {
      firebase_id: DashboardReducer.dashboard.UserId,
      dashboard_id: resolveDashboardId(),
      type: fileType,
      user_id: user?.uid,
    };

    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;

    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    if (onlySequences) {
      payload.only_sequences = true;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    // No abort signal: the export is queued server-side and the user is
    // sent to the Exports page, so paging or a new search must not cancel it.
    const result = await apiRequest(
      "dashboards/v2/get_download_link",
      "POST",
      payload,
      true
    );
    if (!result?.error && !result?.cancel) {
      trackReviewExported(resolveDashboardId(), fileType, {
        onlySequences,
      });
    }
  };
  const ratingColors = {
    "0": "#59009C",
    "1": "#6E6980",
    "2": "#2900D5",
    "3": "#F774A3",
    "4": "#FFB6C1",
    "5": "#8A2BE2",
    "6": "#5F9EA0",
    "7": "#7FFF00",
    "8": "#D2691E",
    "9": "#FF7F50",
    "10": "#6495ED",
  };
  const initRatingDoughnutData = async (rating_percent_obj) => {
    if (rating_percent_obj) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];

      ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].forEach(
        (key) => {
          // Changed from > 1 to > 0 to include all non-zero values
          // You can also use > 0.1 if you want to exclude extremely small values
          if (rating_percent_obj[key] > 0) {
            datas.push(rating_percent_obj[key]);
            labels.push(key);
            backgroundColors.push(hexToRGBA(ratingColors[key], 0.8));
            hoverBackgroundColors.push(hexToRGBA(ratingColors[key], 0.5));
          }
        }
      );

      const ratingDoughnutData = {
        maintainAspectRatio: false,
        responsive: false,
        text: "Rating",
        labels: labels,
        ids: labels.filter((key) => rating_percent_obj[key] > 0),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };

      setRatingDoughnutData(ratingDoughnutData);
    }
  };
  const intentMapping = {
    "-1": t("feedback_dropdown_values.1"),
    "1": t("feedback_dropdown_values.5"),
    "2": t("feedback_dropdown_values.6"),
    "3": t("feedback_dropdown_values.7"),
    "4": t("feedback_dropdown_values.8"),
    "5": t("feedback_dropdown_values.9"),
    "6": t("feedback_dropdown_values.10"),
    "7": t("feedback_dropdown_values.11"),
    "8": t("feedback_dropdown_values.12"),
    "33": t("feedback_dropdown_values.13"),
  };
  const sentimentMapping = {
    "-1": t("feedback_dropdown_values.1"),
    "0.5": t("feedback_dropdown_values.3"),
    "0.0": t("feedback_dropdown_values.4"),
    "1.0": t("feedback_dropdown_values.2"),
    "33": t("feedback_dropdown_values.13"),
  };
  const intentColors = DASHBOARD_INTENT_COLORS;
  const sentimentColors = {
    "-1": "#FF8C00",
    "0.5": "#FFFF00",
    "0.0": "#DC2525",
    "1.0": "#10C800",
    "33": "#FB6542",
  };
  const platformColors = {
    "1": "#E070EF",
    "2": "#FE4780",
    "4": "#3D85C6",
    "6": "#C018D6",
    "9": "#C018D6",
    "10": "#C018D6",
    "14": "#1B031F",
    "17": "#891199",
    "5": "#652CB3",
    "18": "#D896FF",
    "19": "#800080",
    "27": "#962FBF",
    "29": "#000000",
    "31": "#800AF0",
    "32": "#891199",
    "33": "#C018D6",
    "34": "#1B031F",
    "35": "#891199",
    "36": "#FF6B35",
    "40": "#00B67A",
  };
  const initIntentDoughnutData = async (intent_percent_obj) => {
    setIsIntentDoughnutDataLoading(true);
    if (intent_percent_obj && Object.keys(intent_percent_obj).length > 0) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];
      Object.keys(intent_percent_obj).map((key) => {
        if (intent_percent_obj[key] > 1) {
          datas.push(intent_percent_obj[key]);
          labels.push(intentMapping[key]);
          backgroundColors.push(hexToRGBA(intentColors[key], 0.8));
          hoverBackgroundColors.push(hexToRGBA(intentColors[key], 0.5));
        }
      });
      const intentDoughnutData = {
        maintainAspectRatio: false,
        responsive: true,
        text: "intent",
        labels: labels,
        ids: Object.keys(intent_percent_obj).filter(
          (key) => intent_percent_obj[key] > 1
        ),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setIntentDoughnutData(intentDoughnutData);
    }
  };

  const colors = [
    "#4400AA",
    "#FF5280",
    "#9E1684",
    "#4582C4",
    "#5C2A70",
    "#D41C1C",
    "#D2B5F2",
    "#56DEC8",
    "#87050D",
    "#836DDE",
    "#FF056D",
    "#BD02FF",
    "#6E6980",
    "#671D9E",
  ];
  const hexToRGBA = (hex, opacity) => {
    hex = hex?.replace("#", "");
    const r = parseInt(hex?.substring(0, 2), 16);
    const g = parseInt(hex?.substring(2, 4), 16);
    const b = parseInt(hex?.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  const RGBAToHex = (rgba) => {
    const rgbaValues = rgba?.match(/\d+/g);
    const r = ("0" + parseInt(rgbaValues[0]).toString(16)).slice(-2);
    const g = ("0" + parseInt(rgbaValues[1]).toString(16)).slice(-2);
    const b = ("0" + parseInt(rgbaValues[2]).toString(16)).slice(-2);
    return `#${r}${g}${b}`;
  };
  useEffect(() => {
    for (let i = 0; i >= 0; i++) {
      if (restaurantRef.current && restaurantRef.current[i]) {
        restaurantRef.current[i].current["filtersApplied"] = filters.length > 0;
        restaurantRef.current[i].current.update();
      } else {
        break;
      }
    }
  }, [filters, isRestaurantDoughnutDataLoading, reviewsLoading]);
  const [restaurantColorMap, setRestaurantColorMap] = useState({});
  const initRestaurantDoughnutData = async (filteredData, actualData) => {
    if (
      filteredData &&
      Object.keys(filteredData)?.length > 0 &&
      actualData &&
      Object.keys(actualData)?.length > 0
    ) {
      let doughnutDataArray = Object.keys(filteredData).map((key) => {
        const restaurant_obj = filteredData[key];
        const act_obj = actualData[key];
        if (restaurant_obj) {
          const restaurant_arr = [];
          const act_arr = [];
          let total = 0;
          const counts = [];
          Object.keys(restaurant_obj).map((key) => {
            const value = restaurant_obj[key];
            total += showNormalizedData ? value.percentage : value.count;
            restaurant_arr.push([key, value]);
          });
          restaurant_arr.sort(function(a, b) {
            return showNormalizedData
              ? b[1].percentage - a[1].percentage
              : b[1].count - a[1].count;
          });
          const data = [];
          const act_data = [];
          const act_counts = [];
          const labels = [];
          const backgroundColor = [];
          const hoverBackgroundColor = [];
          const threshold = 7;
          const k = Math.min(threshold, restaurant_arr.length);
          const totalCount = restaurant_arr.reduce((acc, curr) => {
            return acc + curr[1].count;
          }, 0);
          let x = 0;
          let y = 0;
          for (let i = 0; i < k; i++) {
            let color = "";
            if (i === k - 1 && k === threshold) {
              if (restaurantColorMap["Others"]) {
                color = restaurantColorMap["Others"];
              } else {
                color = colors[i % colors.length];
                setRestaurantColorMap((prev) => {
                  return { ...prev, ["Others"]: color };
                });
              }
              backgroundColor.push(hexToRGBA(color, 1.0));
              hoverBackgroundColor.push(hexToRGBA(color, 0.6));
              data.push(showNormalizedData ? 100 - x : totalCount - y);
              labels.push("Others");
              counts.push(totalCount - y);
            } else {
              const label = restaurant_arr[i][0];
              if (restaurantColorMap[label]) {
                color = restaurantColorMap[label];
              } else {
                color = colors[i % colors.length];
                setRestaurantColorMap((prev) => {
                  return { ...prev, [label]: color };
                });
              }
              backgroundColor.push(hexToRGBA(color, 1.0));
              hoverBackgroundColor.push(hexToRGBA(color, 0.6));
              x += showNormalizedData ? restaurant_arr[i][1].percentage : 0;
              y += restaurant_arr[i][1].count;
              data.push(
                showNormalizedData
                  ? restaurant_arr[i][1].percentage
                  : restaurant_arr[i][1].count
              );
              labels.push(label);
              counts.push(restaurant_arr[i][1].count);
            }
          }
          let abc = 0;
          let xyz = 0;
          labels.map((label, i) => {
            const totalActualCount = Object.values(act_obj).reduce(
              (total, curr) => total + curr.count,
              0
            );
            if (i === 6 && label === "Others") {
              act_counts.push(totalActualCount - xyz);
              act_data.push(
                showNormalizedData ? 100 - abc : totalActualCount - xyz
              );
            } else {
              // Add safety check for act_obj[label]
              if (act_obj[label]) {
                abc += showNormalizedData ? act_obj[label].percentage : 0;
                xyz += act_obj[label].count;
                act_data.push(
                  showNormalizedData
                    ? act_obj[label].percentage
                    : act_obj[label].count
                );
                act_counts.push(act_obj[label].count);
              } else {
                // Handle missing label in act_obj
                act_data.push(0);
                act_counts.push(0);
              }
            }
          });
          const doughnutData = {
            datasets: [
              {
                backgroundColor: backgroundColor,
                data: data,
                actualData: act_data,
                actualCounts: act_counts,
                hoverBackgroundColor: hoverBackgroundColor,
                counts: counts,
              },
            ],
            labels: labels,
            maintainAspectRatio: false,
            responsive: true,
            text: "restaurant",
            doughnutLabel: key,
          };
          return doughnutData;
        }
      });
      setRestaurantDoughnutData(doughnutDataArray);
    }
  };
  const initDecisionChartsData = (data) => {
    if (data?.length > 0) {
      const dataArr = data.map((decision) => {
        const labels =
          decision.decision === "publish"
            ? ["Do not Publish", "Publish"]
            : decision.decision === "opencase"
            ? ["Do not open case", "Open case"]
            : ["Do not take action", "Take action"];
        const distribution = decision.dist;
        if (distribution.True + distribution.False === 0) {
          return {
            labels,
            datasets: [
              {
                data: [0, 0],
                counts: [0, 0],
              },
            ],
            doughnutLabel: decision.decision,
          };
        }
        const truePerc =
          (distribution.True / (distribution.True + distribution.False)) * 100;
        const falsePerc =
          (distribution.False / (distribution.True + distribution.False)) * 100;
        const datasets = [
          {
            data: [falsePerc.toFixed(1), truePerc.toFixed(1)],
            backgroundColor:
              decision.decision === "publish"
                ? [hexToRGBA("#3A6D8C", 1), hexToRGBA("#41B3A2", 1)]
                : decision.decision === "opencase"
                ? [hexToRGBA("#D91656", 1), hexToRGBA("704264", 1)]
                : [hexToRGBA("#304463", 1), hexToRGBA("#758694", 1)],
            hoverBackgroundColor:
              decision.decision === "publish"
                ? [hexToRGBA("#3A6D8C", 0.8), hexToRGBA("#41B3A2", 0.8)]
                : decision.decision === "opencase"
                ? [hexToRGBA("#D91656", 0.8), hexToRGBA("#704264", 0.8)]
                : [hexToRGBA("#304463", 0.8), hexToRGBA("#758694", 0.8)],
            counts: [distribution.False, distribution.True],
          },
        ];
        return {
          labels,
          datasets,
          text: "decision",
          doughnutLabel: decision.decision,
        };
      });
      const sumOfDataValues = dataArr.map((item) =>
        item.datasets[0].data.reduce((acc, curr) => acc + parseInt(curr, 10), 0)
      );
      if (sumOfDataValues.every((sum) => sum === 0)) {
        setDecisionData([]);
      } else {
        setDecisionData(dataArr);
      }
    } else {
      setDecisionData([]);
    }
  };

  const initSentimentDoughnutData = (sentiment_percent_obj = {}) => {
    if (sentiment_percent_obj) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];
      Object.keys(sentiment_percent_obj).map((key) => {
        if (sentiment_percent_obj[key] > 1) {
          datas.push(sentiment_percent_obj[key]);
          labels.push(sentimentMapping[key]);
          backgroundColors.push(hexToRGBA(sentimentColors[key], 0.8));
          hoverBackgroundColors.push(hexToRGBA(sentimentColors[key], 0.5));
        }
      });
      const sentimentdoughnutData = {
        maintainAspectRatio: false,
        responsive: false,
        text: "Sentiment",
        labels: labels,
        ids: Object.keys(sentiment_percent_obj).filter(
          (key) => sentiment_percent_obj[key] > 1
        ),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setSentimentDoughnutData(sentimentdoughnutData);
    }
  };

  const initPlatformDoughnutData = (platform_obj = {}) => {
    const datas = [];
    const labels = [];
    const backgroundColors = [];
    const hoverBackgroundColors = [];
    Object.keys(platform_obj).map((key) => {
      datas.push(platform_obj[key]);
      labels.push(platformIdsANdNamesMap[key]);
      backgroundColors.push(hexToRGBA(platformColors[key], 0.8));
      hoverBackgroundColors.push(hexToRGBA(platformColors[key], 0.5));
    });
    const platformData = {
      maintainAspectRatio: false,
      responsive: true,
      text: "Platform",
      labels: labels,
      ids: Object.keys(platform_obj),
      datasets: [
        {
          data: datas,
          backgroundColor: backgroundColors,
          hoverBackgroundColor: hoverBackgroundColors,
        },
      ],
    };
    setPlatformData(platformData);
  };

  const determinePeriod = (val) => {
    try {
      let identifier = (val.match(/-/g) || []).length;
      return identifier === 0
        ? "Yearly"
        : identifier === 1
        ? "Monthly"
        : "Daily";
    } catch (e) {
      console.error("Error", e);
      return "Monthly";
    }
  };

  const handleTimePeriodOptions = (val, flag) => {
    if (savedSearch && isStatic) {
      return;
    }
    if (!reviewsLoading) {
      setParticipationPeriod(val);
      setSentimentPeriod(val);
      setratingPeriodLoading(true);
      setratingsPeriod(val);
      setSwitchPeriod(val);
    }
  };

  const timePeriodOptions = (flag) => {
    const itemStyle = {
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff",
    };
    return (
      <Menu
        style={{ backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff" }}
        onClick={(e) => handleTimePeriodOptions(e.key, flag)}
      >
        <Menu.Item key="Daily" style={itemStyle}>
          {t("selected_dashboard_page.1")}
        </Menu.Item>
        {/* <Menu.Item key="Weekly" style={itemStyle}>
          Weekly
        </Menu.Item> */}
        <Menu.Item key="Monthly" style={itemStyle}>
          {t("selected_dashboard_page.2")}
        </Menu.Item>
        <Menu.Item key="Yearly" style={itemStyle}>
          {t("selected_dashboard_page.3")}
        </Menu.Item>
      </Menu>
    );
  };
  const handleResetTopicFilters = () => {
    if (
      reviewsLoading ||
      topTopicsLoading ||
      participationPeriodLoading ||
      topicRatingsLoading ||
      hottermsLoading ||
      decisionDataLoading ||
      driverAnalysisLoading ||
      isIntentDoughnutDataLoading ||
      isRatingDoughnutDataLoading ||
      isSentimentDoughnutDataLoading ||
      isAvgSentimentGaugeDataLoading ||
      isPlatformDoughnutDataLoading ||
      isRestaurantDoughnutDataLoading
    ) {
      return;
    }
    for (let l = 1; l >= 1; l++) {
      if (params.has(`level${l}Selection`)) {
        params.delete(`level${l}Selection`);
        history.push({ search: params.toString() });
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            [`selectedL${l}Topic`]: null,
          },
        });
      } else {
        break;
      }
    }
  };
  //Doubts
  const handleResetFilter = () => {
    if (savedSearch && isStatic) {
      return;
    }
    handleResetTopicFilters();
    handleResetPivotFilters();
    handleResetKDA();
    handleClearAllTopTopics();
    [
      "sentiment",
      "intent",
      "since",
      "until",
      "daysRange",
      "rating",
      "top_topics",
      "topics_operator",
      "platform_id",
      "match_date",
      "hotterm",
      "nps",
      "keyword",
      "pivotFilter",
      "pivots_operator",
      "decisionFilter",
      "cursor_next",
      "cursor_curr",
      "cursor_before",
      "savedSearchID",
      "child_others",
      "parent_others",
      "fraud",
    ].forEach((item) => params.delete(item));
    params.append("daysRange", "allTime");
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenKeywords: [],
        chosenSentiment: "",
        chosenDate: "",
        chosenFetchType: "topic",
        sortByDate: false,
        chosenIntent: "",
        chosenHotTerm: "",
        chosenDocRating: "",
        showNewReviewsLabel: false,
        chosenRestaurantName: "",
        chosenPlatformName: "",
        chosenTopTopic: [],
        topicsOperator: "AND",
        chosenNPS: "",
        dateRange: [],
        pivotFilter: {},
        pivots_operator: null,
        selectedL1Topic: "",
        selectedL2Topic: "",
        level1OfSelectedTopic: "",
        level2OfSelectedTopic: "",
        chosenFraud: "",
      },
    });
    dispatch({
      type: actions.SELECT_TOPIC,
      payload: {
        selected_topic: undefined,
        insightBasedSearch: {},
        trends: {},
      },
    });
  };

  const handleNPSFilter = (label) => {
    if (savedSearch && isStatic) {
      return;
    }
    params.delete("nps");
    params.append("nps", label);
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenNPS: label,
      },
    });
  };

  const handleShowFileType = () => {
    setShowFileTypePopup(true);
  };

  useEffect(() => {
    console.log(selectedTopicFromBars);
    if (
      selectedTopicFromBars &&
      Object.keys(selectedTopicFromBars).length > 0
    ) {
      Object.keys(selectedTopicFromBars).forEach((key) => {
        const item = selectedTopicFromBars[key];
        if (item?.id) {
          updateQParams(`level${item.level}Selection`, JSON.stringify(item));
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              [`selectedL${item.level}Topic`]: item.id,
            },
          });
        }
      });
    }
  }, [selectedTopicFromBars]);

  useEffect(() => {
    if (
      params.has("level1Selection") &&
      ((topicRatingData &&
        topicRatingData.length > 0 &&
        !topicRatingData
          .map((t) => t?.rating?.value)
          .every((t) => parseInt(t, 10) === 0)) ||
        (topicSentimentData && topicSentimentData.length > 0))
    ) {
      for (let l = 1; l >= 1; l++) {
        if (params.has(`level${l}Selection`)) {
          const levelSelection = JSON.parse(params.get(`level${l}Selection`));
          setSelectedTopicFromBars((prev) => {
            return {
              ...prev,
              [levelSelection?.id]: levelSelection,
            };
          });
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              [`selectedL${l}Topic`]: levelSelection?.id,
            },
          });
        } else {
          break;
        }
      }
    }
  }, [topicSentimentData]);

  useEffect(() => {
    if (pivotOptions) {
      const options = {
        level1: [],
        level2: {},
      };

      Object.keys(pivotOptions).forEach((key) => {
        // Level 1 options
        options.level1.push({
          id: key?.toString(),
          label: key?.toString(),
          value: key?.toString(),
        });

        // Construct level2 options
        options.level2[key] = pivotOptions[key].map((option) => ({
          id: option?.toString(),
          label: option?.toString(),
          value: option?.toString(),
        }));
      });
      setMultiLevelOptions(options);
    }
  }, [pivotOptions]);

  const handlePivotDoughnutClick = (key, value) => {
    if (savedSearch && isStatic) {
      return;
    }
    const pvtFilter = params.get("pivotFilter")
      ? JSON.parse(params.get("pivotFilter"))
      : {};
    if (
      pvtFilter &&
      Object.keys(pvtFilter).length > 0 &&
      Object.values(pvtFilter).flat().length > 0
    ) {
      if (Object.keys(pvtFilter).includes(key)) {
        return;
      }
      setSelectedPivots((prevSeletedPivots) => {
        updateQParams(
          "pivotFilter",
          JSON.stringify({ ...prevSeletedPivots, [key]: [value] })
        );
        updateQParams("pivots_operator", "AND");
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            pivotFilter: { ...prevSeletedPivots, [key]: [value] },
          },
        });
        return { ...prevSeletedPivots, [key]: [value] };
      });
      setLevelWisePivotSelections((prev) => ({
        ...prev,
        [key]: { ...prev[key], [value]: {} },
      }));
    } else {
      updateQParams("pivotFilter", JSON.stringify({ [key]: [value] }));
      updateQParams("pivots_operator", "AND");
      setSelectedPivots({ [key]: [value] });
      setLevelWisePivotSelections({
        [key]: { [value]: {} },
      });
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          pivotFilter: { [key]: [value] },
        },
      });
    }
  };
  const handleDecisionDoughnutClick = (key, value) => {
    if (savedSearch && isStatic) {
      return;
    }
    const decFilter = params.get("decisionFilter")
      ? JSON.parse(params.get("decisionFilter"))
      : {};
    if (
      decFilter &&
      Object.keys(decFilter).length > 0 &&
      Object.values(decFilter).flat().length > 0
    ) {
      if (Object.keys(decFilter).includes(key)) {
        return;
      }
      setSelectedDecisions((prevSelectedDecisions) => {
        updateQParams(
          "decisionFilter",
          JSON.stringify({ ...prevSelectedDecisions, [key]: value })
        );
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            decisionFilter: { ...prevSelectedDecisions, [key]: value },
          },
        });
        return { ...prevSelectedDecisions, [key]: value };
      });
    } else {
      updateQParams("decisionFilter", JSON.stringify({ [key]: value }));
      setSelectedDecisions({ [key]: value });
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          decisionFilter: { [key]: value },
        },
      });
    }
  };
  const getSelectedPivotsFromLevelWisePivotSelections = (
    levelWisePivotSelections,
    multiLevelOptions
  ) => {
    const level1Map = multiLevelOptions.level1.reduce((acc, item) => {
      acc[item.id] = item.label;
      return acc;
    }, {});

    const level2Map = Object.keys(multiLevelOptions.level2).reduce(
      (acc, level1Id) => {
        acc[level1Id] = multiLevelOptions.level2[level1Id].reduce(
          (subAcc, item) => {
            subAcc[item.id] = item.label;
            return subAcc;
          },
          {}
        );
        return acc;
      },
      {}
    );

    const requiredFormat = Object.keys(levelWisePivotSelections).reduce(
      (acc, level1Id) => {
        const level1Label = level1Map[level1Id];
        if (level1Label) {
          acc[level1Label] = Object.keys(
            levelWisePivotSelections[level1Id]
          ).map((level2Id) => level2Map[level1Id][level2Id]);
        }
        return acc;
      },
      {}
    );
    return requiredFormat;
  };

  useEffect(() => {
    if (
      levelWisePivotSelections &&
      Object.keys(levelWisePivotSelections).length > 0 &&
      multiLevelOptions &&
      Object.keys(multiLevelOptions?.level1)?.length > 0
    ) {
      const selectedPvts = getSelectedPivotsFromLevelWisePivotSelections(
        levelWisePivotSelections,
        multiLevelOptions
      );
      if (selectedPvts && Object.keys(selectedPvts).length > 0) {
        setSelectedPivots(selectedPvts);
      }
    }
  }, [levelWisePivotSelections]);

  useEffect(() => {
    if (params.get("pivots_operator")) {
      setSelectedPivotsOperator(params.get("pivots_operator"));
    }
  }, [queryFilters]);
  const handleApplyPivotFilters = (operator = "AND") => {
    if (
      reviewsLoading ||
      topTopicsLoading ||
      participationPeriodLoading ||
      topicRatingsLoading ||
      hottermsLoading ||
      decisionDataLoading ||
      driverAnalysisLoading ||
      isIntentDoughnutDataLoading ||
      isRatingDoughnutDataLoading ||
      isSentimentDoughnutDataLoading ||
      isAvgSentimentGaugeDataLoading ||
      isPlatformDoughnutDataLoading ||
      isRestaurantDoughnutDataLoading
    ) {
      return;
    }
    if (selectedPivots) {
      const pivotsToApply =
        multiLevelOptions &&
        Object.keys(levelWisePivotSelections || {}).length > 0
          ? getSelectedPivotsFromLevelWisePivotSelections(
              levelWisePivotSelections,
              multiLevelOptions
            )
          : selectedPivots;
      if (
        !pivotsToApply ||
        Object.keys(pivotsToApply).length === 0 ||
        Object.values(pivotsToApply).flat().length === 0
      ) {
        return;
      }
      setSelectedPivots(pivotsToApply);
      updateQParams("pivotFilter", JSON.stringify(pivotsToApply));
      updateQParams("pivots_operator", operator);
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: { pivotFilter: pivotsToApply, pivots_operator: operator },
      });
    }
  };

  const handleResetPivotFilters = () => {
    if (
      reviewsLoading ||
      topTopicsLoading ||
      participationPeriodLoading ||
      topicRatingsLoading ||
      hottermsLoading ||
      decisionDataLoading ||
      driverAnalysisLoading ||
      isIntentDoughnutDataLoading ||
      isRatingDoughnutDataLoading ||
      isSentimentDoughnutDataLoading ||
      isAvgSentimentGaugeDataLoading ||
      isPlatformDoughnutDataLoading ||
      isRestaurantDoughnutDataLoading
    ) {
      return;
    }
    params.delete("pivotFilter");
    params.delete("pivots_operator");
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: { pivotFilter: {}, pivots_operator: null },
    });
    setSelectedPivots({});
    setLevelWisePivotSelections({});
  };

  const handleResetKDA = () => {
    if (
      reviewsLoading ||
      topTopicsLoading ||
      participationPeriodLoading ||
      topicRatingsLoading ||
      hottermsLoading ||
      decisionDataLoading ||
      driverAnalysisLoading ||
      isIntentDoughnutDataLoading ||
      isRatingDoughnutDataLoading ||
      isSentimentDoughnutDataLoading ||
      isAvgSentimentGaugeDataLoading ||
      isPlatformDoughnutDataLoading ||
      isRestaurantDoughnutDataLoading
    ) {
      return;
    }
    // Reset KDA-specific data
    setKDABubbleData(null);
    setKDAScaleValues({});
    setDriverAnalysisData([]);

    // Clear any KDA-related URL parameters if they exist
    params.delete("kda");
    params.delete("kdaConfig");
    history.push({ search: params.toString() });

    // Reset KDA configuration state
    setSelectedOutcomeMetric(1);
    setSelectedCustomTopics([]);
    setSelectedPivotColumns([]);
    setEmptyDriverAnalysis(true);
    setNoDataForSelectedConfig(false);
    setShowPopupSequence(false);
    setShowDriverPopup(null);
  };

  useEffect(() => {
    if (
      params.get("pivotFilter") &&
      multiLevelOptions &&
      Object.keys(multiLevelOptions).length > 0
    ) {
      const pvtFilters = Object.entries(
        JSON.parse(params.get("pivotFilter"))
      ).flatMap(([key, values]) => {
        return values.map((value) => ({ key: key, value: value }));
      });
      if (pvtFilters && pvtFilters.length > 0) {
        pvtFilters.map((filter) => {
          setLevelWisePivotSelections((prev) => ({
            ...prev,
            [filter.key]: { ...prev[filter.key], [filter.value]: {} },
          }));
        });
      }
    }
  }, [multiLevelOptions]);

  const getOutcomeMetricsList = async () => {
    setTableDataLoading(true);
    const result = await apiRequest(
      "drivers/outcome_metrics",
      "POST",
      { dashboard_id: resolveDashboardId() },
      true
    );
    if (result?.success) {
      const metrics = result.success?.map((item) => ({
        key: parseInt(item.key, 10),
        col1: item.name,
      }));
      setOutcomeMetrics(metrics);
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.outcome_metrics"),
      });
      setSelectedOutcomeMetric(-1);
    }
    setTableDataLoading(false);
  };

  const getPotentialDriversList = async () => {
    setTableDataLoading(true);
    const result = await apiRequest(
      "drivers/potential_drivers",
      "POST",
      { dashboard_id: resolveDashboardId() },
      true
    );
    if (result?.success) {
      const metrics = result.success
        ?.map((item) => {
          if (item.key) {
            return {
              key: item.key,
              col1: item.name,
              col2: item.type === 1 ? "Custom Topic" : "Pivot",
            };
          }
        })
        .filter(Boolean);
      setPotentialDrivers(metrics);
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.drivers_list"),
      });
    }
    setTableDataLoading(false);
  };

  const getKeyDriversConfig = async () => {
    setDriverAnalysisLoading(true);
    const result = await apiRequest(
      "drivers/get_config",
      "POST",
      { dashboard_id: resolveDashboardId() },
      true
    );
    if (result?.success) {
      const selectedConfig = result.success;
      const selectedDriversInConfig = selectedConfig.potential_drivers.map(
        (conf) => ({
          key: conf.type === 1 ? parseInt(conf.key, 10) : conf.key,
          col2: conf.type === 1 ? "Custom Topic" : "Pivot",
        })
      );
      setShowPopupSequence(true);
      getOutcomeMetricsList();
      setSelectedOutcomeMetric(selectedConfig.outcome_metric);
      setSelectedCustomTopics(
        selectedDriversInConfig.filter((item) => item.col2 === "Custom Topic")
      );
      setSelectedPivotColumns(
        selectedDriversInConfig.filter((item) => item.col2 === "Pivot")
      );
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.saved_config"),
      });
    }
    setDriverAnalysisLoading(false);
  };
  const saveKeyDriverConfig = async () => {
    const payload = {
      dashboard_id: resolveDashboardId(),
      outcome_metric: selectedOutcomeMetric,
      potential_drivers: [
        ...selectedCustomTopics,
        ...selectedPivotColumns,
      ]?.map((item) => ({
        key: item.key,
        type: item.col2 === "Custom Topic" ? 1 : 2,
      })),
    };
    const result = await apiRequest(
      "drivers/save_config",
      "POST",
      payload,
      true
    );
    if (result?.success) {
      console.log("Config saved!");
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.save_config"),
      });
    }
  };

  const getKeyDriverAnalysis = async () => {
    const dashboard_id = resolveDashboardId();
    if (!Number.isFinite(dashboard_id)) {
      setDriverAnalysisLoading(false);
      return;
    }
    setDriverAnalysisLoading(true);
    const analysis_payload =
      selectedOutcomeMetric !== -1 &&
      [...selectedCustomTopics, ...selectedPivotColumns]?.length > 0
        ? {
            outcome_metric: selectedOutcomeMetric,
            potential_drivers: [
              ...selectedCustomTopics,
              ...selectedPivotColumns,
            ]?.map((item) => ({
              key: item.key,
              type: item.col2 === "Custom Topic" ? 1 : 2,
            })),
          }
        : {};
    const {
      sentiment,
      intent,
      since: sinceFromFilterKD,
      until: untilFromFilterKD,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const since = sinceFromFilterKD || params.get("since") || "";
    const until = untilFromFilterKD || params.get("until") || "";
    const payload = {
      ...analysis_payload,
      dashboard_id: resolveDashboardId(),
      start_index: 0,
      num_docs: numOfDocs,
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    const result = await apiRequest(
      "drivers/analysis",
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;
    if (result?.success) {
      const responseData = result.success;
      if (responseData === -1 || responseData.length === 0) {
        setNoDataForSelectedConfig(true);
        setEmptyDriverAnalysis(false);
        setDriverAnalysisLoading(false);
        return;
      } else if (responseData === "No config found") {
        setNoDataForSelectedConfig(false);
        setEmptyDriverAnalysis(true);
        setDriverAnalysisLoading(false);
        return;
      } else {
        setDriverAnalysisData(responseData);
        setNoDataForSelectedConfig(false);
        setEmptyDriverAnalysis(false);
        setDriverAnalysisLoading(false);
      }
    } else {
      notifyWidgetError(result, t, "api_errors.driver_analysis");
      setEmptyDriverAnalysis(true);
      setDriverAnalysisLoading(false);
    }
  };
  const deleteDriverAnalysis = async () => {
    setDriverAnalysisLoading(true);
    const payload = {
      dashboard_id: resolveDashboardId(),
    };
    const result = await apiRequest("drivers/delete", "POST", payload, true);
    if (result?.success) {
      notification.success({
        message: t("api_errors.config_deleted", "Configuration deleted!"),
      });
      setEmptyDriverAnalysis(true);
      setSelectedOutcomeMetric(1);
      setSelectedCustomTopics([]);
      setSelectedPivotColumns([]);
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.delete_config"),
      });
    }
    setDriverAnalysisLoading(false);
  };

  const convertIntoBubbleData = (scatterData) => {
    const maxSize = Math.max(...scatterData.map((d) => d.size));
    return {
      datasets: scatterData?.map((d) => ({
        data: [{ x: d.x, y: d.y, r: d.r }],
        backgroundColor: hexToRGBA(
          d.fill,
          // Opacity based on the size
          Math.max(0.4, (1 - d.size / maxSize).toFixed(2))
        ),
        // Min 0.4 opacity
        borderColor: d.fill,
        label: d.label,
        size: d.size,
      })),
    };
  };

  const convertIntoTableData = (scatterData) => {
    return scatterData?.map((d, index) => ({
      key: index,
      topic: removeParentFromChildren(d.label),
      performance: d.x,
      importance: d.y,
      sampleSize: d.size,
      color: d.fill,
      // Optional columns that may or may not be available
      topicImpactRating: d.topic_impact_rating,
      topIntent: d?.top_intent,
      negative_sentiment_percentage: d?.negative_sentiment_percentage,
    }));
  };

  const resetZoom = () => {
    const zoom = {
      limits: {
        x: { min: -25, max: 125 },
        y: { min: -25, max: 125 },
      },
      pan: {
        enabled: false,
        mode: "xy",
        speed: 5,
        threshold: 5,
      },
      zoom: {
        wheel: {
          enabled: false,
        },
        pinch: {
          enabled: false,
        },
        enabled: false,
        mode: "xy",
      },
    };
    bubbleChart.current.config._config.options.plugins.zoom = zoom;
    bubbleChart.current.resetZoom();
    bubbleChart.current.update();
    setZoomLevel(0);
  };

  const handleZoomState = (value) => {
    const zoom = {
      limits: {
        x: { min: -25, max: 125 },
        y: { min: -25, max: 125 },
      },
      pan: {
        enabled: true,
        mode: "xy",
        speed: 5,
        threshold: 5,
      },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        enabled: true,
        mode: "xy",
      },
    };
    bubbleChart.current.config._config.options.plugins.zoom = zoom;
    bubbleChart.current.zoom(1 + value / 50, "active");
    bubbleChart.current.update();
    setZoomLevel((prev) => prev + value);
  };
  const removeOthersFromTopTopics = (topics) => {
    const removeOthersNested = (topics, isParent = false) => {
      return topics.filter((topic) => {
        if (isParent) {
          if ((topic?.id === null || topic?.id > 0) && topic.type === 2) {
            return topic;
          }
        } else {
          if (topic?.id > 0 && topic.lib_id > 0 && topic.type === 2) {
            return topic;
          }
        }
      });
    };
    return removeOthersNested(topics, true);
  };
  const convertToTreeOptions = (topicsTree) => {
    const convert = (tree) => {
      return tree.map((topic) => {
        const child =
          topic?.child && topic?.child?.length > 0
            ? convert(topic.child.filter((t) => t.lib_id > 0))
            : null;
        const col2 = "Custom Topic";
        const obj = {
          key: topic?.lib_id,
          col1: topic?.name,
          col2,
        };
        if (child) {
          obj.child = child;
        }
        return obj;
      });
    };
    return convert(topicsTree);
  };

  useEffect(() => {
    if (topTopics && topTopics?.tree && topTopics?.tree?.length > 0) {
      const treeWithoutOthers = removeOthersFromTopTopics(topTopics.tree);
      if (treeWithoutOthers && treeWithoutOthers.length > 0) {
        const topics = convertToTreeOptions(treeWithoutOthers);
        if (topics && topics.length > 0) {
          if (pivotOptions && Object.keys(pivotOptions).length > 0) {
            const pivots = Object.keys(pivotOptions);
            setPotentialDrivers([
              ...topics,
              ...pivots?.map((pvt, index) => ({
                key: `${pvt}_${index}`,
                col1: pvt,
                col2: "Pivot",
              })),
            ]);
          } else {
            setPotentialDrivers(topics);
          }
          return;
        }
      }
    }
    if (pivotOptions && Object.keys(pivotOptions).length > 0) {
      const pivots = Object.keys(pivotOptions);
      setPotentialDrivers(
        pivots?.map((pvt, index) => ({
          key: `${pvt}_${index}`,
          col1: pvt,
          col2: "Pivot",
        }))
      );
    } else if (showDriverPopup) {
      // No Topic Library topics and no pivots — fetch directly from the dashboard's DashTopics
      getPotentialDriversList();
    }
  }, [pivotOptions, topTopics, showDriverPopup]);

  // useEffect(() => {
  //   handleZoomInOut();
  // }, [zoomLevel]);

  useEffect(() => {
    if (driverAnalysisData) {
      const bubbleData = convertIntoBubbleData(driverAnalysisData);
      setKDABubbleData(bubbleData);
      const bubbleDataSets = bubbleData?.datasets;
      const xValues = bubbleDataSets?.map((item) => item?.data[0]?.x);
      const yValues = bubbleDataSets?.map((item) => item?.data[0]?.y);
      const filteredValues = {
        x: xValues?.filter((v) => {
          if (v) {
            return v;
          }
        }),
        y: yValues?.filter((v) => {
          if (v) {
            return v;
          }
        }),
      };
      setKDAScaleValues(filteredValues);
    }
  }, [driverAnalysisData]);
  const removeParentFromChildren = (parent) => {
    if (parent && parent !== "" && parent.includes(">")) {
      const substrs = parent.split(">").slice(-1)[0];
      return substrs;
    } else {
      return parent;
    }
  };
  const roundSentiments = (sentiment) => {
    const keys = Object.keys(sentiment);

    // Round values and calculate new total
    let roundedSentiment = {};
    let roundedTotal = 0;
    keys.forEach((key) => {
      const roundedPercentage = Math.round(sentiment[key].percentage * 10) / 10;
      roundedSentiment[key] = {
        ...sentiment[key],
        percentage: roundedPercentage,
      };
      roundedTotal += roundedPercentage;
    });

    // Adjust if the total exceeds 100
    if (roundedTotal > 100) {
      let maxKey = keys[0];
      keys.forEach((key) => {
        if (
          roundedSentiment[key].percentage > roundedSentiment[maxKey].percentage
        ) {
          maxKey = key;
        }
      });
      const excess = roundedTotal - 100;
      roundedSentiment[maxKey].percentage -= excess + 0.1;
      roundedTotal -= excess;
    }

    return roundedSentiment;
  };

  const adjustSentiments = (data) => {
    return data.map((item) => {
      if (item.sentiment) {
        item.sentiment = roundSentiments(item.sentiment);
      }
      if (item.child && item.child.length > 0) {
        item.child = adjustSentiments(item.child);
      }
      return item;
    });
  };
  const formatCountsForDoughnuts = (count) => {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1) + "M";
    } else if (count >= 1000) {
      return (count / 1000).toFixed(1) + "K";
    } else {
      return count;
    }
  };
  const hasAlphabet = (str) => {
    return /[A-Za-z]/.test(str);
  };
  const getDecisionData = async () => {
    const {
      sentiment,
      intent,
      since: sinceFromFilterDD,
      until: untilFromFilterDD,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const since = sinceFromFilterDD || params.get("since") || "";
    const until = untilFromFilterDD || params.get("until") || "";
    const payload = {
      dashboard_id: resolveDashboardId(),
      start_index: 0,
      num_docs: numOfDocs,
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud !== undefined && fraud !== null && fraud !== "") {
      let fraudValue;
      if (fraud === "true" || fraud === "1" || fraud === 1 || fraud === true) {
        fraudValue = true;
      } else if (
        fraud === "false" ||
        fraud === "0" ||
        fraud === 0 ||
        fraud === false
      ) {
        fraudValue = false;
      } else {
        fraudValue = fraud;
      }
      payload.fraud = fraudValue;
    }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    const result = await apiRequest(
      "dashboards/decision_distribution",
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;
    if (result?.success) {
      initDecisionChartsData(result?.success);
    } else {
      notifyWidgetError(result, t, "api_errors.decision_analysis");
    }
    setDecisionDataLoading(false);
  };
  const overallIntentOptions = [
    {
      id: "33",
      value: "33",
      label: t("feedback_dropdown_values.13"),
      img: "/assets/mixed_intents.svg",
    },
    {
      id: "1",
      value: "1",
      label: t("feedback_dropdown_values.5"),
      img: "/assets/Appraisal.svg",
    },
    {
      id: "2",
      value: "2",
      label: t("feedback_dropdown_values.6"),
      img: "/assets/Complaint.svg",
    },
    {
      id: "3",
      value: "3",
      label: t("feedback_dropdown_values.7"),
      img: "/assets/Suggestion.svg",
    },
    {
      id: "4",
      value: "4",
      label: t("feedback_dropdown_values.8"),
      img: "/assets/Remark.svg",
    },
    {
      id: "5",
      value: "5",
      label: t("feedback_dropdown_values.9"),
      img: "/assets/Marketing & Spam.svg",
    },
    {
      id: "6",
      value: "6",
      label: t("feedback_dropdown_values.10"),
      img: "/assets/Information.svg",
    },
    {
      id: "7",
      value: "7",
      label: t("feedback_dropdown_values.11"),
      img: "/assets/Request.svg",
    },
    {
      id: "8",
      value: "8",
      label: t("feedback_dropdown_values.12"),
      img: "/assets/Comparison.svg",
    },
  ];
  const overallSentimentOptions = [
    {
      id: "33",
      value: "33",
      label: t("feedback_dropdown_values.13"),
      img: "/assets/mixed_sentiments.svg",
    },
    {
      id: "1.0",
      value: "1.0",
      label: t("feedback_dropdown_values.2"),
      img: "/assets/Positive.svg",
    },
    {
      id: "0.5",
      value: "0.5",
      label: t("feedback_dropdown_values.3"),
      img: "/assets/Neutral.svg",
    },
    {
      id: "0.0",
      value: "0.0",
      label: t("feedback_dropdown_values.4"),
      img: "/assets/Highly_negative.svg",
    },
  ];
  const publishOptions = [
    {
      id: "1",
      label: "Could be published",
      value: "1",
      img: "/assets/mPublish.svg",
    },
    {
      id: "2",
      label: "Do not publish",
      value: "2",
      img: "/assets/cancel_circle_outlined.svg",
    },
  ];
  const caseOptions = [
    {
      id: "1",
      label: "Open a case",
      value: "1",
      img: "/assets/mOpenCase.svg",
    },
    {
      id: "2",
      label: "Do not open any case",
      value: "2",
      img: "/assets/cancel_circle_outlined.svg",
    },
  ];
  const actionOptions = [
    {
      id: "1",
      label: "Take an action",
      value: "1",
      img: "/assets/mAction.svg",
    },
    {
      id: "2",
      label: "Do not take any action",
      value: "2",
      img: "/assets/cancel_circle_outlined.svg",
    },
  ];
  const platformOptions = platformData.ids?.map((id) => ({
    label: platformIdsANdNamesMap[id],
    id: id,
    value: id,
  }));
  const ratingOptions = ["1", "2", "3", "4", "5"]?.map((label) => ({
    label: label,
    id: label,
    value: label,
  }));

  useEffect(() => {
    if (
      savedSearchLevelWisePivotSelections &&
      Object.keys(savedSearchLevelWisePivotSelections).length > 0 &&
      multiLevelOptions &&
      Object.keys(multiLevelOptions?.level1)?.length > 0
    ) {
      const selectedPvts = getSelectedPivotsFromLevelWisePivotSelections(
        savedSearchLevelWisePivotSelections,
        multiLevelOptions
      );
      if (selectedPvts && Object.keys(selectedPvts).length > 0) {
        setSavedSearchSelectedPivots(selectedPvts);
      }
    } else {
      setSavedSearchSelectedPivots({});
      setSavedSearchPivotsApplied(false);
    }
  }, [savedSearchLevelWisePivotSelections]);
  const handleSavedSearchPivotsApply = (val) => {
    setSavedSearchPivotsApplied(true);
  };
  const handleCreateSavedSearch = async () => {
    if (savedSearchTitle === "") {
      notification.warning({
        message: t("api_errors.saved_view_title_empty", "Saved View title cannot be empty!"),
      });
      return;
    }
    if (
      savedSearchCheckedTopicIds?.length > 0 &&
      savedSearchTopTopicsFilter?.length === 0
    ) {
      notification.warning({
        message: t("api_errors.apply_top_topics", "Please apply or discard the selected top-topics"),
      });
      return;
    }
    if (
      savedSearchSelectedPivots &&
      Object.keys(savedSearchSelectedPivots)?.length > 0 &&
      !savedSearchPivotsApplied
    ) {
      notification.warning({
        message: t("api_errors.apply_pivot_filters", "Please apply the selected pivot filters"),
      });
      return;
    }
    setCreateSavedSearchLoading(true);
    const query = {};
    if (savedSearchSentiment) {
      query["sentiment"] = savedSearchSentiment.value;
    }
    if (savedSearchIntent) {
      query["intent"] = savedSearchIntent.value;
    }
    if (
      savedSearchSelectedPivots &&
      Object.keys(savedSearchSelectedPivots).length > 0
    ) {
      query["pivotFilter"] = savedSearchSelectedPivots;
      query["pivots_operator"] = savedSearchPivotsOperator;
    }
    if (savedSearchDateRange?.length > 0) {
      const since = savedSearchDateRange[0];
      const until = savedSearchDateRange[1];
      query["since"] = since;
      query["until"] = until;
      const sinceDate = dayjs(since);
      const untilDate = dayjs(until);
      const noOfDays =
        since === until ||
        (untilDate.diff(sinceDate, "day") === 1 && since !== until)
          ? untilDate.diff(sinceDate, "day")
          : untilDate.diff(sinceDate, "day") + 1;
      const period =
        noOfDays < 30 ? "daily" : noOfDays < 366 ? "monthly" : "yearly";
      query["sentiment_period"] = period;
      query["volume_period"] = period;
      query["ratings_period"] = period;
    } else {
      query["sentiment_period"] = "monthly";
      query["volume_period"] = "monthly";
      query["ratings_period"] = "monthly";
    }
    if (savedSearchSelectedTopicIds?.length > 0) {
      query["top_topics"] = savedSearchTopTopicsFilter;
      query["topics_operator"] = savedSearchTopicsOperator;
      if (savedSearchChildOthers?.length > 0) {
        query["child_others"] = savedSearchChildOthers;
        query["top_topics_others"] = true;
      } else if (savedSearchParentOthers?.length > 0) {
        query["parent_others"] = savedSearchParentOthers;
        query["top_topics_others"] = true;
      } else {
        query["top_topics_others"] = false;
      }
    }
    if (savedSearchPlatform) {
      query["platform_id"] = savedSearchPlatform.value;
    }
    if (savedSearchRating) {
      query["rating"] = savedSearchRating.value;
    }
    if (savedSearchPublish) {
      query["publish"] = savedSearchPublish.value === "1" ? "True" : "False";
    }
    if (savedSearchOpenCase) {
      query["opencase"] = savedSearchOpenCase.value === "1" ? "True" : "False";
    }
    if (savedSearchAction) {
      query["takeaction"] = savedSearchAction.value === "1" ? "True" : "False";
    }
    if (savedSearchTags?.length > 0) {
      query["keyword"] = savedSearchTags;
    }
    const payload = {
      dashboard_id: resolveDashboardId(),
      search_name: savedSearchTitle,
      search_query: query,
    };
    const promise = apiRequest(
      "dashboards/saved-searches/add",
      "POST",
      payload,
      true
    );
    const timeout = new Promise((resolve) => setTimeout(resolve, 8000));
    const result = await Promise.race([promise, timeout]);
    if (result?.validation_error || result?.error) {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.create_saved_view"),
      });
    } else {
      notification.success({
        message: t("api_errors.saved_view_created", "Saved View created successfully"),
      });
    }
    setShowSavedSearchPopup(false);
    setCreateSavedSearchLoading(false);
  };

  useEffect(() => {
    if (!showSavedSearchPopup) {
      setSavedSearchSentiment(null);
      setSavedSearchIntent(null);
      setSavedSearchTitle("");
      setSavedSearchCheckedTopicIds([]);
      setSavedSearchSelectedTopicIds([]);
      setSavedSearchLevelWisePivotSelections({});
      setSavedSearchSelectedPivots({});
      setSavedSearchDateRange([]);
      setSavedSearchDaysRange("allTime");
      setSavedSearchPlatform(null);
      setSavedSearchRating(null);
      setSavedSearchPublish(null);
      setSavedSearchOpenCase(null);
      setSavedSearchAction(null);
      setCreateSavedSearchLoading(false);
      setSavedSearchTextWord("");
      setSavedSearchTags([]);
    }
  }, [showSavedSearchPopup]);

  useEffect(() => {
    if (savedSearchShowDateFilter) {
      setShowRangePicker(true);
    }
  }, [savedSearchShowDateFilter]);
  const basicDoughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    onHover: (event, chartElement) => {
      if (chartElement.length) {
        event.native.target.style.cursor = "pointer";
      } else {
        event.native.target.style.cursor = "default";
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          usePointStyle: true,
          color: theme === "dark" ? "white" : "black",
          font: {
            size: 12,
            color: theme === "dark" ? "white" : "black",
          },
          pointStyle: "circle",
          pointStyleWidth: 16,
          padding: 20,
          boxWidth: 12,
        },
        onHover: (event, chartElement) => {
          if (chartElement) {
            event.native.target.style.cursor = "pointer";
          } else {
            event.native.target.style.cursor = "default";
          }
        },
      },
      tooltip: {
        enabled: false,
        external: (context) => {
          // Tooltip Element
          var tooltipEl = document.getElementById("chartjs-tooltip");

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<div></div>";
            document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          const tooltipModel = context.tooltip;
          if (tooltipModel.opacity === 0) {
            if (tooltipEl) {
              tooltipEl.remove();
            }
            return;
          }
          // Set caret Position
          tooltipEl.classList.remove("above", "below", "no-transform");
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add("no-transform");
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            let innerHtml = "<div class=" + styles.driversTooltip + ">";
            const index = tooltipModel.dataPoints[0].dataIndex;
            const dataset = tooltipModel.dataPoints[0].dataset;
            const datasetLabel = tooltipModel.dataPoints[0].label;
            const datasetValue = tooltipModel.dataPoints[0].raw;
            innerHtml += `
            <div class=${styles.topicLabelInTooltip}>
              <span class=${styles.fillColor} style="background-color: ${dataset?.backgroundColor[index]}"></span>
              <span class=${styles.topicLabel}>${datasetLabel}: ${datasetValue}%</span>
            </div>`;
            innerHtml += "</div>";
            const tooltipRoot = tooltipEl.querySelector("div");
            tooltipRoot.innerHTML = innerHtml;
          }
          // this will be the overall tooltip
          const position = context.chart.canvas.getBoundingClientRect();

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = "absolute";
          let left = position.left + window.pageXOffset + tooltipModel.caretX;
          if (left + tooltipEl.offsetWidth > window.innerWidth) {
            left =
              position.left +
              window.pageXOffset / 2 +
              tooltipModel.caretX -
              tooltipEl.offsetWidth;
          }
          tooltipEl.style.left = left + "px";
          tooltipEl.style.top =
            position.top + window.pageYOffset + tooltipModel.caretY + "px";
          tooltipEl.style.padding =
            tooltipModel.padding + "px " + tooltipModel.padding + "px";
          tooltipEl.style.pointerEvents = "none";
        },
      },
      datalabels: {
        display: true,
        color: "white",
        font: {
          size: 9,
        },
        formatter: (value, context) => {
          // Hide labels for NaN or extremely small values (less than 0.1%)
          if (isNaN(value) || value < 1) {
            return "";
          }
          // Show whole numbers for larger values
          return Math.round(value) + "%";
        },
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
  };
  const presetDatesMap = {
    last24: t("filter.15"),
    last7d: t("filter.16"),
    last14d: t("filter.17"),
    last30d: t("filter.18"),
    last90d: t("filter.19"),
    custom: t("filter.20"),
    allTime: t("filter.21"),
  };
  useEffect(() => {
    if (savedSearchPivotFiltersApplied) {
      setTimeout(() => {
        setSavedSearchPivotFiltersApplied(false);
      }, 0.001);
    }
  }, [savedSearchPivotFiltersApplied]);

  const handleDownloadChartData = async (data, type) => {
    if (type === "Sentiment") {
      setDownloadSentimentChartsDataLoading(true);
    } else {
      setDownloadRatingChartsDataLoading(true);
    }
    const processData = (topics, type) => {
      let rows = [];
      let serialNumber = 1;

      const processTopics = (topics) => {
        topics.forEach((topic) => {
          if (type === "Sentiment") {
            const positive = topic.sentiment["1.0"];
            const negative = topic.sentiment["0.0"];
            const neutral = topic.sentiment["0.5"];
            const unspecified = topic.sentiment["-1"];

            rows.push({
              "S.No": serialNumber++,
              TopicId: topic.id,
              Label: topic.label,
              "Positive %": positive.percentage,
              "Positive Count": positive.value,
              "Negative %": negative.percentage,
              "Negative Count": negative.value,
              "Neutral %": neutral.percentage,
              "Neutral Count": neutral.value,
              "Unspecified %": unspecified.percentage,
              "Unspecified Count": unspecified.value,
              "Contribution to Rating": topic.potential || 0,
            });
          } else if (type === "Rating") {
            rows.push({
              "S.No": serialNumber++,
              TopicId: topic.id,
              Label: topic.label,
              "Avg. Rating": topic.rating.value,
              "Reviews Count": topic.rating.reviewsCount,
              "Contribution to Rating": topic.potential || 0,
            });
          }

          // Process child topics
          if (topic.child && topic.child.length > 0) {
            processTopics(topic.child);
          }
        });
      };

      processTopics(topics);
      return rows;
    };

    // Flatten and process the data
    const drows = processData(data, type);

    const headers =
      type === "Sentiment"
        ? [
            [
              "S.No",
              "TopicId",
              "Label",
              "Positive",
              null,
              "Negative",
              null,
              "Neutral",
              null,
              "Unspecified",
              null,
              "Contribution to Rating",
            ],
            [
              "",
              "",
              "",
              "%",
              "Count",
              "%",
              "Count",
              "%",
              "Count",
              "%",
              "Count",
              "",
            ],
          ]
        : [
            [
              "S.No",
              "TopicId",
              "Label",
              "Avg. Rating",
              "Reviews Count",
              "Contribution to Rating",
            ],
          ];

    const dataRows = drows?.map((row) =>
      type === "Sentiment"
        ? [
            row["S.No"],
            row.TopicId,
            row.Label,
            row["Positive %"],
            row["Positive Count"],
            row["Negative %"],
            row["Negative Count"],
            row["Neutral %"],
            row["Neutral Count"],
            row["Unspecified %"],
            row["Unspecified Count"],
            row["Contribution to Rating"],
          ]
        : [
            row["S.No"],
            row.TopicId,
            row.Label,
            row["Avg. Rating"],
            row["Reviews Count"],
            row["Contribution to Rating"],
          ]
    );

    // Combine headers and data
    const worksheetData = [...headers, ...dataRows];

    const since = params.get("since");
    const until = params.get("until");
    const fileName =
      since && until
        ? `${type}_chartdata_${since}_${until}.xlsx`
        : `${type}_chartdata_alltime.xlsx`;

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Topics");

    // Merge headers
    if (type === "Sentiment") {
      worksheet["!merges"] = [
        { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // Merges cells at (0,3) and (0,4)
        { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } }, // Merges cells at (0,5) and (0,6)
        { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }, // Merges cells at (0,7) and (0,8)
        { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } }, // Merges cells at (0,9) and (0,10)
      ];
    }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const response = await apiRequest(
      "dashboards/presigned_post",
      "POST",
      {
        filename: fileName,
      },
      true
    );
    if (response?.success) {
      const fileUrl = response.success;
      const result = await uploadFileToS3(
        fileUrl,
        fileBlob,
        setChartDataDownloadProgress
      );
      if (result) {
        const presignedUrl = await apiRequest("dashboards/store", "POST", {
          key: fileUrl?.fields?.key,
          dashboard_id: parseInt(initialState.currentDashboard, 10),
          type: type,
        });
        if (presignedUrl?.success) {
          notification.success({
            message: (
              <span>
                {t("notifications.47")}.
                <br />
                Go to{" "}
                <a
                  onClick={() => {
                    history.push("/console/report?page=download");
                  }}
                >
                  Exports page
                </a>
              </span>
            ),
          });
        } else {
          notification.error({
            message: t("notifications.73"),
          });
        }
      } else {
        notification.error({
          message: t("notifications.73"),
        });
      }
    } else {
      notification.error({
        message: t("notifications.73"),
      });
    }
    setDownloadSentimentChartsDataLoading(false);
    setDownloadRatingChartsDataLoading(false);
  };

  const [fraudDoughnutData, setFraudDoughnutData] = useState([]);
  const [isFraudDoughnutDataLoading, setIsFraudDoughnutDataLoading] = useState(
    true
  );
  const initFraudDoughnutData = (fraud_dist = {}) => {
    if (fraud_dist && Object.keys(fraud_dist).length > 0) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];
      const total = Object.values(fraud_dist).reduce((a, b) => a + b, 0);

      Object.keys(fraud_dist).forEach((key) => {
        const count = fraud_dist[key];
        const percent = total > 0 ? ((count / total) * 100).toFixed(2) : 0;
        let label, color;
        if (key === false || key === "false") {
          label = "Fraud";
          color = "#F44336"; // red
        } else if (key === "true" || key === true) {
          label = "Not Fraud";
          color = "#4CAF50"; // green
        } else {
          label = `${key} (${count}, ${percent}%)`;
          color = "#FFA726"; // orange for unknown
        }
        datas.push(percent);
        labels.push(label);
        backgroundColors.push(color);
        hoverBackgroundColors.push(color);
      });

      const fraudData = {
        maintainAspectRatio: false,
        responsive: true,
        text: "Fraud",
        labels: labels,
        ids: Object.keys(fraud_dist),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setFraudDoughnutData(fraudData);
    } else {
      setFraudDoughnutData({});
    }
    setIsFraudDoughnutDataLoading(false);
  };

  const handleTermBlacklisted = (blacklistedTerm, termType) => {
    // Update the hottermsData to remove the blacklisted term
    if (hottermsData && hottermsData[termType]) {
      const updatedHottermsData = { ...hottermsData };
      updatedHottermsData[termType] = hottermsData[termType].filter(
        (term) => term.terms !== blacklistedTerm
      );
      setHottermsData(updatedHottermsData);
    }
  };

  return (
    <div className={styles.mainWindow}>
      {/* <ScrollToReviews /> */}
      <DashboardPageChrome>
        <DashboardHeader
          generalDataSrc
          shared={shared}
          currentDashboardHash={match.params.id}
          disableDateBtn={
            reviewsLoading || topTopicsLoading || isRestaurantDoughnutDataLoading
          }
          setChangeDateRange={setChangeDateRange}
          savedSearch={savedSearch}
        />
        {!shared && <NestedTabs />}
      </DashboardPageChrome>
      <div className={styles.savedSearchInfo}>
        {savedSearch && (
          <div className={styles.savedSearchTextContainer}>
            <span className={styles.savedSearchText}>
              <Trans
                i18nKey="selected_dashboard_page.139"
                t={t}
                values={{ searchName: params.get("savedSearchName") }}
                tOptions={{ interpolation: { escapeValue: false } }}
              />
            </span>
            <CloseOutlined
              style={{ color: "white" }}
              onClick={() => {
                [
                  "start_index",
                  "page_offset",
                  "sentiment",
                  "intent",
                  "since",
                  "until",
                  "daysRange",
                  "rating",
                  "top_topics",
                  "topics_operator",
                  "platform_id",
                  "match_date",
                  "hotterm",
                  "nps",
                  "keyword",
                  "pivotFilter",
                  "pivots_operator",
                  "decisionFilter",
                  "cursor_next",
                  "cursor_curr",
                  "cursor_before",
                  "savedSearchID",
                  "child_others",
                  "parent_others",
                  "fraud",
                ].forEach((item) => params.delete(item));
                if (
                  !DashboardReducer.dashboard_end_date &&
                  !DashboardReducer.dashboard_start_date
                ) {
                  params.append("daysRange", "allTime");
                  dispatch({
                    type: actions.UPDATE_SEARCH_STATE,
                    payload: {
                      selectedDaysRange: "allTime",
                      dateRange: [],
                    },
                  });
                } else {
                  // Create a dateRange array for last 24 hrs with the end_date
                  const cd = new Date(
                    DashboardReducer.dashboard?.RefreshRate
                      ? new Date()
                      : DashboardReducer.dashboard_end_date
                  );
                  const pd = new Date(
                    DashboardReducer.dashboard?.RefreshRate
                      ? new Date()
                      : DashboardReducer.dashboard_end_date
                  );
                  cd.setDate(cd.getDate());
                  pd.setDate(pd.getDate());
                  pd.setDate(pd.getDate() - 1);
                  const formattedCurrentDate = cd.toISOString().split("T")[0];
                  const formattedPastDate = pd.toISOString().split("T")[0];
                  params.append("since", formattedPastDate);
                  params.append("until", formattedCurrentDate);
                  params.append("daysRange", "last24");
                  dispatch({
                    type: actions.UPDATE_SEARCH_STATE,
                    payload: {
                      selectedDaysRange: "last24",
                      dateRange: [formattedPastDate, formattedCurrentDate],
                    },
                  });
                }
                setSavedSearch(false);
                params.append("start_index", 0);
                params.append("page_offset", 10);
                history.push({ search: params.toString() });
              }}
            />
          </div>
        )}
      </div>
      {filters.length > 0 && (
        <div className={styles.searchFilters}>
          <div className={styles.filterFirstRow}>{filters}</div>
          <div
            className={styles.reset}
            onClick={() => {
              handleResetFilter();
            }}
          >
            {t("selected_dashboard_page.5")}
          </div>
        </div>
      )}
      <Spin spinning={DashboardReducer.loading}>
        <div className={styles.dropdownFilter}>
          <div className={styles.pivotFilterBar}>
            {multiLevelOptions &&
              Object.keys(multiLevelOptions?.level1)?.length > 0 &&
              !reviewsLoading && (
                <PivotTwoPaneFilter
                  title={
                    <span className={styles.pivotFilters}>
                      {t("selected_dashboard_page.138")}
                    </span>
                  }
                  levelWiseOptions={multiLevelOptions}
                  levelWiseSelections={levelWisePivotSelections}
                  setLevelWiseSelections={setLevelWisePivotSelections}
                  reset={handleResetPivotFilters}
                  apply={(val) => handleApplyPivotFilters(val)}
                  disabled={savedSearch && isStatic}
                  selectedFilterType={selectedPivotsOperator}
                  setSelectedFilterType={setSelectedPivotsOperator}
                />
              )}
          </div>
          <span className={styles.savedSearchPopupBtn}>
            <span
              className={styles.savedSearchBtn}
              onClick={() => setShowSavedSearchPopup(true)}
            >
              <img
                className={styles.message_img}
                src={
                  theme === "dark"
                    ? "/assets/saved_search.svg"
                    : "/assets/saved_search_black.svg"
                }
                width={24}
                height={24}
              />
            </span>
          </span>
        </div>
        <div className={styles.analysisContainer}>
          {
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>
                    {filters.length > 0
                      ? t("selected_dashboard_page.73")
                      : t("selected_dashboard_page.7")}
                  </span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.filtered_data.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.filtered_data.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
            >
              <Spin spinning={isSentimentDoughnutDataLoading}>
                <div className={styles.dataWrapper}>
                  <span>{rawData}</span>
                </div>
              </Spin>
            </BoardCard>
          }

          {ratingBreakdown && Object.keys(ratingBreakdown).length > 0 && (
            <BoardCard title="App Rating">
              <Spin spinning={isSentimentDoughnutDataLoading}>
                <AppRatingCard
                  data={ratingBreakdown}
                  theme={theme}
                  reviewsAvgRating={avgRating}
                />
              </Spin>
            </BoardCard>
          )}
          {(platformData?.datasets &&
            (DashboardReducer?.dashboard?.PlatformId === 11 ||
              DashboardReducer?.dashboard?.PlatformId === 12 ||
              DashboardReducer?.dashboard?.PlatformId === 13) && (
              <BoardCard
                title={
                  <span className={styles.KDATitle}>
                    <span>{t("selected_dashboard_page.97")}</span>
                    <Tooltip
                      title={
                        params.get("since") && params.get("until")
                          ? t("dashboard_tooltips.platform.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                          : t("dashboard_tooltips.platform.2")
                      }
                      color="#100D31"
                    >
                      <img
                        className={styles.message_img}
                        src={
                          theme === "dark"
                            ? "/assets/info1.svg"
                            : "/assets/info1_black.svg"
                        }
                      />
                    </Tooltip>
                  </span>
                }
                id="Platform-Analysis"
              >
                <div className={styles.doughnutWrapper}>
                  <Spin spinning={isPlatformDoughnutDataLoading}>
                    <CustomChart
                      data={platformData}
                      height={150}
                      type="doughnut"
                      options={{
                        ...basicDoughnutOptions,
                        onClick: (e) => {
                          var point = e.chart?.getElementsAtEventForMode(
                            e,
                            "nearest",
                            {
                              intersect: true,
                            }
                          );
                          if (point?.length > 0) {
                            handleDoughnutClick(point[0], "platform");
                          } else {
                            return;
                          }
                        },
                        plugins: {
                          ...basicDoughnutOptions.plugins,
                          legend: {
                            ...basicDoughnutOptions.plugins.legend,
                            onClick: (event, legendItem) => {
                              handleDoughnutClick(legendItem, "platform");
                            },
                          },
                        },
                      }}
                      theme={theme}
                    />
                  </Spin>
                </div>
              </BoardCard>
            )) || <></>}
        </div>
        {
          <div className={styles.analysisContainer}>
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{`${t("selected_dashboard_page.60")}🔥`}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.hotterms.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.hotterms.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
            >
              <div className={styles.container}>
                <HotTerms
                  allNgrams={hottermsData}
                  loading={hottermsLoading}
                  setLoading={setHottermsLoading}
                  overLimit={overLimitForHotterms}
                  disableSelection={
                    (savedSearch && isStatic) ||
                    topTopicsLoading ||
                    reviewsLoading ||
                    isRestaurantDoughnutDataLoading
                  }
                  onTermBlacklisted={handleTermBlacklisted}
                />
              </div>
            </BoardCard>
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("others.42")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.top_topics.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.top_topics.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
            >
              <Spin spinning={topTopicsLoading}>
                <div className={styles.container}>
                  <TopTopics
                    data={topTopics}
                    topTopicsLoading={topTopicsLoading}
                    disableTopTopicsBtn={savedSearch && isStatic}
                    applyDisabled={
                      reviewsLoading ||
                      topTopicsLoading ||
                      participationPeriodLoading ||
                      topicRatingsLoading ||
                      hottermsLoading ||
                      decisionDataLoading ||
                      driverAnalysisLoading ||
                      isIntentDoughnutDataLoading ||
                      isRatingDoughnutDataLoading ||
                      isSentimentDoughnutDataLoading ||
                      isAvgSentimentGaugeDataLoading ||
                      isPlatformDoughnutDataLoading ||
                      isRestaurantDoughnutDataLoading
                    }
                    selectedTopTopics={selectedTopTopics}
                    setSelectedTopTopics={setSelectedTopTopics}
                    checkedTopicIds={checkedTopicIds}
                    setCheckedTopicIds={setCheckedTopicIds}
                    selectedTopicIds={selectedTopicIds}
                    setSelectedTopicIds={setSelectedTopicIds}
                    boardType="dashboard"
                    handleClearAll={handleClearAllTopTopics}
                  />
                </div>
              </Spin>
            </BoardCard>
          </div>
        }
        {
          <div>
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.96")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.kda.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.kda.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                      // onClick={() => {
                      //   const win = window.open(
                      //     "https://pivony.notion.site/Key-drivers-analysis-KDA-94a067596db74855b74ffc2c511bef4d#510a8b02c3514c7baf3e4ae9ca75e183",
                      //     "_blank"
                      //   );
                      //   win.focus();
                      // }}
                    />
                  </Tooltip>
                </span>
              }
              extra={
                <div className={styles.keyDriverActions}>
                  {!emptyDriverAnalysis && (
                    <>
                      {/* Edit button - only show when not static saved view */}
                      {(!savedSearch || !isStatic) && (
                        <img
                          className={styles.message_img}
                          src={
                            theme === "dark"
                              ? "/assets/edit_icon.svg"
                              : "/assets/edit_icon_black.svg"
                          }
                          onClick={() => {
                            !driverAnalysisLoading && getKeyDriversConfig();
                          }}
                          width={20}
                          height={20}
                        />
                      )}

                      {/* Delete button - only show when not static saved view */}
                      {(!savedSearch || !isStatic) && (
                        <img
                          className={styles.message_img}
                          src={
                            theme === "dark"
                              ? "/assets/delete_icon.svg"
                              : "/assets/delete_icon_black.svg"
                          }
                          onClick={() => {
                            if (!driverAnalysisLoading) {
                              setDriverAnalysisData([]);
                              deleteDriverAnalysis();
                            }
                          }}
                          width={20}
                          height={20}
                        />
                      )}
                    </>
                  )}
                </div>
              }
            >
              <Spin spinning={driverAnalysisLoading}>
                {emptyDriverAnalysis ? (
                  <div
                    className={styles.emptyDriverAnalysis}
                    onClick={() => {
                      if (savedSearch && isStatic) {
                        return;
                      }
                      setShowPopupSequence(true);
                      getOutcomeMetricsList();
                    }}
                  >
                    <span className={styles.displayMsg}>
                      <PlusOutlined
                        style={{
                          fontSize: "14px",
                          width: "14px",
                          height: "14px",
                        }}
                      />{" "}
                      {t("selected_dashboard_page.108")}
                    </span>
                  </div>
                ) : (
                  <div className={styles.bubbleWrapper}>
                    <div className={styles.bubbleChartWrapper}>
                      {noDataForSelectedConfig ? (
                        <div className={styles.noDataForSelectedConfig}>
                          <span className={styles.emptyMsg}>
                            No data available
                          </span>
                          {(!savedSearch || !isStatic) && (
                            <span
                              className={styles.redirectBtn}
                              onClick={() => {
                                getKeyDriversConfig();
                              }}
                            >
                              Edit Configuration
                            </span>
                          )}
                        </div>
                      ) : (
                        <>
                          {driverAnalysisData && driverAnalysisData.length > 0 && (
                            <div className={styles.tableWidget}>
                              <div className={styles.scrollIndicator}>
                                <span>← Scroll to see more columns →</span>
                              </div>
                              <Table
                                dataSource={convertIntoTableData(
                                  driverAnalysisData
                                )}
                                columns={[
                                  {
                                    title: "Topic",
                                    dataIndex: "topic",
                                    key: "topic",
                                    width: 180,
                                    ellipsis: true,
                                    render: (text, record) => (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "10px",
                                            height: "10px",
                                            borderRadius: "50%",
                                            backgroundColor: record.color,
                                            flexShrink: 0,
                                          }}
                                        />
                                        <span style={{ fontSize: "13px" }}>
                                          {text}
                                        </span>
                                      </div>
                                    ),
                                  },
                                  {
                                    title: "Performance",
                                    dataIndex: "performance",
                                    key: "performance",
                                    width: 80,
                                    align: "right",
                                    render: (value) =>
                                      value?.toFixed(2) || "0.00",
                                    sorter: (a, b) =>
                                      a.performance - b.performance,
                                  },
                                  {
                                    title: "Importance",
                                    dataIndex: "importance",
                                    key: "importance",
                                    width: 80,
                                    align: "right",
                                    render: (value) =>
                                      value?.toFixed(2) || "0.00",
                                    sorter: (a, b) =>
                                      a.importance - b.importance,
                                  },
                                  {
                                    title: "Sample Size",
                                    dataIndex: "sampleSize",
                                    key: "sampleSize",
                                    width: 80,
                                    align: "right",
                                    render: (value) =>
                                      new Intl.NumberFormat(
                                        getIntlLocale(i18n.language),
                                      ).format(value ?? 0),
                                    sorter: (a, b) =>
                                      a.sampleSize - b.sampleSize,
                                  },
                                  // Optional columns - only show if data exists
                                  ...(driverAnalysisData?.some(
                                    (d) => d.topic_impact_rating
                                  )
                                    ? [
                                        {
                                          title: "Impact Over Rating",
                                          dataIndex: "topicImpactRating",
                                          key: "topicImpactRating",
                                          width: 100,
                                          align: "right",
                                          render: (value) =>
                                            value ? value.toFixed(2) : "N/A",
                                          sorter: (a, b) =>
                                            (a.topicImpactRating || 0) -
                                            (b.topicImpactRating || 0),
                                        },
                                      ]
                                    : []),
                                  ...(driverAnalysisData?.some(
                                    (d) => d.top_intent
                                  )
                                    ? [
                                        {
                                          title: "Top Intent",
                                          dataIndex: "topIntent",
                                          key: "topIntent",
                                          width: 100,
                                          ellipsis: true,
                                          render: (value) => value || "N/A",
                                        },
                                      ]
                                    : []),
                                  ...(driverAnalysisData?.some(
                                    (d) => d.negative_sentiment_percentage
                                  )
                                    ? [
                                        {
                                          title: "% Negative",
                                          dataIndex:
                                            "negative_sentiment_percentage",
                                          key: "negative_sentiment_percentagee",
                                          width: 80,
                                          align: "right",
                                          render: (value) =>
                                            value
                                              ? `${value.toFixed(1)}%`
                                              : "N/A",
                                          sorter: (a, b) =>
                                            a.negative_sentiment_percentage -
                                            b.negative_sentiment_percentage,
                                        },
                                      ]
                                    : []),
                                ]}
                                pagination={{
                                  pageSize: 10,
                                  position: ["bottomRight"],
                                  showQuickJumper: false,
                                  size: "small",
                                  showSizeChanger: true,
                                }}
                                scroll={{ x: 800, y: 400 }}
                                size="small"
                                className={styles.tableContainer}
                                responsive={true}
                                locale={{
                                  emptyText: (
                                    <div className={styles.noDataMessage}>
                                      No data available
                                    </div>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </Spin>
            </BoardCard>
          </div>
        }
        {/* <div className={styles.numericDataContainer}>
          {DashboardReducer.boardData.UniqueUsers && DashboardReducer.dashboard?.PlatformId !== 2 &&
            DashboardReducer.boardData.UniqueUsers !== 0 &&
            DashboardReducer?.dashboard?.PlatformId !== 11 && (
                <BoardCard title="Total Users">
                  <span>{DashboardReducer.boardData.UniqueUsers || 0}</span>
                </BoardCard>
              )}
          {npScore !== 0 && <BoardCard title={"NPS"}>
            <Spin spinning={isSentimentDoughnutDataLoading}>
              <div className={styles.dataWrapper}>
                <span>{npScore}</span>
                <span>of {overalNps}</span>
              </div>
            </Spin>
            <span className={styles.indicator}></span>
          </BoardCard>
          }
        </div>
        <div className={styles.analysisContainer}></div> */}
        {npsInfo && Object.keys(npsInfo).length !== 0 && (
          <div className={styles.analysisContainer}>
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>
                    {npsScale[1] === 5
                      ? t("selected_dashboard_page.100")
                      : t("selected_dashboard_page.99")}
                  </span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? npsScale[1] === 5
                          ? t("dashboard_tooltips.voc.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                          : t("dashboard_tooltips.nps.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                        : npsScale[1] === 5
                        ? t("dashboard_tooltips.voc.2")
                        : t("dashboard_tooltips.nps.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="nps-score"
            >
              <Spin spinning={isAvgSentimentGaugeDataLoading}>
                <div className={styles.npsChart}>
                  <GaugeChart
                    animate={false}
                    className={styles.sentimentGauge}
                    id="gauge-chart2"
                    nrOfLevels={3}
                    needleColor={
                      theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"
                    }
                    needleBaseColor={
                      theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"
                    }
                    textColor={theme === "dark" ? "white" : "black"}
                    percent={
                      npsScale[1] === 5
                        ? (avgRating - 1) / 4
                        : npsInfo?.nps < 0
                        ? 0.5 - Math.abs(npsInfo?.nps) / 2
                        : 0.5 + npsInfo?.nps / 2
                    }
                    width={200}
                    colors={["#AA2B0E", "#FFA800", "#00B07B"]}
                    formatTextValue={() => {
                      return npsScale[1] === 5
                        ? parseFloat(avgRating)
                        : parseFloat(npsInfo?.nps * 100).toFixed(0);
                    }}
                  />
                </div>
                <div className={styles.npsBarTitle}>{t("label.17")}</div>
                <div className={styles.npsBar}>
                  {npsInfo?.detractors > 0 && (
                    <div className={styles.barPercent}>
                      <span
                        onClick={() => {
                          handleNPSFilter("detractors");
                        }}
                        className={styles.color0}
                        style={{ width: `${npsInfo.detractors * 2}px` }}
                      ></span>
                      <span className={styles.percent}>
                        {npsInfo?.detractors}%
                      </span>
                    </div>
                  )}
                  {npsInfo?.passives > 0 && (
                    <div className={styles.barPercent}>
                      <span
                        onClick={() => {
                          handleNPSFilter("neutrals");
                        }}
                        className={styles.color2}
                        style={{ width: `${npsInfo.passives * 2}px` }}
                      ></span>
                      <span className={styles.percent}>
                        {npsInfo?.passives}%
                      </span>
                    </div>
                  )}
                  {npsInfo?.promoters > 0 && (
                    <div className={styles.barPercent}>
                      <span
                        onClick={() => {
                          handleNPSFilter("promoters");
                        }}
                        className={styles.color3}
                        style={{ width: `${npsInfo.promoters * 2}px` }}
                      ></span>
                      <span className={styles.percent}>
                        {npsInfo?.promoters}%
                      </span>
                    </div>
                  )}
                </div>
                {npsInfo?.detractors > 0 && (
                  <div className={styles.npsBarTitle}>
                    {t("selected_dashboard_page.149")}
                  </div>
                )}
                <div className={styles.npsBar}>
                  {npsInfo?.deep_detractors > 0 && (
                    <div className={styles.barPercent}>
                      <span
                        onClick={() => {
                          handleNPSFilter("deep detractors");
                        }}
                        className={styles.color01}
                        style={{ width: `${npsInfo.deep_detractors * 2}px` }}
                      ></span>
                      <span className={styles.percent}>
                        {npsInfo?.deep_detractors}%
                      </span>
                    </div>
                  )}
                  {npsInfo?.detractors2 > 0 && (
                    <div className={styles.barPercent}>
                      <span
                        onClick={() => {
                          handleNPSFilter("other detractors");
                        }}
                        className={styles.color02}
                        style={{ width: `${npsInfo.detractors2 * 2}px` }}
                      ></span>
                      <span className={styles.percent}>
                        {npsInfo?.detractors2}%
                      </span>
                    </div>
                  )}
                </div>
                <div className={styles.npsLabels}>
                  <div className={styles.labelItem0}>
                    <span></span>
                    {`${t("selected_dashboard_page.149")} [${
                      npsScale[1] === 5 ? `1-3` : `0-6`
                    }]`}
                  </div>
                  <div className={styles.labelItem01}>
                    <span></span>
                    {`${t("selected_dashboard_page.148")} [${
                      npsScale[1] === 5 ? `1-2` : `0-3`
                    }]`}
                  </div>
                  <div className={styles.labelItem02}>
                    <span></span>
                    {`${t("selected_dashboard_page.150")} [${
                      npsScale[1] === 5 ? `3` : `4-6`
                    }]`}
                  </div>
                  <div className={styles.labelItem1}>
                    <span></span>
                    {`${t("selected_dashboard_page.151")} [${
                      npsScale[1] === 5 ? 4 : `7-8`
                    }]`}
                  </div>
                  <div className={styles.labelItem2}>
                    <span></span>
                    {`${t("selected_dashboard_page.152")} [${
                      npsScale[1] === 5 ? 5 : `9-10`
                    }]`}
                  </div>
                </div>
              </Spin>
            </BoardCard>
          </div>
        )}
        <div className={styles.numericDataContainer}>
          {(DashboardReducer.boardData.hasOwnProperty("BotAccounts") && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.9")}</span>
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </span>
              }
            >
              <span>{DashboardReducer?.boardData?.BotAccounts || 0}</span>
            </BoardCard>
          )) || <></>}
        </div>
        <div className={styles.ac}>
          {intentDoughnutData?.length !== 0 && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.12")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.intent.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.intent.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Intent-Analysis"
            >
              <div className={styles.doughnutWrapper}>
                <Spin spinning={isIntentDoughnutDataLoading}>
                  <CustomChart
                    data={intentDoughnutData}
                    type="doughnut"
                    height={150}
                    options={{
                      ...basicDoughnutOptions,
                      onClick: (e) => {
                        var point = e.chart?.getElementsAtEventForMode(
                          e,
                          "nearest",
                          {
                            intersect: true,
                          }
                        );
                        if (point?.length > 0) {
                          handleDoughnutClick(point[0], "intent");
                        } else {
                          return;
                        }
                      },
                      plugins: {
                        ...basicDoughnutOptions.plugins,
                        legend: {
                          ...basicDoughnutOptions.plugins.legend,
                          onClick: (event, legendItem) => {
                            handleDoughnutClick(legendItem, "intent");
                          },
                        },
                      },
                    }}
                    theme={theme}
                  />
                </Spin>
              </div>
            </BoardCard>
          )}
        </div>
        <div className={styles.ac}>
          {avgSentiment ? (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.10")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.avg_sent.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.avg_sent.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Overall-Sentiment-Analysis"
            >
              <Spin spinning={isAvgSentimentGaugeDataLoading}>
                <GaugeChart
                  animate={false} //setting animate ti true can crush the application there is an issue in this part vs sunburst d3
                  className={styles.sentimentGauge}
                  id="gauge-chart2"
                  nrOfLevels={3}
                  percent={avgSentiment || 0}
                  formatTextValue={(text) => {
                    return text;
                  }}
                  textColor={theme === "dark" ? "white" : "black"}
                  width={200}
                  colors={[
                    "rgba(220, 37, 37, 1)",
                    "rgb(255, 255, 0)",
                    "rgba(16, 200, 0, 1)",
                  ]}
                  needleColor={theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"}
                  needleBaseColor={
                    theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"
                  }
                />
              </Spin>
            </BoardCard>
          ) : (
            <></>
          )}
          {(sentimentDoughnutData?.datasets && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.11")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.sentiment.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.sentiment.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Detailed-Sentiment-Analysis"
            >
              <div className={styles.doughnutWrapper}>
                <Spin spinning={isSentimentDoughnutDataLoading}>
                  <CustomChart
                    data={sentimentDoughnutData}
                    type="doughnut"
                    height={150}
                    options={{
                      ...basicDoughnutOptions,
                      onClick: (e) => {
                        var point = e.chart?.getElementsAtEventForMode(
                          e,
                          "nearest",
                          {
                            intersect: true,
                          }
                        );
                        if (point?.length > 0) {
                          handleDoughnutClick(point[0], "sentiment");
                        } else {
                          return;
                        }
                      },
                      plugins: {
                        ...basicDoughnutOptions.plugins,
                        legend: {
                          ...basicDoughnutOptions.plugins.legend,
                          onClick: (event, legendItem) => {
                            handleDoughnutClick(legendItem, "sentiment");
                          },
                        },
                      },
                    }}
                    theme={theme}
                  />
                </Spin>
              </div>
            </BoardCard>
          )) || <></>}
          {fraudDoughnutData &&
            fraudDoughnutData.labels &&
            fraudDoughnutData.labels.length > 0 && (
              <BoardCard
                title={
                  <span className={styles.KDATitle}>
                    {t("selected_dashboard_page.166")}
                  </span>
                }
                id="FraudDoughnut"
              >
                <div className={styles.doughnutWrapper}>
                  <Spin spinning={isFraudDoughnutDataLoading}>
                    <CustomChart
                      data={fraudDoughnutData}
                      type="doughnut"
                      height={150}
                      options={{
                        ...basicDoughnutOptions,
                        onClick: (e) => {
                          var point = e.chart?.getElementsAtEventForMode(
                            e,
                            "nearest",
                            {
                              intersect: true,
                            }
                          );
                          if (point?.length > 0) {
                            handleDoughnutClick(point[0], "fraud");
                          } else {
                            return;
                          }
                        },
                        plugins: {
                          ...basicDoughnutOptions.plugins,
                          legend: {
                            ...basicDoughnutOptions.plugins.legend,
                            onClick: (event, legendItem) => {
                              handleDoughnutClick(legendItem, "fraud");
                            },
                          },
                        },
                      }}
                      theme={theme}
                    />
                  </Spin>
                </div>
              </BoardCard>
            )}

          {ratingDoughnutData && ratingDoughnutData["labels"]?.length > 0 && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.13")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.rating.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.rating.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Rating-Analysis"
            >
              <div className={styles.doughnutWrapper}>
                <Spin spinning={isRatingDoughnutDataLoading}>
                  <CustomChart
                    data={ratingDoughnutData}
                    type="doughnut"
                    height={150}
                    options={{
                      ...basicDoughnutOptions,
                      onClick: (e) => {
                        var point = e.chart?.getElementsAtEventForMode(
                          e,
                          "nearest",
                          {
                            intersect: true,
                          }
                        );
                        if (point?.length > 0) {
                          handleDoughnutClick(point[0], "rating");
                        } else {
                          return;
                        }
                      },
                      plugins: {
                        ...basicDoughnutOptions.plugins,
                        legend: {
                          ...basicDoughnutOptions.plugins.legend,
                          onClick: (event, legendItem) => {
                            handleDoughnutClick(legendItem, "rating");
                          },
                        },
                      },
                    }}
                    theme={theme}
                  />
                </Spin>
              </div>
            </BoardCard>
          )}
          {volumeDaily && volumeDaily.length > 0 && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.15")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.vol_daily.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.vol_daily.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Time-based-Participation"
              extra={
                <span>
                  <Dropdown
                    trigger={["click"]}
                    overlay={() => timePeriodOptions("participation")}
                  >
                    <Button
                      style={{
                        color: theme === "dark" ? "#fff" : "#000",
                        backgroundColor: theme === "dark" ? "#1C193B" : "#fff",
                        border: 0,
                      }}
                      disabled={savedSearch && isStatic}
                    >
                      {participationPeriod ||
                        (volumeDaily &&
                          volumeDaily.length > 0 &&
                          determinePeriod(volumeDaily[0].day)) ||
                        "Daily"}
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </span>
              }
            >
              <Spin spinning={participationPeriodLoading}>
                <LineChartWrapper
                  id="Time-based Participation"
                  period={switchPeriod ? switchPeriod : dateBasedChartsPeriod}
                  VolumeDaily={
                    participationPeriodLoading
                      ? []
                      : volumeDaily.length
                      ? volumeDaily
                      : []
                  }
                  allData={allData}
                  clickable={savedSearch && isStatic ? false : true}
                />
              </Spin>
            </BoardCard>
          )}
          {(sentimentPeriodLoading ||
            (sentimentDaily && sentimentDaily.length > 0)) && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.16")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.sent_daily.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.sent_daily.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Time-based-Sentiment"
              extra={
                <span>
                  <Dropdown
                    trigger={["click"]}
                    overlay={() => timePeriodOptions("sentiment")}
                  >
                    <Button
                      style={{
                        color: theme === "dark" ? "#fff" : "#000",
                        backgroundColor: theme === "dark" ? "#1C193B" : "#fff",
                        border: 0,
                      }}
                      disabled={savedSearch && isStatic}
                    >
                      {sentimentPeriod ||
                        (sentimentDaily &&
                          sentimentDaily.length > 0 &&
                          determinePeriod(sentimentDaily[0].day)) ||
                        "Daily"}
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </span>
              }
            >
              <Spin spinning={sentimentPeriodLoading}>
                <LineChartWrapper
                  period={switchPeriod ? switchPeriod : dateBasedChartsPeriod}
                  SentimentDaily={
                    sentimentPeriodLoading
                      ? []
                      : sentimentDaily.length
                      ? sentimentDaily
                      : []
                  }
                  allData={allData}
                  clickable={savedSearch && isStatic ? false : true}
                />
              </Spin>
            </BoardCard>
          )}

          {(ratingPeriodLoading ||
            (Time_Daily_Rating &&
              Object.keys(Time_Daily_Rating).length > 0 &&
              timerating)) && (
              <BoardCard
                title={
                  <span className={styles.KDATitle}>
                    <span>{t("selected_dashboard_page.14")}</span>
                    <Tooltip
                      title={
                        params.get("since") && params.get("until")
                          ? t("dashboard_tooltips.rat_daily.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                          : t("dashboard_tooltips.rat_daily.2")
                      }
                      color="#100D31"
                    >
                      <img
                        className={styles.message_img}
                        src={
                          theme === "dark"
                            ? "/assets/info1.svg"
                            : "/assets/info1_black.svg"
                        }
                      />
                    </Tooltip>
                  </span>
                }
                id="Time-based Ratings"
                extra={
                  <span>
                    <Dropdown
                      trigger={["click"]}
                      overlay={() => timePeriodOptions("Time-based_Ratings")}
                    >
                      <Button
                        style={{
                          color: theme === "dark" ? "#fff" : "#000",
                          backgroundColor:
                            theme === "dark" ? "#1C193B" : "#fff",
                          border: 0,
                        }}
                        disabled={savedSearch && isStatic}
                      >
                        {ratingsPeriod || "Daily"}
                        <DownOutlined />
                      </Button>
                    </Dropdown>
                  </span>
                }
              >
                <Spin spinning={ratingPeriodLoading}>
                  <LineChartWrapper
                    id="Time-based Participation"
                    Time_Rating={timerating}
                    Time_Daily_Rating={Time_Daily_Rating || {}}
                    period={switchPeriod ? switchPeriod : dateBasedChartsPeriod}
                    allData={allData}
                    clickable={savedSearch && isStatic ? false : true}
                  />
                </Spin>
              </BoardCard>
            )}
        </div>
        <div className={styles.ac}>
          {(topicRatingsLoading ||
            (topicRatingData &&
              topicRatingData.length > 0 &&
              !topicRatingData
                .map((t) => t?.rating?.value)
                .every((t) => parseInt(t, 10) === 0))) && (
              <BoardCard
                title={
                  <span className={styles.KDATitle}>
                    <span>{t("selected_dashboard_page.84")}</span>
                    <Tooltip
                      title={
                        params.get("since") && params.get("until")
                          ? t("dashboard_tooltips.tpc_rat.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                          : t("dashboard_tooltips.tpc_rat.2")
                      }
                      color="#100D31"
                    >
                      <img
                        className={styles.message_img}
                        src={
                          theme === "dark"
                            ? "/assets/info1.svg"
                            : "/assets/info1_black.svg"
                        }
                      />
                    </Tooltip>
                  </span>
                }
                id="Topics Rating"
                extra={
                  <div className={styles.subTopicCards}>
                    <span
                      className={styles.downloadChartsBtn}
                      onClick={() =>
                        handleDownloadChartData(topicRatingData, "Rating")
                      }
                    >
                      {downloadRatingChartsDataLoading ? (
                        <LoadingOutlined
                          style={{
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "600",
                            width: "14px",
                            height: "14px",
                          }}
                        />
                      ) : (
                        <i className="fa fa-download" />
                      )}
                    </span>
                    {selectedTopicFromBars &&
                      Object.keys(selectedTopicFromBars).length > 0 && (
                        <div className={styles.selections}>
                          {Object.values(selectedTopicFromBars).map((topic) => (
                            <span
                              key={topic.id}
                              className={styles.level1Label}
                              title={topic.label}
                              onClick={() => {
                                if (savedSearch && isStatic) {
                                  return;
                                }
                                const topics = Object.values(
                                  selectedTopicFromBars
                                ).filter((t) => t.level < topic.level);
                                setSelectedTopicFromBars(topics);
                                for (
                                  let level = topic.level;
                                  level >= 1;
                                  level++
                                ) {
                                  if (params.has(`level${level}Selection`)) {
                                    params.delete(`level${level}Selection`);
                                    history.push({
                                      search: params.toString(),
                                    });
                                    dispatch({
                                      type: actions.UPDATE_SEARCH_STATE,
                                      payload: {
                                        [`selectedL${level}Topic`]: null,
                                      },
                                    });
                                  } else {
                                    break;
                                  }
                                }
                              }}
                            >
                              <span>
                                {removeParentFromChildren(topic.label)}
                              </span>
                              <CloseOutlined />
                            </span>
                          ))}
                        </div>
                      )}
                  </div>
                }
              >
                <Spin spinning={topicRatingsLoading}>
                  <div className={styles.barChartWrapper}>
                    <BarChartWrapper
                      data={topicRatingData || []}
                      selectedTopics={selectedTopicFromBars}
                      setSelectedTopics={setSelectedTopicFromBars}
                      metric={"rating"}
                      disableSelection={savedSearch && isStatic}
                      onlyOneMetric={
                        !topicSentimentData || topicSentimentData.length === 0
                      }
                    />
                  </div>
                </Spin>
              </BoardCard>
            )}
          {(topicRatingsLoading ||
            (topicSentimentData && topicSentimentData.length > 0)) && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.86")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.tpc_sent.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.tpc_sent.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Topics Sentiment"
              extra={
                <div className={styles.subTopicCards}>
                  <span
                    className={styles.downloadChartsBtn}
                    onClick={() =>
                      handleDownloadChartData(topicSentimentData, "Sentiment")
                    }
                  >
                    {downloadSentimentChartsDataLoading ? (
                      <LoadingOutlined
                        style={{
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                    ) : (
                      <i className="fa fa-download" />
                    )}
                  </span>
                  {selectedTopicFromBars &&
                    Object.keys(selectedTopicFromBars).length > 0 && (
                      <div className={styles.selections}>
                        {Object.values(selectedTopicFromBars).map((topic) => (
                          <span
                            key={topic.id}
                            className={styles.level1Label}
                            title={topic.label}
                            onClick={() => {
                              if (savedSearch && isStatic) {
                                return;
                              }
                              const topics = Object.values(
                                selectedTopicFromBars
                              ).filter((t) => t.level < topic.level);
                              setSelectedTopicFromBars(topics);
                              for (
                                let level = topic.level;
                                level >= 1;
                                level++
                              ) {
                                if (params.has(`level${level}Selection`)) {
                                  params.delete(`level${level}Selection`);
                                  history.push({
                                    search: params.toString(),
                                  });
                                  dispatch({
                                    type: actions.UPDATE_SEARCH_STATE,
                                    payload: {
                                      [`selectedL${level}Topic`]: null,
                                    },
                                  });
                                } else {
                                  break;
                                }
                              }
                            }}
                          >
                            <span>{removeParentFromChildren(topic.label)}</span>
                            <CloseOutlined />
                          </span>
                        ))}
                      </div>
                    )}
                </div>
              }
            >
              <Spin spinning={topicRatingsLoading}>
                <div className={styles.barChartWrapper}>
                  <BarChartWrapper
                    data={topicSentimentData || []}
                    selectedTopics={selectedTopicFromBars}
                    setSelectedTopics={setSelectedTopicFromBars}
                    metric={"sentiment"}
                    stacked={true}
                    disableSelection={savedSearch && isStatic}
                    onlyOneMetric={
                      !topicRatingData ||
                      topicRatingData.length === 0 ||
                      topicRatingData
                        .map((t) => t?.rating?.value)
                        .every((t) => parseInt(t, 10) === 0)
                    }
                    scrollable={true}
                  />
                </div>
              </Spin>
            </BoardCard>
          )}
        </div>
        {decisionData?.length > 0 &&
          [33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId) && (
            <div
              className={`${styles.analysisContainer} ${styles.pivotDoughnuts}`}
            >
              <BoardCard
                title={
                  <span className={styles.KDATitle}>
                    <span>{t("selected_dashboard_page.157")}</span>
                    <Tooltip
                      title={
                        params.get("since") && params.get("until")
                          ? t("dashboard_tooltips.decision.1", {
                              since: params.get("since"),
                              until: params.get("until"),
                            })
                          : t("dashboard_tooltips.decision.2")
                      }
                      color="#100D31"
                    >
                      <img
                        className={styles.message_img}
                        src={
                          theme === "dark"
                            ? "/assets/info1.svg"
                            : "/assets/info1_black.svg"
                        }
                      />
                    </Tooltip>
                  </span>
                }
                id="Decision-Analysis"
              >
                <div className={styles.dnutWrapper}>
                  <Spin spinning={decisionDataLoading}>
                    <div className={`${styles.doughnutContainer}`}>
                      {decisionData.map((decsData) => (
                        <div className={styles.doughnut}>
                          <span className={styles.doughnutLabel}>
                            {decsData.doughnutLabel === "publish"
                              ? "Publish"
                              : decsData.doughnutLabel === "opencase"
                              ? "Open Case"
                              : "Take Action"}
                          </span>
                          {decsData.datasets[0].data.reduce(
                            (acc, curr) => acc + parseInt(curr, 10),
                            0
                          ) > 0 ? (
                            <CustomChart
                              data={decsData}
                              options={{
                                ...basicDoughnutOptions,
                                cutout: "55%",
                                onClick: function(e) {
                                  var point = e.chart?.getElementsAtEventForMode(
                                    e,
                                    "nearest",
                                    {
                                      intersect: true,
                                    }
                                  );
                                  if (point?.length > 0) {
                                    const key = decsData.doughnutLabel;
                                    const value =
                                      point[0].index === 0 ? "False" : "True";
                                    handleDecisionDoughnutClick(key, value);
                                  }
                                },
                                layout: {
                                  padding: {
                                    left: 40,
                                    right: 40,
                                    top: 0,
                                    bottom: 0,
                                  },
                                },
                                plugins: {
                                  ...basicDoughnutOptions.plugins,
                                  legend: {
                                    display: false,
                                  },
                                  tooltip: {
                                    enabled: false,
                                    external: (context) => {
                                      // Tooltip Element
                                      var tooltipEl = document.getElementById(
                                        "chartjs-tooltip"
                                      );

                                      // Create element on first render
                                      if (!tooltipEl) {
                                        tooltipEl = document.createElement(
                                          "div"
                                        );
                                        tooltipEl.id = "chartjs-tooltip";
                                        tooltipEl.innerHTML = "<div></div>";
                                        document.body.appendChild(tooltipEl);
                                      }

                                      // Hide if no tooltip
                                      const tooltipModel = context.tooltip;
                                      if (tooltipModel.opacity === 0) {
                                        if (tooltipEl) {
                                          tooltipEl.remove();
                                        }
                                        return;
                                      }
                                      // Set caret Position
                                      tooltipEl.classList.remove(
                                        "above",
                                        "below",
                                        "no-transform"
                                      );
                                      if (tooltipModel.yAlign) {
                                        tooltipEl.classList.add(
                                          tooltipModel.yAlign
                                        );
                                      } else {
                                        tooltipEl.classList.add("no-transform");
                                      }

                                      function getBody(bodyItem) {
                                        return bodyItem.lines;
                                      }

                                      // Set Text
                                      if (tooltipModel.body) {
                                        let innerHtml =
                                          "<div class=" +
                                          styles.driversTooltip +
                                          ">";
                                        const index =
                                          tooltipModel.dataPoints[0].dataIndex;
                                        const datasetLabel =
                                          decsData.labels[index];
                                        const filteredPercentage =
                                          decsData.datasets[0].data[index];
                                        const filteredCount =
                                          decsData.datasets[0].counts[index];
                                        innerHtml += `
                                    <div class=${styles.topicLabelInTooltip}>
                                      <span class=${styles.fillColor} style="background-color: ${decsData.datasets[0].backgroundColor[index]}"></span>
                                      <span class=${styles.topicLabel}>${datasetLabel}</span>
                                    </div>`;
                                        innerHtml += `
                                        <p class=${styles.tooltipValues}><b>${
                                          showNormalizedData
                                            ? filteredPercentage + "%"
                                            : filteredCount
                                        }</b></p>
                                      `;
                                        innerHtml += "</div>";
                                        const tooltipRoot = tooltipEl.querySelector(
                                          "div"
                                        );
                                        tooltipRoot.innerHTML = innerHtml;
                                      }
                                      // this will be the overall tooltip
                                      const position = context.chart.canvas.getBoundingClientRect();

                                      // Display, position, and set styles for font
                                      tooltipEl.style.opacity = 1;
                                      tooltipEl.style.position = "absolute";
                                      let left =
                                        position.left +
                                        window.pageXOffset +
                                        tooltipModel.caretX;
                                      if (
                                        left + tooltipEl.offsetWidth >
                                        window.innerWidth
                                      ) {
                                        left =
                                          position.left +
                                          window.pageXOffset / 2 +
                                          tooltipModel.caretX -
                                          tooltipEl.offsetWidth;
                                      }
                                      tooltipEl.style.left = left + "px";
                                      tooltipEl.style.top =
                                        position.top +
                                        window.pageYOffset +
                                        tooltipModel.caretY +
                                        "px";
                                      tooltipEl.style.padding =
                                        tooltipModel.padding +
                                        "px " +
                                        tooltipModel.padding +
                                        "px";
                                      tooltipEl.style.pointerEvents = "none";
                                    },
                                  },
                                  datalabels: {
                                    color: (context) => {
                                      const bgColor =
                                        context.dataset.backgroundColor[
                                          context.dataIndex
                                        ];
                                      if (
                                        RGBAToHex(bgColor) === "#d2b5f2" ||
                                        RGBAToHex(bgColor) === "#56dec8" ||
                                        RGBAToHex(bgColor) === "#ffbfff" ||
                                        RGBAToHex(bgColor) === "#cccccc" ||
                                        RGBAToHex(bgColor) === "#9bc3de" ||
                                        RGBAToHex(bgColor) === "#e7edef"
                                      ) {
                                        return "#4400AA";
                                      } else {
                                        return "white";
                                      }
                                    },
                                    font: {
                                      size: 12,
                                    },
                                    formatter: (value, context) => {
                                      if (
                                        context.dataset.data[
                                          context.dataIndex
                                        ] == 0 ||
                                        isNaN(
                                          context.dataset.data[
                                            context.dataIndex
                                          ]
                                        )
                                      ) {
                                        return "";
                                      }
                                      const formattedCount = formatCountsForDoughnuts(
                                        context.dataset.counts[
                                          context.dataIndex
                                        ]
                                      );
                                      const lineBreak = "\n";
                                      const spaceBreak = "\t";
                                      return context.dataset.data[
                                        context.dataIndex
                                      ] < 2
                                        ? ""
                                        : hasAlphabet(formattedCount)
                                        ? `${spaceBreak}${" "}${
                                            showNormalizedData
                                              ? value + "%"
                                              : formattedCount
                                          }${lineBreak}${
                                            showNormalizedData
                                              ? "(" + formattedCount + ")"
                                              : ""
                                          }`
                                        : `${" "}${
                                            showNormalizedData
                                              ? value + "%"
                                              : formattedCount
                                          }${lineBreak}${
                                            showNormalizedData
                                              ? "(" + formattedCount + ")"
                                              : ""
                                          }`;
                                    },
                                  },
                                },
                              }}
                              type={"doughnut"}
                            />
                          ) : (
                            <div className={styles.emptyDoughnut}>
                              {/* <Doughnut
                                data={decsData}
                                options={{
                                  ...IntentOptions,
                                  cutoutPercentage: 45,
                                  legend: false,
                                  layout: {
                                    padding: {
                                      left: 40,
                                      right: 40,
                                      top: 0,
                                      bottom: 0,
                                    },
                                  },
                                  plugins: {
                                    datalabels: {
                                      font: {
                                        size: 9,
                                      },
                                      formatter: function(value, context) {
                                        if (
                                          context.dataset.data[
                                            context.dataIndex
                                          ] == 0 ||
                                          isNaN(
                                            context.dataset.data[
                                              context.dataIndex
                                            ]
                                          )
                                        ) {
                                          return "";
                                        }
                                      },
                                    },
                                  },
                                }}
                              /> */}
                              <span className={styles.noDataDoughnutMsg}>
                                No Data
                              </span>
                            </div>
                          )}
                          {decsData.datasets[0].data.reduce(
                            (acc, curr) => acc + parseInt(curr),
                            0
                          ) > 0 && (
                            <>
                              <div className={styles.pivotsLegendSingle}>
                                <div
                                  title={decsData.labels[0]}
                                  className={styles.topicLabelInTooltip}
                                >
                                  <span
                                    className={styles.fillColor}
                                    style={{
                                      backgroundColor:
                                        decsData.doughnutLabel === "publish"
                                          ? hexToRGBA("#3A6D8C", 1)
                                          : decsData.doughnutLabel ===
                                            "opencase"
                                          ? hexToRGBA("#D91656", 1)
                                          : hexToRGBA("#304463", 1),
                                    }}
                                  ></span>
                                  <span
                                    onClick={() => {
                                      handleDecisionDoughnutClick(
                                        decsData.doughnutLabel,
                                        "False"
                                      );
                                    }}
                                    className={styles.topicLabel}
                                  >
                                    {decsData.labels[0]}
                                  </span>
                                </div>
                              </div>
                              <div className={styles.pivotsLegendSingle}>
                                <div
                                  title={decsData.labels[1]}
                                  className={styles.topicLabelInTooltip}
                                >
                                  <span
                                    className={styles.fillColor}
                                    style={{
                                      backgroundColor:
                                        decsData.doughnutLabel === "publish"
                                          ? hexToRGBA("#41B3A2", 1)
                                          : decsData.doughnutLabel ===
                                            "opencase"
                                          ? hexToRGBA("704264", 1)
                                          : hexToRGBA("#758694", 1),
                                    }}
                                  ></span>
                                  <span
                                    onClick={() => {
                                      handleDecisionDoughnutClick(
                                        decsData.doughnutLabel,
                                        "True"
                                      );
                                    }}
                                    className={styles.topicLabel}
                                  >
                                    {decsData.labels[1]}
                                  </span>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </Spin>
                </div>
              </BoardCard>
            </div>
          )}
        {restaurantDoughnutData && restaurantDoughnutData.length > 0 && (
          <div
            className={`${styles.analysisContainer} ${styles.pivotDoughnuts}`}
          >
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.17")}</span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "10px",
                    }}
                  ></div>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.pivot.1", {
                            since: params.get("since"),
                            until: params.get("until"),
                          })
                        : t("dashboard_tooltips.pivot.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Detailed-Pivot-Analysis"
            >
              <div
                className={
                  filters.length > 0
                    ? styles.dnutWrapper
                    : styles.doughnutWrapper
                }
              >
                <Spin spinning={isRestaurantDoughnutDataLoading}>
                  <div className={styles.doughnutContainer}>
                    {restaurantDoughnutData.map((restaurentData, index) => (
                      <div
                        className={
                          restaurantRef.current[index]?.current?.filtersApplied
                            ? styles.pivotDoughnut
                            : styles.unfilteredPivotDoughnut
                        }
                      >
                        <span className={styles.doughnutLabel}>
                          {restaurentData.doughnutLabel}
                        </span>
                        <CustomChart
                          type="doughnut"
                          data={restaurentData}
                          options={{
                            ...basicDoughnutOptions,
                            cutout: "55%",
                            radius: "70%",
                            onClick: function(e) {
                              var point = e.chart?.getElementsAtEventForMode(
                                e,
                                "nearest",
                                {
                                  intersect: true,
                                }
                              );
                              if (point?.length > 0) {
                                const key = restaurentData.doughnutLabel;
                                const value =
                                  restaurentData.labels[point[0].index];
                                if (
                                  point[0].index === 6 &&
                                  value === "Others"
                                ) {
                                  return;
                                }
                                handlePivotDoughnutClick(key, value);
                              }
                            },
                            layout: {
                              padding: (chartInstance) => {
                                return {
                                  left: 40,
                                  right: 40,
                                  top: 40,
                                  bottom: 40,
                                };
                              },
                            },
                            plugins: {
                              ...basicDoughnutOptions.plugins,
                              legend: {
                                display: false,
                              },
                              tooltip: {
                                enabled: false,
                                external: (context) => {
                                  // Tooltip Element
                                  var tooltipEl = document.getElementById(
                                    "chartjs-tooltip"
                                  );

                                  // Create element on first render
                                  if (!tooltipEl) {
                                    tooltipEl = document.createElement("div");
                                    tooltipEl.id = "chartjs-tooltip";
                                    tooltipEl.innerHTML = "<div></div>";
                                    document.body.appendChild(tooltipEl);
                                  }

                                  // Hide if no tooltip
                                  const tooltipModel = context.tooltip;
                                  if (tooltipModel.opacity === 0) {
                                    if (tooltipEl) {
                                      tooltipEl.remove();
                                    }
                                    return;
                                  }
                                  // Set caret Position
                                  tooltipEl.classList.remove(
                                    "above",
                                    "below",
                                    "no-transform"
                                  );
                                  if (tooltipModel.yAlign) {
                                    tooltipEl.classList.add(
                                      tooltipModel.yAlign
                                    );
                                  } else {
                                    tooltipEl.classList.add("no-transform");
                                  }

                                  function getBody(bodyItem) {
                                    return bodyItem.lines;
                                  }

                                  // Set Text
                                  if (tooltipModel.body) {
                                    let innerHtml =
                                      "<div class=" +
                                      styles.driversTooltip +
                                      ">";
                                    const index =
                                      tooltipModel.dataPoints[0].dataIndex;
                                    const datasetLabel =
                                      restaurentData.labels[index];
                                    const filteredPercentage =
                                      restaurentData.datasets[0].data[index];
                                    const filteredCount =
                                      restaurentData.datasets[0].counts[index];
                                    const actualPercentage =
                                      restaurentData.datasets[0].actualData[
                                        index
                                      ];
                                    const actualCount =
                                      restaurentData.datasets[0].actualCounts[
                                        index
                                      ];
                                    const diffValue =
                                      filteredPercentage - actualPercentage;
                                    if (
                                      filteredCount >= 0 &&
                                      filteredPercentage >= 0 &&
                                      actualPercentage >= 0 &&
                                      actualCount >= 0
                                    ) {
                                      innerHtml += `
                                      <div class=${styles.topicLabelInTooltip}>
                                        <span class=${styles.fillColor} style="background-color: ${restaurentData.datasets[0].backgroundColor[index]}"></span>
                                        <span class=${styles.topicLabel}>${datasetLabel}</span>
                                      </div>`;
                                      if (filters?.length > 0) {
                                        innerHtml += `
                                          <p class=${styles.tooltipValues}><b>${
                                          showNormalizedData
                                            ? filteredPercentage + "%"
                                            : filteredCount
                                        }</b></p>
                                        `;
                                      } else {
                                        innerHtml += `
                                          <p class=${styles.tooltipValues}><b>${
                                          showNormalizedData
                                            ? actualPercentage + "%"
                                            : actualCount
                                        }</b></p>
                                        `;
                                      }
                                      // Add diff of percentages
                                      innerHtml += `
                                          <p class=${
                                            styles.tooltipValues
                                          }><b>Diff: ${
                                        diffValue > 0
                                          ? "+" + diffValue.toFixed(1) + "%"
                                          : diffValue < 0
                                          ? diffValue.toFixed(1) + "%"
                                          : "0%"
                                      }</b></p>
                                        `;
                                    }
                                    innerHtml += "</div>";
                                    const tooltipRoot = tooltipEl.querySelector(
                                      "div"
                                    );
                                    tooltipRoot.innerHTML = innerHtml;
                                  }
                                  // this will be the overall tooltip
                                  const position = context.chart.canvas.getBoundingClientRect();

                                  // Display, position, and set styles for font
                                  tooltipEl.style.opacity = 1;
                                  tooltipEl.style.position = "absolute";
                                  let left =
                                    position.left +
                                    window.pageXOffset +
                                    tooltipModel.caretX;
                                  if (
                                    left + tooltipEl.offsetWidth >
                                    window.innerWidth
                                  ) {
                                    left =
                                      position.left +
                                      window.pageXOffset / 2 +
                                      tooltipModel.caretX -
                                      tooltipEl.offsetWidth;
                                  }
                                  tooltipEl.style.left = left + "px";
                                  tooltipEl.style.top =
                                    position.top +
                                    window.pageYOffset +
                                    tooltipModel.caretY +
                                    "px";
                                  tooltipEl.style.padding =
                                    tooltipModel.padding +
                                    "px " +
                                    tooltipModel.padding +
                                    "px";
                                  tooltipEl.style.pointerEvents = "none";
                                },
                              },
                              datalabels: {
                                color: (context) => {
                                  const bgColor =
                                    context.dataset.backgroundColor[
                                      context.dataIndex
                                    ];
                                  if (
                                    RGBAToHex(bgColor) === "#d2b5f2" ||
                                    RGBAToHex(bgColor) === "#56dec8" ||
                                    RGBAToHex(bgColor) === "#ffbfff" ||
                                    RGBAToHex(bgColor) === "#cccccc" ||
                                    RGBAToHex(bgColor) === "#9bc3de" ||
                                    RGBAToHex(bgColor) === "#e7edef"
                                  ) {
                                    return "#4400AA";
                                  } else {
                                    return "white";
                                  }
                                },
                                font: {
                                  size: 12,
                                },
                                formatter: (value, context) => {
                                  if (
                                    context.dataset.data[context.dataIndex] ==
                                      0 ||
                                    isNaN(
                                      context.dataset.data[context.dataIndex]
                                    )
                                  ) {
                                    return "";
                                  }
                                  const formattedCount = formatCountsForDoughnuts(
                                    context.dataset.counts[context.dataIndex]
                                  );
                                  const lineBreak = "\n";
                                  const spaceBreak = "\t";
                                  return context.dataset.data[
                                    context.dataIndex
                                  ] < 2
                                    ? ""
                                    : hasAlphabet(formattedCount)
                                    ? `${spaceBreak}${" "}${
                                        showNormalizedData
                                          ? value + "%"
                                          : formattedCount
                                      }${lineBreak}${
                                        showNormalizedData
                                          ? "(" + formattedCount + ")"
                                          : ""
                                      }`
                                    : `${" "}${
                                        showNormalizedData
                                          ? value + "%"
                                          : formattedCount
                                      }${lineBreak}${
                                        showNormalizedData
                                          ? "(" + formattedCount + ")"
                                          : ""
                                      }`;
                                },
                              },
                            },
                          }}
                          theme={theme}
                          ref={
                            restaurantRef.current[index] ||
                            (restaurantRef.current[index] = createRef())
                          }
                          plugins={[
                            {
                              beforeDraw: (chart) => {
                                if (chart.filtersApplied) {
                                  var ctx = chart.ctx;
                                  var datasets = chart.data.datasets;
                                  datasets.forEach((dataset, i) => {
                                    var meta = chart.getDatasetMeta(i);
                                    meta.data.forEach((elem, index) => {
                                      ctx.save();
                                      var outerRadius = elem.outerRadius + 10;
                                      var startAngle = elem.startAngle;
                                      var endAngle = elem.endAngle;

                                      var halfAngle =
                                        (endAngle - startAngle) / 4;
                                      var halfStartAngle = startAngle;
                                      var halfEndAngle =
                                        startAngle + halfAngle * 2;
                                      var halfMidAngle =
                                        (halfStartAngle + halfEndAngle) / 2;
                                      var x =
                                        elem.x +
                                        Math.cos(halfMidAngle) *
                                          (outerRadius + 15);
                                      var y =
                                        elem.y +
                                        Math.sin(halfMidAngle) *
                                          (outerRadius + 15);
                                      const filteredPercentage =
                                        dataset.data[index];
                                      const actualPercentage =
                                        dataset.actualData[index];
                                      var diffValue =
                                        filteredPercentage - actualPercentage;
                                      if (
                                        dataset.data[index] > 3 &&
                                        diffValue !== 0
                                      ) {
                                        // Draw outer ring
                                        ctx.save();
                                        ctx.beginPath();
                                        ctx.strokeStyle =
                                          elem.options.backgroundColor;
                                        ctx.lineWidth = 3;
                                        ctx.arc(
                                          elem.x,
                                          elem.y,
                                          outerRadius,
                                          halfStartAngle,
                                          halfEndAngle
                                        );
                                        ctx.stroke();

                                        // Draw number
                                        ctx.font = "bold 12px Poppins";

                                        ctx.textAlign = "center";
                                        ctx.textBaseline = "middle";
                                        ctx.fillStyle =
                                          theme === "dark" ? "white" : "black";
                                        ctx.fillText(
                                          diffValue > 0
                                            ? "+" + diffValue
                                            : diffValue < 0
                                            ? diffValue
                                            : 0,
                                          x,
                                          y
                                        );
                                        ctx.save();
                                        ctx.restore();
                                      }
                                    });
                                  });
                                }
                              },
                            },
                          ]}
                        />
                        <div
                          className={
                            restaurentData.labels.length === 1
                              ? styles.pivotsLegendSingle
                              : styles.pivotsLegend
                          }
                        >
                          {restaurentData.labels.map((label) => (
                            <div
                              title={label}
                              className={styles.topicLabelInTooltip}
                            >
                              <span
                                className={styles.fillColor}
                                style={{
                                  backgroundColor: hexToRGBA(
                                    restaurantColorMap[label],
                                    1.0
                                  ),
                                }}
                              ></span>
                              <span
                                onClick={() => {
                                  if (label !== "Others") {
                                    handlePivotDoughnutClick(
                                      restaurentData.doughnutLabel,
                                      label
                                    );
                                  }
                                }}
                                className={styles.topicLabel}
                              >
                                {label}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </Spin>
              </div>
            </BoardCard>
          </div>
        )}
        <div className={styles.chartReviewsContainer}>
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/reviews_icon.svg"
                      : "/assets/reviews_icon_black.svg"
                  }
                />
                <span>
                  {numReviews
                    ? `${t("selected_dashboard_page.18")}: ${numReviews}`
                    : t("selected_dashboard_page.18")}
                </span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.reviews.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                      : t("dashboard_tooltips.reviews.2")
                  }
                  color="#100D31"
                  pointAtCenter
                  autoAdjustOverflow
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            theme={theme}
            extra={
              !shared &&
              ![65, 66, 67, 68, 69, 70].includes(userReducer?.PackageId) && (
                <div className={styles.shareBtn}>
                  <span
                    type="primary"
                    style={{ borderRadius: "8px" }}
                    disabled={[74, 75, 66, 65, 67].includes(
                      userReducer?.PackageId
                    )}
                    className={styles.downloadBtn}
                    onClick={handleShowFileType}
                    ref={downloadBtnRef}
                  >
                    <img
                      className={styles.downloadReviewIcon}
                      src={
                        theme === "dark"
                          ? "/assets/download.svg"
                          : "/assets/download_black.svg"
                      }
                      alt=""
                    />
                    <span className={styles.downloadReviewText}>
                      {t("button.25")}
                    </span>
                  </span>
                </div>
              )
            }
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              {/* Doubts */}
              {!savedSearch ? (
                <CustomInput
                  // label="Search"
                  value={searchWord}
                  placeholder={t("placeholder.13")}
                  disabled={savedSearch}
                  onOk={() => handleSearchWord(searchWord, true, true)}
                  onChange={setSearchWord}
                  style={{ margin: "20px auto" }}
                  extra={
                    <Button
                      type="primary"
                      onClick={() => handleSearchWord(searchWord, true, true)}
                      disabled={reviewsLoading}
                    >
                      {t("button.5")}
                    </Button>
                  }
                />
              ) : (
                <></>
              )}
              <ReviewsList
                reviewsLoading={reviewsLoading}
                allReviews={allReviews}
                setAllReviews={setAllReviews}
                numReviews={numReviews}
                startIndex={startIndex}
                setStartIndex={setStartIndex}
                getAllReviews={getSearchResults}
                getOnlyReviews={getOnlyReviews}
                setNumOfDocs={setNumOfDocs}
                numOfDocs={numOfDocs}
                handleTagSelection={handleSearchWord}
                user={user}
                setReviewsLoading={setReviewsLoading}
                getHighlights={getHighlights}
                highlights={highlights}
                shared={shared}
                searchControllerRef={searchControllerRef}
                currentDashboardHash={initialState.currentDashboard}
                boardDataSrc
                setCreateModal={setCreateModal}
                setShowAIInsightsModal={setShowAIInsightsModal}
                setCreateTaskModal={() => {
                  if (
                    userReducer.trello_status === "active" ||
                    userReducer.clickup_status === "active" ||
                    userReducer.jira_status === "active"
                  ) {
                    setCreateTaskModal(true);
                  } else {
                    notification.info({
                      message: t("notifications.48"),
                      icon: (
                        <InfoCircleOutlined
                          style={{
                            color: theme === "dark" ? "white" : "black",
                          }}
                        />
                      ),
                    });
                  }
                }}
                // facebookReplies={facebookReplies}
                // getFacebookReplies={getFacebookReplies}
                setFilters={setFilters}
                filters={filters}
                resetPivotFilters={handleResetPivotFilters}
                resetTopicFilters={handleResetTopicFilters}
                selectedPivots={selectedPivots}
                pivotOptions={pivotOptions}
                multiLevelOptions={multiLevelOptions}
                setSelectedPivots={setSelectedPivots}
                setSelectedDecisions={setSelectedDecisions}
                levelWisePivotSelections={levelWisePivotSelections}
                setLevelWisePivotSelections={setLevelWisePivotSelections}
                topicRatingsLoading={topicRatingsLoading}
                topTopics={topTopics}
                handleClearAllTopTopics={handleClearAllTopTopics}
                checkedTopicIds={checkedTopicIds}
                setCheckedTopicIds={setCheckedTopicIds}
                selectedTopicIds={selectedTopicIds}
                setSelectedTopicIds={setSelectedTopicIds}
                selectedTopicFromBars={selectedTopicFromBars}
                setSelectedTopicFromBars={setSelectedTopicFromBars}
                npsScale={npsScale}
                cursors={cursors}
                setCursorNext={setCursorNext}
                backWardCursors={backWardCursors}
                disableSelection={(savedSearch && isStatic) || topTopicsLoading}
                setHideEmptyReviews={setHideEmptyReviews}
                hideEmptyReviews={hideEmptyReviews}
                resetReviewsPage={resetReviewsPage}
                setResetReviewsPage={setResetReviewsPage}
                setSelectedReviewIds={setSelectedReviewIds}
                selectedReviewIDs={selectedReviewIDs}
                setTweetsCheckList={setTweetsCheckList}
                setUsersCheckList={setUsersCheckList}
                tweetsCheckList={tweetsCheckList}
                usersCheckList={usersCheckList}
              />
            </div>
          </BoardCard>
        </div>
      </Spin>
      <Modal1
        showModal={createModal}
        onClose={() => {
          setCreateModal(false);
          setInsightTxt("");
          setinsightTitleTxt("");
        }}
        onSave={handleCreateInsight}
        showSaveButton={true}
        textonButton={t("button.7")}
        titleAsset=""
        title={
          <span className={styles.insightTitle}>
            {t("selected_dashboard_page.65")}{" "}
            <img
              className={styles.message_img}
              src={
                theme === "dark"
                  ? "/assets/info1.svg"
                  : "/assets/info1_black.svg"
              }
              style={{ cursor: "pointer" }}
              width={20}
              height={20}
              onClick={() => {
                const win = window.open(
                  "https://pivony.notion.site/Insight-Creation-160faa1a90cc4191baf11fb62c88d808",
                  "_blank"
                );
                win.focus();
              }}
            />
          </span>
        }
        widthofmodal="420px"
        loadingSaveClick={createInsightLoading}
      >
        <div className={styles.titles}>
          <Input.TextArea
            style={{
              height: "2px",
              marginBottom: "7px",
              width: "400px",
              background: "transparent",
              color: theme === "dark" ? "white" : "black",
              borderColor: "#6f6c99",
              borderRadius: "10px",
            }}
            placeholder={t("placeholder.14")}
            // onKeyPress={(e) => keyPressed(e, handleCreateInsight)}
            onChange={(e) => setinsightTitleTxt(e.target.value)}
            value={insightTitleTxt}
          />
        </div>
        <div className={styles.titles}>
          <Input.TextArea
            style={{
              height: "130px",
              width: "400px",
              background: "transparent",
              color: theme === "dark" ? "white" : "black",
              borderColor: "#6f6c99",
              borderRadius: "10px",
            }}
            placeholder={t("selected_dashboard_page.15")}
            // onKeyPress={(e) => keyPressed(e, handleCreateInsight)}
            onChange={(e) => setInsightTxt(e.target.value)}
            value={insightTxt}
          />
        </div>
      </Modal1>
      {!shared && (
        <DashboardAIInsightsModal
          visible={showAIInsightsModal}
          onClose={() => setShowAIInsightsModal(false)}
          onSubmit={handleAIInsightGeneration}
          reviewCount={numReviews ?? null}
          filterLabels={buildAIInsightsFilterLabels()}
          quota={aiInsightsQuota}
          quotaLoading={aiInsightsQuotaLoading}
          quotaError={aiInsightsQuotaError}
          isDark={theme === "dark"}
        />
      )}
      {userReducer?.trello_status === "active" && (
        <CreateTaskTrelloModal
          userReducer={userReducer}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {userReducer?.jira_status === "active" && (
        <CreateTaskJiraModal
          userReducer={userReducer}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {userReducer?.clickup_status === "active" && (
        <CreateTaskClickupModal
          userReducer={userReducer}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {showPopupSequence && (
        <DataSelectionPopup
          open={showPopupSequence}
          onClose={() => {
            setShowPopupSequence(false);
            setSelectedOutcomeMetric(1);
            setSelectedCustomTopics([]);
            setSelectedPivotColumns([]);
            setOutcomeMetrics([]);
          }}
          onSave={() => {
            setShowPopupSequence(false);
            setShowDriverPopup(true);
          }}
          dataType={"Outcome Metric"}
          description={t("selected_dashboard_page.114")}
          options={outcomeMetrics}
          columnHeaders={[
            { title: t("selected_dashboard_page.110"), align: "left" },
          ]}
          selectedItems={selectedOutcomeMetric}
          setSelectedItems={setSelectedOutcomeMetric}
          resetPopup={() => {
            setShowPopupSequence(false);
            setSelectedOutcomeMetric(1);
            setSelectedCustomTopics([]);
            setSelectedPivotColumns([]);
            setOutcomeMetrics([]);
          }}
          popupWidth="400px"
          selectionType={"single"}
          saveButtonText={t("selected_dashboard_page.116")}
          dataLoading={tableDataLoading}
        />
      )}
      {showDriverPopup && (
        <DataSelectionPopup
          open={showDriverPopup}
          onClose={() => {
            setShowDriverPopup(false);
            setSelectedOutcomeMetric(1);
            setSelectedCustomTopics([]);
            setSelectedPivotColumns([]);
            setPotentialDrivers([]);
          }}
          dataType={"Potential Drivers"}
          description={t("selected_dashboard_page.119")}
          options={potentialDrivers}
          columnHeaders={[
            { title: t("selected_dashboard_page.112"), align: "left" },
          ]}
          saveButtonText={t("selected_dashboard_page.118")}
          onSave={() => {
            if ([...selectedCustomTopics, ...selectedPivotColumns].length < 2) {
              notification.warning({
                message: t("api_errors.select_two_drivers", "Please select at least two drivers"),
              });
              return;
            }
            // if ([...selectedCustomTopics, ...selectedPivotColumns] > 10) {
            //   notification.warning({
            //     message: "Too much data for the analysis",
            //     description: "Max 10 topics can be selected.",
            //   });
            //   return;
            // }
            setEmptyDriverAnalysis(false);
            setShowDriverPopup(false);
            /*Call the generate scattered chart API*/
            saveKeyDriverConfig();
            getKeyDriverAnalysis();
          }}
          selectedCustomTopics={selectedCustomTopics}
          setSelectedCustomTopics={setSelectedCustomTopics}
          selectedPivotColumns={selectedPivotColumns}
          setSelectedPivotColumns={setSelectedPivotColumns}
          resetPopup={() => {
            setShowDriverPopup(false);
            setSelectedOutcomeMetric(1);
            setSelectedCustomTopics([]);
            setSelectedPivotColumns([]);
            setOutcomeMetrics([]);
            setPotentialDrivers([]);
          }}
          selectionType={"multiple"}
          dataLoading={tableDataLoading}
          emptyDataContent={
            <div className={styles.emptyDataContent}>
              <span className={styles.emptyMsg}>
                {t("selected_dashboard_page.120")}
              </span>
              <span
                className={styles.redirectBtn}
                onClick={() => {
                  history.push(`/settings/topic-library`);
                }}
              >
                {t("selected_dashboard_page.121")}
              </span>
            </div>
          }
        />
      )}
      {showFileTypePopup && (
        <FileTypePopup
          loading={downloadDataLoading}
          setShowFileTypePopup={setShowFileTypePopup}
          downloadData={downloadData}
          fileType={fileType}
          setFileType={setFileType}
          onlySequences={onlySequences}
          setOnlySequences={setOnlySequences}
        />
      )}
      {showAdditionalSearchPopup && !savedSearch && (
        <Modal
          showModal={showAdditionalSearchPopup}
          onClose={() => {
            setShowAdditionalSearchPopup(false);
          }}
          onDiscard={() => {
            setShowAdditionalSearchPopup(false);
            updateQParams(
              "keyword",
              JSON.stringify([{ label: searchWord, type: "search" }])
            );
            dispatch({
              type: actions.UPDATE_SEARCH_STATE,
              payload: {
                chosenKeywords: [{ label: searchWord, type: "search" }],
              },
            });
            setSearchWord("");
          }}
          onSave={() => {
            setShowAdditionalSearchPopup(false);
            const selectedTags = params.has("keyword")
              ? JSON.parse(params.get("keyword"))
              : [];
            const nextSelectedTags = [
              ...selectedTags,
              { label: searchWord, type: "search" },
            ];
            params.delete("keyword");
            params.append("keyword", JSON.stringify(nextSelectedTags));
            history.push({ search: params.toString() });
            dispatch({
              type: actions.UPDATE_SEARCH_STATE,
              payload: {
                chosenKeywords: nextSelectedTags,
              },
            });
            setSearchWord("");
          }}
          showSaveButton={true}
          showCancelButton={true}
          textonButton={t("selected_dashboard_page.135")}
          cancelButtonText={t("selected_dashboard_page.134")}
          titleAsset=""
          title={t("selected_dashboard_page.132")}
          widthofmodal="460px"
        >
          <p>{t("selected_dashboard_page.133")}</p>
        </Modal>
      )}
      {showSavedSearchPopup && (
        <Modal
          showModal={showSavedSearchPopup}
          onClose={() => {
            setShowSavedSearchPopup(false);
          }}
          onSave={handleCreateSavedSearch}
          showSaveButton={true}
          showCancelButton={true}
          textonButton={t("button.7")}
          titleAsset=""
          title={t("selected_dashboard_page.136")}
          widthofmodal="450px"
          enableScroll={true}
          loadingSaveClick={createSavedSearchLoading}
        >
          <div className={styles.savedSearchPopupContent}>
            <input
              placeholder={t("selected_dashboard_page.137")}
              value={savedSearchTitle}
              onChange={(e) => setSavedSearchTitle(e.target.value)}
              className={styles.savedSearchTitle}
            />
            <Dropdown
              open={savedSearchShowDateFilter}
              overlay={
                <div className={styles.dateContainer}>
                  <DateFilterTwoPickers
                    onChange={(dateString, daysRange) => {
                      setSavedSearchDateRange(
                        dateString?.length > 0
                          ? [dateString[0], dateString[1]]
                          : []
                      );
                      setSavedSearchDaysRange(daysRange);
                      setSavedSearchShowDateFilter(false);
                    }}
                    close={() => {
                      setSavedSearchShowDateFilter(false);
                    }}
                    selectedDaysRange={savedSearchDaysRange}
                    setSelectedDaysRange={(val) => setSavedSearchDaysRange(val)}
                    defaultStartDate={new Date()}
                    defaultEndDate={new Date()}
                    searchPeriod={[new Date(), new Date()]}
                  />
                </div>
              }
              trigger={["click"]}
              placement="bottom"
              overlayClassName={styles.savedSearchDateFilter}
              onOpenChange={(i) => {
                setSavedSearchShowDateFilter(i);
              }}
            >
              <span className={styles.savedSearchDateBtn}>
                <span className={styles.iconWithLabel}>
                  <img
                    src={
                      theme === "dark"
                        ? "/assets/calendar.svg"
                        : "/assets/calendar_black.svg"
                    }
                    alt=""
                    width={16}
                    height={16}
                  />{" "}
                  {` ${presetDatesMap[savedSearchDaysRange]}`}
                </span>
                <DownOutlined />
              </span>
            </Dropdown>
            {topTopics?.tree?.length > 0 && (
              <Dropdown
                open={savedSearchShowTopTopics}
                overlay={
                  <div className={styles.container}>
                    <TopTopics
                      data={topTopics}
                      topTopicsLoading={topTopicsLoading}
                      disableTopTopicsBtn={false}
                      applyDisabled={
                        reviewsLoading ||
                        topTopicsLoading ||
                        participationPeriodLoading ||
                        topicRatingsLoading ||
                        hottermsLoading ||
                        decisionDataLoading ||
                        driverAnalysisLoading ||
                        isIntentDoughnutDataLoading ||
                        isRatingDoughnutDataLoading ||
                        isSentimentDoughnutDataLoading ||
                        isAvgSentimentGaugeDataLoading ||
                        isPlatformDoughnutDataLoading ||
                        isRestaurantDoughnutDataLoading
                      }
                      setTopicsOperator={setSavedSearchTopicsOperator}
                      checkedTopicIds={savedSearchCheckedTopicIds}
                      setCheckedTopicIds={setSavedSearchCheckedTopicIds}
                      selectedTopicIds={savedSearchSelectedTopicIds}
                      setSelectedTopicIds={setSavedSearchSelectedTopicIds}
                      boardType="dashboard"
                      handleClearAll={handleClearAllTopTopics}
                      showOnlyTree={true}
                      setSavedSearchShowTopTopics={setSavedSearchShowTopTopics}
                      setSavedSearchTopTopicsFilter={
                        setSavedSearchTopTopicsFilter
                      }
                      setSavedSearchChildOthers={setSavedSearchChildOthers}
                      setSavedSearchParentOthers={setSavedSearchParentOthers}
                      applyPopupStyling
                    />
                  </div>
                }
                placement="bottomLeft"
                overlayClassName={styles.topTopicsDropdown}
                trigger={["click"]}
                onOpenChange={(flag) => setSavedSearchShowTopTopics(flag)}
              >
                <span
                  className={styles.topTopicsBtn}
                  onClick={(e) => e.stopPropagation()}
                >
                  {savedSearchSelectedTopicIds?.length > 0 ? (
                    <div className={styles.savedSearchSelectedTopicsWrapper}>
                      {savedSearchSelectedTopicIds.map((item) => {
                        const parent_ids = savedSearchSelectedTopicIds
                          .map((item) => item?.parent_id)
                          .filter((item) => {
                            if (item) {
                              return item;
                            }
                          });
                        if (parent_ids?.includes(item?.id)) {
                          return;
                        }
                        return (
                          <div
                            key={item?.id}
                            className={styles.savedSearchSelectedTopic}
                          >
                            {item?.parent_id
                              ? `${
                                  savedSearchSelectedTopicIds.find(
                                    (parent) => parent?.id === item?.parent_id
                                  )?.label
                                } > ${item.label}`
                              : item.label}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <span>{t("others.42")}</span>
                  )}
                  <DownOutlined />
                </span>
              </Dropdown>
            )}
            <SingleSelect
              options={overallSentimentOptions}
              selectedOptions={savedSearchSentiment}
              setSelectedOptions={setSavedSearchSentiment}
              placeholder={
                <span className={styles.actionsPlaceholder}>
                  {t("button.45")}
                </span>
              }
              width={388}
              height={42}
              allowClearSelection
              popupStyling
            />
            <SingleSelect
              options={overallIntentOptions}
              selectedOptions={savedSearchIntent}
              setSelectedOptions={setSavedSearchIntent}
              placeholder={
                <span className={styles.actionsPlaceholder}>
                  {t("button.46")}
                </span>
              }
              width={388}
              height={42}
              allowClearSelection
              popupStyling
            />
            {[33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId) && (
              <SingleSelect
                options={publishOptions}
                selectedOptions={savedSearchPublish}
                setSelectedOptions={setSavedSearchPublish}
                placeholder={
                  <span className={styles.actionsPlaceholder}>
                    {t("button.48")}
                  </span>
                }
                width={388}
                height={42}
                allowClearSelection
                popupStyling
              />
            )}
            {[33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId) && (
              <SingleSelect
                options={caseOptions}
                selectedOptions={savedSearchOpenCase}
                setSelectedOptions={setSavedSearchOpenCase}
                placeholder={
                  <span className={styles.actionsPlaceholder}>
                    {t("button.49")}
                  </span>
                }
                width={388}
                height={42}
                allowClearSelection
                popupStyling
              />
            )}
            {[33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId) && (
              <SingleSelect
                options={actionOptions}
                selectedOptions={savedSearchAction}
                setSelectedOptions={setSavedSearchAction}
                placeholder={
                  <span className={styles.actionsPlaceholder}>
                    {t("button.50")}
                  </span>
                }
                width={388}
                height={42}
                allowClearSelection
                popupStyling
              />
            )}
            {[11, 12, 13].includes(DashboardReducer?.dashboard?.PlatformId) &&
              platformData.datasets && (
                <SingleSelect
                  options={platformOptions}
                  selectedOptions={savedSearchPlatform}
                  setSelectedOptions={setSavedSearchPlatform}
                  placeholder={
                    <span className={styles.actionsPlaceholder}>
                      {t("button.52")}
                    </span>
                  }
                  width={388}
                  height={42}
                  allowClearSelection
                  popupStyling
                />
              )}
            {ratingDoughnutData.labels?.length > 0 && (
              <SingleSelect
                options={ratingOptions}
                selectedOptions={savedSearchRating}
                setSelectedOptions={setSavedSearchRating}
                placeholder={
                  <span className={styles.actionsPlaceholder}>
                    {t("button.47")}
                  </span>
                }
                width={388}
                height={42}
                allowClearSelection
                popupStyling
              />
            )}
            {multiLevelOptions &&
              Object.keys(multiLevelOptions?.level1)?.length > 0 &&
              !savedSearchPivotFiltersApplied && (
                <PivotTwoPaneFilter
                  title={
                    <span className={styles.pivotsPlaceHolder}>
                      {savedSearchSelectedPivots &&
                      Object.keys(savedSearchSelectedPivots)?.length > 0 ? (
                        <div
                          className={styles.savedSearchSelectedTopicsWrapper}
                        >
                          {Object.entries(savedSearchSelectedPivots)
                            .flatMap(([key, values]) => {
                              return values.map((value) => ({
                                key: key,
                                value: value,
                              }));
                            })
                            ?.map((filter) => {
                              return (
                                <div
                                  className={styles.savedSearchSelectedTopic}
                                  key={`${filter.key}-${filter.value}`}
                                >
                                  {filter.key}
                                  {": "}
                                  {filter.value}
                                </div>
                              );
                            })}
                        </div>
                      ) : (
                        <>{t("selected_dashboard_page.117")}</>
                      )}
                    </span>
                  }
                  levelWiseOptions={multiLevelOptions}
                  levelWiseSelections={savedSearchLevelWisePivotSelections}
                  setLevelWiseSelections={
                    setSavedSearchLevelWisePivotSelections
                  }
                  reset={() => {
                    setSavedSearchPivotsApplied(false);
                    setSavedSearchLevelWisePivotSelections({});
                  }}
                  apply={(val) => {
                    setSavedSearchPivotFiltersApplied(true);
                    handleSavedSearchPivotsApply(val);
                  }}
                  disabled={savedSearchPivotFiltersApplied}
                  selectedFilterType={savedSearchPivotsOperator}
                  setSelectedFilterType={setSavedSearchPivotsOperator}
                  popupStyling
                  width={388}
                />
              )}
            {savedSearchTags.length > 0 && (
              <div className={styles.searchTagsWrapper}>
                {savedSearchTags.map((tag) => (
                  <span className={styles.searchTag}>
                    {tag.label}
                    <CloseOutlined
                      style={{ color: "white", cursor: "pointer" }}
                      onClick={() =>
                        setSavedSearchTags((prev) => {
                          return prev.filter((t) => t.label !== tag.label);
                        })
                      }
                    />
                  </span>
                ))}
              </div>
            )}
            <input
              placeholder={t("placeholder.13")}
              value={savedSearchTextWord}
              onChange={(e) => setSavedSearchTextWord(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter" && e.target.value !== "") {
                  setSavedSearchTags((prev) => {
                    return [
                      ...prev,
                      {
                        label: savedSearchTextWord,
                        type: "search",
                      },
                    ];
                  });
                  setSavedSearchTextWord("");
                }
              }}
              className={styles.savedSearchTitle}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default DashboardData;
